<ion-header>
	<app-account-toolbar
		src="/assets/dean_and_david/burger-menu/privacy.svg"
		(back)="goBack()"
		title="menu_popover.privacy"
	></app-account-toolbar>
</ion-header>

<ion-content class="ion-padding">
	<!-- <h1>Datenschutzerklärung</h1>
	<section>
		<h2>Allgemeine Hinweise</h2>
		<p>
			Wir nehmen den Schutz personenbezogener Daten sehr ernst. Wir behandeln
			personenbezogene Daten vertraulich und entsprechend der gesetzlichen
			Datenschutzvorschriften sowie auf Grundlage dieser Datenschutzerklärung. Die
			rechtlichen Grundlagen findest Du insbesondere in der
			Datenschutz-Grundverordnung (DSGVO) sowie ergänzend im
			Bundesdatenschutzgesetz (BDSG).

		</p>
		<p>
			Wenn Du unsere Webseite benutzt, werden je nach Art und Umfang der Nutzung
			verschiedene personenbezogene Daten verarbeitet. Personenbezogene Daten sind
			Informationen, die sich auf eine identifizierte oder identifizierbare
			natürliche Person (im Folgenden „betroffene Person“) beziehen; als
			identifizierbar wird eine natürliche Person angesehen, die direkt oder
			indirekt (z.B. mittels Zuordnung zu einer Online-Kennung) identifiziert
			werden kann. Darunter fallen Informationen wie der Name, die Anschrift, die
			Telefonnummer und das Geburtsdatum.
		</p>
		<p>
			Grundsätzlich bist Du nicht verpflichtet, uns Deine personenbezogenen Daten
			mitzuteilen. Wenn Du dies jedoch nicht tust, werden wir Dir unsere Webseite
			nicht uneingeschränkt zur Verfügung stellen können oder Deine Anfragen an uns
			nicht beantworten können. Personenbezogene Daten, die wir nicht zwingend für
			die oben genannten Verarbeitungszwecke benötigen, sind entsprechend als
			freiwillige Angaben gekennzeichnet.
		</p>
		<p>
			Die vorliegende Datenschutzerklärung informiert Dich gemäß Art. 12 ff. DSGVO
			über den Umgang mit Deinen personenbezogenen Daten bei der Nutzung unserer
			Webseite. Sie erläutert insbesondere, welche Daten wir erheben, wie wir dies
			tun und wofür wir die Daten benötigen.
		</p>
	</section>

	<section>
		<h2>Verantwortlicher</h2>
		<p>
			Verantwortlicher ist die natürliche oder juristische Person, die allein oder
			gemeinsam mit anderen über die Zwecke und Mittel der Verarbeitung von
			personenbezogenen Daten entscheidet (z.B. Name, E-Mail-Adresse etc.).
			Verantwortlicher im Sinne der DSGVO und der geltenden nationalen
			Datenschutzgesetze (insb. BDSG) sowie sonstiger datenschutzrechtlicher
			Bestimmungen ist:
		</p>
		<p>
			dean&amp;david Franchise GmbH<br />
			Lohenstraße 8 | 82166 Gräfelfing<br />
			T: +49 89 26 20 59 410<br />
			E: <a href="mailto:info&#64;deananddavid.com">info&#64;deananddavid.com</a>
		</p>
		<p>(nachfolgend „wir“)</p>
		<p>
			Diese Datenschutzerklärung gilt auch für das Angebot, das durch unsere
			Franchisenehmer bereitgestellt wird. Diese sind jeweils gemeinsam mit uns
			verantwortlich. Nähere Informationen kannst Du der Datenschutzerklärung des
			jeweiligen Stores entnehmen.
		</p>
	</section>

	<section>
		<h2>Datenschutzbeauftragter</h2>
		<p>Wir haben für unser Unternehmen folgenden Datenschutzbeauftragten bestellt:</p>
		<p>
			Luka Jozanovic<br />
			PRIOLAN GmbH | Steinsfeldstraße 46 | 74626 Bretzfeld<br />
			T: +49 0163 2867702<br />
			E: <a href="mailto:datenschutz&#64;deananddavid.com" role="link">datenschutz&#64;deananddavid.com</a>

		</p>
	</section>

	<section>
		<h2>Datenerfassung auf unserer Webseite</h2>
		 <h3>Aufruf und Besuch unserer Webseite (Server-Log-Dateien)</h3>
		<p>
			Für die Umsetzung unserer Bestellseite nutzen wir „Smoothr“, eine Checkout-
			und Bestelllö-sung der
		</p>
		<p>
			Sterlix GmbH<br />
			Rankestr. 8<br />
			10789 Berlin, DEUTSCHLAND.<br />
		</p>
		<p>
			Sterlix GmbH verarbeitet folgende personenbezogene Daten:
		</p>
		<ul>
			<li>
				Kundendaten, z.B. Anrede/Name
			</li>
			<li>
				Kundenadresse
			</li>
			<li>
				Kunden E-Mail
			</li>
			<li>
				Kunden Telefonnummer
			</li>
			<li>
				Bestellhistorie des Kunden
			</li>
			<li>
				Bestellverläufe des Kunden
			</li>
			<li>
				bestellte Artikel
			</li>
		</ul>
		<p>
			Sterlix GmbH verarbeitet für uns personenbezogene Daten für die erfolgreiche
			Erfüllung von Lieferungen und Abholungen, damit Du Deine Bestellung bei uns
			reibungslos tätigen kannst. Hierzu gehört beispielsweise die Verwaltung der
			Registrierung und der Versand von E-Mails. Hierfür benötigt Sterlix
			Informationen, um mit Dir in Kontakt zu treten (Benachrichtigung über
			Zustellung, Zahlung, Kontoaktivitäten, Passwortänderungen etc.). Sterlix
			erhält keine Kartenzahlungsdaten, wenn Du Deine Bestellung online bezahlt.
			Näheres zum Zahlungsabwicklung findest Du unter Ziff. IV.8.
		</p>
		<p>
			Mit Sterlix GmbH haben wir einen Auftragsverarbeitungsvertrag nach Art. 28
			Abs. 3 DSGVO geschlossen. Diese Vereinbarung stellt sicher, dass Deine Daten
			nur zu den Zwecken verarbeitet werden, für die wir die Daten erhoben haben.
			Die Datenschutzhinweise von Sterlix GmbH findest Du unter
			<a href="https://www.smoothr.de/datenschutz" role="link">https://www.smoothr.de/datenschutz</a>.
		</p>

	</section>
	<section>
		<h2>
			Aufruf und Besuch unserer Webseite (Server-Log-Dateien)
		</h2>

		<p>
			Zum Zweck der technischen Bereitstellung der Webseite ist es erforderlich,
			dass wir bestimmte, durch Dein Endgerät automatisch übermittelte
			Informationen verarbeiten. Diese Informationen werden bei jedem Aufruf
			unserer Webseite erfasst und in so genannten Server-Log-Dateien gespeichert.
			Dies sind:
		</p>

		<ul>
			<li>IP-Adresse des anfragenden Endgerätes</li>
			<li>Datum und Uhrzeit des Zugriffs</li>
			<li>Zugriffsstatus</li>
			<li>übertragene Datenmenge in Byte</li>
			<li>Browsertyp, Betriebssystem, Oberfläche, Sprache des Browsers, Version der
				Browsersoftware</li>
			<li>Referrer URL</li>
			<li>Zeitverschiebung zwischen anfragendem Host und Webserver,</li>
			<li>Inhalt zur Anfrage bzw. Angabe der abgerufenen Datei, die an den Nutzer
				übermittelt wurde</li>
		</ul>
		<p>Die erhobenen personenbezogenen Daten werden für maximal 30 Tage
			gespeichert.
		</p>
		<p>
			Soweit Du unsere Webseite nutzt, um dich über unser Produkt- und
			Leistungsangebot zu informieren oder dieses zu nutzen, ist Rechtsgrundlage
			für die vorübergehende Speicherung und Verarbeitung der Zugriffsdaten Art. 6
			Abs. 1 S. 1 lit. b DSGVO, der die Verarbeitung von Daten zur Erfüllung eines
			Vertrags oder zur Durchführung vorvertraglicher Maßnahmen gestattet. Darüber
			hinaus dient Art. 6 Abs. 1 S. 1 lit. f DSGVO als Rechtsgrundlage. Unser
			berechtigtes Interesse besteht hierbei darin, Dir eine technisch
			funktionierende und benutzerfreundlich gestaltete Webseite zur Verfügung
			stellen zu können sowie die Sicherheit unserer Systeme zu gewährleisten.
		</p>
		<p>
			Beim Aufruf unserer Webseite fragen wir Dich über Deinen Browser temporär
			nach Deinem Standort. Diesen kannst Du uns freiwillig mitteilen. Die
			Datenverarbeitung erfolgt auf Grundlage Deiner Einwilligung (Art. 6 Abs. 1
			lit. a DSGVO).
		</p>
		<p>
			Wir arbeiten hierfür mit einem externen Dienstleister zusammen. Wir speichern
			unsere Hosting-Daten in einer Datenbank beim verantwortlichen Dienstleiter
		</p>
		<p>
			MongoDB Inc.<br />
			3 Shelbourne Building<br />
			Crampton Avenue Ballsbridge<br />
			Dublin 4, IRLAND.
		</p>
		<p>
			Mit MongoDB Inc.(im Folgenden: MongoDB) wurde einen
			Auftragsverarbeitungsvertrag nach Art. 28 DSGVO geschlossen. Weitere
			Informationen findest Du in den Datenschutzhinweisen von MongoDB unter
			<a target="_blank"
				href="https://www.mongodb.com/legal/privacy-policy?tid=132613636" role="link">https://www.mongodb.com/legal/privacy-policy?tid=132613636</a>.
		</p>
		<p>
			Die in der Datenbank von MongoDB gespeicherten Daten werden auf Servern
			gespeichert. Zum Hosting unserer Datenbank nutzen wir Google Cloud. Hierfür
			nutzen wir die Dienste von
		</p>
		<p>
			Google Ireland Limited<br />
			Gordon House, Barrow Street<br />
			Dublin 4, IRLAND.
		</p>
		<p>
			Die Auftragsverarbeitungsbedingungen von Google Ireland Limited (im
			Folgenden: Google) kannst Du unter
			<a target="_blank"
				href="https://business.safety.google/intl/de/adsprocessorterms/" role="link">https://business.safety.google/intl/de/adsprocessorterms/</a>
			einsehen. Weitere Informationen findest Du in den Datenschutzbestimmungen von
			Google
			<a target="_blank" href="https://business.safety.google/privacy/?hl=en" role="link">https://business.safety.google/privacy/?hl=en</a>.
		</p>
	</section>

	<section>
		<h3>Cookies</h3>
		<h4>Allgemeines</h4>
		<p>
			Wir setzen auf unserer Webseite so genannte „Cookies“ ein. Cookies richten
			auf Deinem Rechner keinen Schaden an und enthalten keine Viren. Cookies
			dienen dazu, unser Angebot benutzerfreundlicher, effektiver und sicherer zu
			machen sowie die Bereitstellung bestimmter Funktionen zu ermöglichen. Cookies
			sind kleine Textdateien, die auf Deinem Rechner oder mobilen Gerät abgelegt
			werden und die Dein Browser speichert. Ein Cookie enthält eine
			charakteristische Zeichenfolge, die eine eindeutige Identifizierung Deines
			Browsers beim erneuten Aufrufen der Webseite ermöglicht.
		</p>
		<p>Wir setzen folgende Cookies ein:
		</p>
		<ul>
			<li>Session Cookies</li>
			<li>Temporäre Cookies (z.B. Cookies zu Analysezwecken, Plugins, etc.)</li>
		</ul>
		<p>
			Cookies werden durch die meisten Browser automatisch akzeptiert. Cookies
			können einzeln oder vollständig im jeweiligen Browser gelöscht werden. Soweit
			Du Cookies in Deinen Browsereinstellungen vollständig deaktivierst, kann dies
			dazu führen, dass Dir nicht alle Funktionen unserer Webseite zur Nutzung zur
			Verfügung stehen.
		</p>
		<h4>Session Cookies</h4>
		<p>
			Wir nutzen Session Cookies, um festzustellen, dass Du unsere Webseite sowie
			einzelne Seiten besucht hast. Session-Cookies speichern eine Session-ID und
			liefern keinen Hinweis zu Deiner Identifikation. Die Informationen werden
			gelöscht, sobald Du deinen Browser schließt.
		</p>
		<h4>Temporäre Cookies</h4>
		<p>
			Einige der Cookies, die wir auf unserer Webseite verwenden, stammen von
			Dritten, die uns helfen, die Wirkung unserer Webseiteninhalte und Interessen
			unserer Besucher zu analysieren, die Leistung und Performance unserer
			Webseite zu messen oder bedarfsgerechte Werbung und anderen Content auf
			unsere oder andere Webseiten zu setzen.
		</p>
		<p>
			Die Cookie-basierte Datenverarbeitung erfolgt vorrangig auf Basis Deiner
			erteilten Einwilligung gemäß § 25 Abs. 1 TDDDG, Art. 6 Abs. 1 S. 1 lit. a
			DSGVO. Darüber hinaus dienen Art. 6 Abs. 1 S. 1 lit. c DSGVO und Art. 6 Abs.
			1 S. 1 lit. f DSGVO als Rechtsgrundlage. Unser berechtigtes Interesse besteht
			hierbei darin, Dir eine technisch funktionierende und benutzerfreundlich
			gestaltete Webseite zur Verfügung stellen zu können sowie die Sicherheit
			unserer Systeme zu gewährleisten.
		</p>
		<p>
			Du kannst die Cookies unter folgendem Link die Cookies einsehen und die
			Cookie-Einstellungen jederzeit ändern über <a target="_blank"
				href="https://order.deananddavid.com/cookie" role="link">https://order.deananddavid.com/cookie</a>
		</p>
	</section>

	<section>
		<h3>Kontaktaufnahme und Bestellungen</h3>
		<p>
			Soweit Du mit uns im Rahmen einer bestehenden Vertragsbeziehung Kontakt
			aufnimmst oder uns im Vorfeld zur Information über unser Leistungsangebot
			oder unsere sonstigen Services kontaktierst, werden die von Dir mitgeteilten
			Daten und Informationen zum Zwecke der Bearbeitung und Beantwortung Deiner
			Kontaktanfrage gemäß Art. 6 Abs. 1 S. 1 lit. b DSGVO (Vertragserfüllung)
			verarbeitet. Wenn Du dich bei uns registrierst, um bei uns zu bestellen oder
			als Gast bestellst, erfolgt die Datenverarbeitung zur
			Vorbereitung/Bereitstellung/Lieferung deiner Bestellung und auf Grundlage von
			Art. 6 Abs. 1 S. 1 lit. b DSGVO (Vertragserfüllung). Ansonsten erfolgt die
			Datenverarbeitung zur Wahrung unserer berechtigten Interessen gemäß Art. 6
			Abs. 1 S. 1 lit. f DSGVO zur sachgerechten Beantwortung von Kunden- und
			Kontaktanfragen. Soweit Du uns Deine Einwilligung (Art. 6 Abs. 1 lit. a
			DSGVO) erteilt hast, erfolgt die Datenverarbeitung auf dieser
			Rechtsgrundlage.
		</p>
		<h4>Anfragen per E-Mail, Telefon und Fax
		</h4>
		<p>
			Wenn Du mit uns per E-Mail, Telefon oder Fax Anfragen zukommen lässt, wird
			Deine Nachricht inklusive der von Dir mitgeteilten personenbezogenen Daten
			(Name, E-Mail-Adresse, Telefonnummer, Faxnummer u. ä.) zwecks Bearbeitung und
			Beantwortung der Anfrage sowie für den Fall von Anschlussfragen bei uns
			gespeichert und entsprechend weiterverarbeitet. Diese Daten geben wir nicht
			an Dritte weiter, es sei denn, dies ist im Rahmen der Bearbeitung und
			Beantwortung Deiner Kontaktanfrage erforderlich (z.B. an einen
			dean&david-Store) oder Du hast uns Deine Einwilligung erteilt.
		</p>
		<h4>Registrierung
		</h4>
		<p>
			Du kannst auf unserer Webseite als Gast bestellen. Du kannst dich auch für
			eine Registrierung bei uns entscheiden. Du kannst dann beim Bestellvorgang
			Gutschein-/Promocodes und Coupons nutzen und deinen Bestellverlauf einsehen.
			Zudem können Deine Daten automatisch beim Bestellvorgang ausgefüllt werden.
		</p>
		<h4>Registrierung bei uns</h4>
		<p>Eine Registrierung ist direkt bei uns möglich. Hierfür benötigen wir
			folgende personenbezogene Daten von Dir::</p>
		<ul>
			<li>Vor- und Nachname
			</li>
			<li>E-Mail</li>
			<li>Telefonnummer (optional)</li>
			<li>
				Geburtsdatum (optional)
			</li>
		</ul>
		<p>Die Verarbeitung der personenbezogenen Daten erfolgt auf Grundlage Deiner
			Einwilligung (Art. 6 Abs. 1 lit. a DSGVO).</p>
		<p>
			Um Deine Registrierung bei uns richtig zu verarbeiten, arbeiten wir mit
			Sterlix GmbH zusammen (s.o.).
		</p>
		<h4>„Mit Apple anmelden“</h4>
		<p>
			Statt dich bei uns zu registrieren, kannst Du dich mit Deinem Apple-Account
			auf unserer Webseite anmelden („mit Apple anmelden“). Hierfür werden Cookies
			(Ziff. IV.2.) in Deinem Endgerät gespeichert. Datenschutzrechtlich
			verantwortlicher Anbieter für diesen Dienst ist
		</p>
		<p>
			Apple Distribution International Limited
			<br />
			Hollyhill Industrial Estate,
			<br />
			Hollyhill, Cork, T23 YK84, IRLAND.
		</p>
		<p>
			Wenn Du dich für eine Anmeldung mit Apple entscheidest und auf den Button
			„mit Apple anmelden“ klickst, wirst Du auf das Anmeldefeld von Apple
			weitergeleitet. Du kannst dich dann mit Deinem Apple-Account bei dean & david
			anmelden, statt eine eigene Registrierung vorzunehmen. Hierfür werden Cookies
			in Deinem Browser gespeichert. Nähere Informationen zur Anmeldung mit Apple
			findest Du unter <a href="https://support.apple.com/de-de/102609" role="link">https://support.apple.com/de-de/102609</a>.
		</p>
		<p>Wir erhalten Zugriff auf folgende personenbezogene Daten von Dir:
		</p>
		<ul>
			<li>Name</li>
			<li>E-Mail-Adresse</li>
		</ul>
		<p>
			Diese Daten werden zur Einrichtung, Bereitstellung und Personalisierung
			Deines Accounts genutzt. Weitere Informationen findest Du in der
			Datenschutzerklärung von Apple unter
			<a href="https://www.apple.com/de/legal/privacy/data/de/apple-pay/" role="link">https://www.apple.com/de/legal/privacy/data/de/apple-pay/</a>.
		</p>
		<p>Die Verarbeitung der personenbezogenen Daten erfolgt auf Grundlage Deiner
			Einwilligung (Art. 6 Abs. 1 lit. a DSGVO).</p>
		<h4>Registrierung mit Facebook</h4>
		<p>
			Statt einer direkten Registrierung auf unserer Bestellseite kannst Du dich
			mit „Facebook“ registrieren. Hierfür werden Cookies (Ziff. IV.2.) in Deinem
			Endgerät gespeichert. Datenschutzrechtlich verantwortlich für diesen Dienst
			ist
		</p>
		<p>
			Meta Platforms Ireland Limited
			<br />
			4 Grand Canal Square<br />
			Dublin 2, IRLAND.

		</p>
		<p>
			Wenn Du Dich für die Registrierung mit Facebook Connect entscheidest und auf
			den „Login with Facebook“- / „Connect with Facebook“-Button klickst, wirst Du
			automatisch auf die Plattform von Facebook weitergeleitet. Dort kannst Du
			Dich mit Deinen Nutzungsdaten anmelden. Dadurch wird Dein Facebook-Profil mit
			unserer Webseite bzw. unseren Diensten verknüpft. Durch diese Verknüpfung
			erhalten wir Zugriff auf Deine bei Facebook hinterlegten Daten. Dies sind vor
			allem:
		</p>
		<ul>
			<li>Facebook-Name</li>
			<li>Facebook-Profil- und Titelbild</li>
			<li>Facebook-Titelbild</li>
			<li>bei Facebook hinterlegte E-Mail-Adresse</li>
			<li>Facebook-ID</li>
			<li>Facebook-Freundeslisten</li>
			<li>Facebook Likes („Gefällt-mir“-Angaben)</li>
			<li>Geburtstag</li>
			<li>Geschlecht</li>
			<li>Land</li>
			<li>Sprache</li>
		</ul>

		<p>
			Diese Daten werden zur Einrichtung, Bereitstellung und Personalisierung
			Deines Accounts genutzt. Weitere Informationen findest Du in der
			Meta-Datenschutzrichtlinie unter
			<a href="https://www.facebook.com/privacy/policy/" role="link">https://www.facebook.com/privacy/policy/</a>.
		</p>
		<p>Die Verarbeitung der personenbezogenen Daten erfolgt auf Grundlage Deiner
			Einwilligung (Art. 6 Abs. 1 lit. a DSGVO)..</p>
		<h4>Anmeldung über Google</h4>
		<p>
			Statt einer direkten Registrierung auf unserer Bestellseite kannst Du dich
			mit Deinem Google Account registrieren. Hierfür werden Cookies (Ziff. IV.2.)
			in Deinem Endgerät gespeichert. Datenschutzrechtlich verantwortlich für
			diesen Dienst ist
		</p>
		<p>
			Google Ireland Limited<br />
			Gordon House, Barrow Street
			<br />
			Dublin 4, IRLAND.
		</p>
		<p>
			Wenn Du Dich für eine Anmeldung mit Google entscheidest und auf den „Weiter
			mit Google“-Button klickst, wirst Du auf das Anmeldefeld von Google
			weitergeleitet. Du kannst dann Deinen Google-Account verwenden, um Dich bei
			dean & david anzumelden. Nähere Informationen zur Anmeldung mit Google
			findest du unter
			<a href="https://support.google.com/accounts/answer/12921417?hl=de" role="link">https://support.google.com/accounts/answer/12921417?hl=de</a>.
		</p>
		<p>
			Wenn Du die die Funktion „Weiter mit Google“ verwendest, dich auf unserer
			Webseite anzumelden, erhalten wir Zugriff auf Daten, die mit Deinem
			Google-Konto verknüpft sind. Dies sind vor allem:
		</p>
		<ul>
			<li>Profilbild</li>
			<li>E-Mail-Adresse</li>
			<li>Name</li>
		</ul>
		<p>
			Diese Daten werden zur Einrichtung, Bereitstellung und Personalisierung
			Deines Accounts genutzt. Weitere Informationen findest Du in den
			Datenschutzinformationen von Google unter
			<a href="https://business.safety.google/privacy/?hl=en" role="link">https://business.safety.google/privacy/?hl=en</a>.
		</p>
		<p>Die Verarbeitung der personenbezogenen Daten erfolgt auf Grundlage Deiner
			Einwilligung (Art. 6 Abs. 1 lit. a DSGVO). </p>
		<h4>
			Bestellung
		</h4>
		<p>
			Wenn Du bei uns bestellst, benötigen wir, um Deine Bestellung auszuführen,
			einige personenbezogene Daten:
		</p>
		<ul>
			<li>Vor- und Nachname</li>
			<li>Telefonnummer</li>
			<li>E-Mail-Adresse</li>
			<li>ggf. Lieferadresse</li>
			<li>ggf. sonstige Informationen, die Du uns über das Feld „Anmerkung
				hinzufügen“ mitteilst</li>
		</ul>
		<p>
			Diese Daten geben wir an den von Dir ausgewählten dean-and-david Store
			weiter, damit sie Deine Bestellung ausführen und bereitstellen / ausliefern
			können. Die Verarbeitung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO
			(Vertragserfüllung). Sofern Du uns Gesundheitsdaten mitteilst (bspw.
			Allergien), erfolgt die Datenverarbeitung auf Grundlage von Art. 9 Abs. 2
			lit. e DSGVO, wenn Du diese Daten uns öffentlich gemacht hast. Ansonsten
			erfolgt die Verarbeitung auf Grundlage deiner Einwilligung Art. 9 Abs. 2 lit.
			a DSGVO.
		</p>
	</section>

	<section>
		<h3>Kommunikation mit uns</h3>
		<p>
			Wir versenden über Smoothr (s.o.) E-Mails, um Dich beispielsweise über
			Bestellverläufe und Kontoaktivitäten zu informieren. Zum Versand von E-Mails
			nutzen wir SendGrid, einen E-Mail-Delivery-Dienst. Datenschutzrechtlich
			verantwortlicher Anbieter für diesen Dienst ist
		</p>
		<p>
			Twilio Ireland Limited
			<br />
			3 Dublin Landings, North Wall Quay
			<br />
			Dublin 1, IRLAND.
		</p>
		<p>
			Mit SendGrid können wir E-Mails effektiver versenden und verarbeiten. Wir
			können Dich so schneller über Deine Bestellung informieren oder Dir
			Informationen über Deinen Account zukommen lassen.
		</p>
		<p>Für den Versand der E-Mails verarbeitet Twilio Ireland Limited (im
			Folgenden: Twilio) folgende personenbezogene Daten:</p>
		<ul>
			<li>Vorname</li>
			<li>Name</li>
			<li>Lieferadresse (falls Lieferung)</li>
			<li>Bestelldaten (Artikel, Summe und Coupon-Nummer)</li>
			<li>Zahlungsart</li>
			<li>Öffnungsraten</li>
			<li>Klicks</li>
			<li>Datum und Zeit</li>
			<li>Sendestatus</li>
			<li>Anhänge (Bestellbestätigung)</li>
		</ul>

		<p>
			Die erhobenen personenbezogenen Daten werden für maximal 37 Tage gespeichert.
			Weitere Informationen findest Du in den Datenschutzhinweisen von Twilio unter
			<a href="https://www.twilio.com/en-us/legal/privacy?tid=331732615152" role="link">https://www.twilio.com/en-us/legal/privacy?tid=331732615152</a>.
		</p>
		<p>
			Die Datenverarbeitung zum Zwecke der Bearbeitung Deiner Bestellung erfolgt
			auf Grundlage von Art. 6 Abs. 1 S. 1 lit. b DSGVO (Vertragserfüllung).
			Ansonsten erfolgt die Datenverarbeitung zur Wahrung unserer berechtigten
			Interessen gemäß Art. 6 Abs. 1 S. 1 lit. f DSGVO, da wir ein berechtigtes
			Interesse haben, Dich über Kontoaktivitäten zu informieren.
		</p>
	</section>

	<section>
		<h3>Plugins/Cookies</h3>
		<h4>Cookiebot</h4>
		<p>
			Wir nutzen den Zustimmungsverwaltungsdienst Cookiebot. Durch diesen Dienst
			können wir Deine Einwilligung zur Speicherung bestimmter Cookies einholen und
			diese datenschutzkonform dokumentieren und verwalten. Um die erteilten
			Einwilligungen oder einen etwaigen Widerruf zuzuordnen, speichert Cookiebot
			einen Cookie in Deinem Browser.
		</p>
		<p>Datenschutzrechtlich verantwortlicher Anbieter ist:</p>
		<p>
			Usercentrics A/S<br />
			Havnegade 39<br />
			1058 Kopenhagen, DÄNEMARK.
		</p>
		<p>Usercentrics A/S verarbeitet folgende Daten</p>
		<ul>
			<li>Datum und Uhrzeit des Zugriffs</li>
			<li>Browser-Informationen</li>
			<li>Geräteinformationen</li>
			<li>Geografischer Standort</li>
			<li>Cookie-Präferenzen</li>
			<li>URL der besuchten Seite</li>
		</ul>
		<p>

			Usercentrics A/S speichert Deine Einwilligungsdaten (erteilte Einwilligung
			und Widerruf der Einwilligung) für ein Jahr. Die Daten werden dann
			unverzüglich gelöscht.

		</p>
		<p>
			Weitere Informationen findest Du in der Datenschutzrichtlinie des Anbieters
			unter
			<a href="https://www.cookiebot.com/de/privacy-policy/" role="link">https://www.cookiebot.com/de/privacy-policy/</a>.
		</p>
		<p>
			Rechtsgrundlage für die Nutzung von Cookiebot ist Art. 6 Abs. 1 S. 1 lit. c
			DSGVO, um die gesetzlich vorgeschriebene Einwilligung für den Einsatz
			bestimmter Technologien einzuholen.
		</p>
		<h4>Google Maps</h4>
		<p>Wir nutzen den Online-Kartendienst Google Maps. Datenschutzrechtlich
			verantwortlicher Anbieter für diesen Dienst ist:</p>
		<p>
			Google Ireland Limited<br />
			Gordon House<br />
			4 Barrow St,<br />
			Dublin, D04 E5W5, IRLAND.
		</p>
		<p>
			Google Maps ist ein Dienst zur visuellen Darstellung von Karten und
			geographischen Informationen. Wir können Dir über diesen Dienst von Google
			Ireland Limited (im Folgenden: Google) unsere dean & david–Standorte und den
			nächsten Store anzeigen lassen. Durch die Freigabe oder Angabe Deines
			Standorts können wir Dir die Suche des nächsten Stores erleichtern.
		</p>
		<p>Google verarbeitet folgende personenbezogene Daten:</p>
		<ul>
			<li>Datum und Uhrzeit des Besuchs</li>
			<li>Standort</li>
			<li>IP-Adresse</li>
			<li>URL</li>
			<li>Nutzungsdaten</li>
			<li>Suchbegriffe</li>
			<li>geografischer Standort</li>
		</ul>
		<p>
			Die von Google verarbeiteten Daten werden bis zu zwei Jahre gespeichert.
			Weitere Informationen findest Du in den Datenschutzbestimmungen von Google
			<a href="https://business.safety.google/privacy/?hl=en" role="link">https://business.safety.google/privacy/?hl=en</a>.
			Die Cookie-Richtlinien von Google findest Du unter
			<a href="https://policies.google.com/technologies/cookies?hl=en" role="link">https://policies.google.com/technologies/cookies?hl=en</a>.
		</p>
		<p>
			Wir haben ein berechtigtes Interesse (Art. 6 Abs. 1 lit. f DSGVO) daran,
			Google Maps für eine ansprechende Darstellung unserer dean &
			david-Store-Standorte einzubinden.
		</p>
		<h4>Braze</h4>
		<p>
			Wir nutzen „Braze“, um Dich über Push-Nachrichten, In-App-Messages zu
			informieren. Zudem nutzen wir Braze zum Zwecke des E-Mail-Marketings.

		</p>
		<p>Datenschutzrechtlich verantwortlicher Anbieter für diesen Dienst ist:</p>
		<p>
			Braze, Inc.<br />
			63 Madison Avenue, 13th Floor,<br />
			New York, NY 10016, USA.
		</p>
		<p>Braze, Inc. (im Folgenden: Braze) verarbeitet folgende personenbezogene
			Daten:
		</p>
		<ul>
			<li>Nutzerdaten (z.B. Demografische Details)</li>
			<li>Meta-/Kommunikationsdaten (z.B. Geräte-Informationen, IP-Adresse)</li>
			<li>Interaktionsdaten (z.B. Clicks, Opens)</li>
		</ul>
		<p>
			Die erhobenen personenbezogenen Daten werden für maximal 90 Tage gespeichert.
			Weitere Informationen findest Du in den Datenschutzbestimmungen von Braze
			<a href="https://www.braze.com/company/legal/privacy" role="link">https://www.braze.com/company/legal/privacy</a>.
			Die Cookie-Richtlinien von Braze findest Du unter
			<a href="https://www.braze.com/company/legal/cookies" role="link">https://www.braze.com/company/legal/cookies</a>.
		</p>
		<p>
			Die Verarbeitung der personenbezogenen Daten erfolgt auf Grundlage Deiner
			Einwilligung (Art. 6 Abs. 1 lit. a DSGVO, § 25 Abs. 1 TDDDG).
		</p>
		<h4>Google Cloud CDN</h4>
		<p>
			Wir nutzen das Content Delivery Network (CDN) von Google Cloud. Über ein CDN
			können wir Dir eine schnellere Ladezeit der Webseite zu ermöglichen. Durch
			diesen Dienst können wir Dir als Nutzer unsere Webseite schneller zum Abruf
			bereitstellen.
		</p>
		<p>Datenschutzrechtlich verantwortlicher Anbieter für diesen Dienst ist
		</p>
		<p>
			Google Ireland Limited<br />
			Gordon House, Barrow Street<br />
			Dublin 4, IRLAND.
		</p>
		<p>Google Ireland Limited (im Folgenden: Google) verarbeitet folgende
			personenbezogene Daten:</p>
		<ul>
			<li>Betriebssystem</li>
			<li>Browser</li>
			<li>Referrer-URL</li>
			<li>aufgerufene Webseite</li>
			<li>IP-Adresse</li>
		</ul>
		<p>
			Zur Erhebung der Daten wird ein Cookie in Deinem Browser platziert. Die
			erhobenen personenbezogenen Daten werden für maximal 30
			Tage gespeichert. Weitere Informationen findest Du in den
			Datenschutzbestimmungen von Google
			<a href="https://business.safety.google/privacy/?hl=en" role="link">https://business.safety.google/privacy/?hl=en</a>.
			Die
			Cookie-Richtlinien von Google findest Du unter
			<a href="https://policies.google.com/technologies/cookies?hl=en" role="link">https://policies.google.com/technologies/cookies?hl=en</a>.
		</p>
		<p>
			Die Verarbeitung der personenbezogenen Daten erfolgt auf Grundlage unseres
			berechtigten Interesses (Art. 6 Abs. 1 lit. f DSGVO) an einer möglichst
			fehlerfreien und schnellen Bereitstellung unseres Angebots.
		</p>
	</section> -->

	<!-- 	
	<section>
		<h3>Analyse-Tools und Werbung</h3>
		<p>
			Wir nutzen verschiedene Tools zur technischen Analyse der Webseite, zur
			Nutzeranalyse des Webseitenverhaltens und zum Zwecke der Werbung.
		</p>

		<h4>Google Analytics</h4>
		<h5>Allgemeines</h5>
		<p>Wir nutzen den Webtrackingdienst Google Analytics. Datenschutzrechtlich
			verantwortlicher Anbieter für diesen Dienst ist </p>
		<p>
			Google Ireland Limited<br />
			Gordon House, Barrow Street<br />
			Dublin 4, IRLAND.
		</p>
		<p>
			Durch Google Analytics können wir Dein Nutzerverhalten auf unserer Webseite
			analysieren. In unserem Auftrag wird Google Ireland Limited (im Folgenden:
			Google) diese Informationen benutzen, um Deine Nutzung der Webseite
			auszuwerten, um Reports über die Webseitenaktivitäten zusammenzustellen und
			um weitere mit der Webseitennutzung und der Internetnutzung verbundene
			Dienstleistungen gegenüber uns zu erbringen. Die im Rahmen von Google
			Analytics von Deinem Browser übermittelte IP-Adresse wird nicht mit anderen
			Daten von Google zusammengeführt.
		</p>

		<p>Folgende personenbezogene Daten werden durch Google verarbeitet:</p>
		<ul>
			<li>Klickpfad</li>
			<li>Datum und Uhrzeit des Besuchs</li>
			<li>Geräteinformationen</li>
			<li>Standort-Informationen</li>
			<li>IP-Adresse</li>
			<li>Besuchte Seiten</li>
			<li>Referrer-URL</li>
			<li>Browser-Informationen</li>
			<li>Hostname</li>
			<li>Browser-Sprache</li>
			<li>Browser-Typ</li>
			<li>Bildschirmauflösung</li>
			<li>Gerätebetriebssystem</li>
			<li>Interaktionsdaten</li>
			<li>Nutzerverhalten</li>
			<li>Besuchte URL</li>
			<li>Cookie ID</li>
		</ul>
		<p>
			Google Analytics verwendet „Cookies“ (s.o. Ziffer IV.2), die eine Analyse der
			Benutzung unserer Webseite durch Dich ermöglichen.
			Die gesammelten Informationen werden an einen Server von Google innerhalb der
			EU, aber ggf. auch in den USA übertragen und dort
			gespeichert.
		</p>
		<p>
			Die Höchstgrenze für die Speicherung von Cookies von Google Analytics beträgt
			zwei Jahre. Weitere Informationen erhältst Du in
			den Datenschutzinformationen von Google unter
			<a href="https://business.safety.google/privacy/?hl=en" role="link">https://business.safety.google/privacy/?hl=en</a>.
			Die Cookie-Richtlinie
			von Google kannst Du unter
			<a href="https://policies.google.com/technologies/cookies?hl=en">https://policies.google.com/technologies/cookies?hl=en</a>
			abrufen. Unter <a href="http://tools.google.com/dlpage/gaoptout?hl=de" role="link">http://tools.google.com/dlpage/gaoptout?hl=de</a>
			kannst Du das Browser-Add-On zur Deaktivierung von Google Analytics
			herunterladen und installieren, um die Datenerfassung durch
			Google einzuschränken.
		</p>
		<p>
			Die Verarbeitung der personenbezogenen Daten erfolgt auf Grundlage Deiner
			Einwilligung (Art. 6 Abs. 1 lit. a DSGVO, § 25 Abs. 1
			TDDDG).
		</p>
		<h5>Demografische Merkmale</h5>
		<p>
			Unsere Webseite nutzt die Funktion „demografische Merkmale” von Google
			Analytics. Dadurch können Berichte erstellt werden, die
			Aussagen zu Alter, Geschlecht und Interessen der Seitenbesucher enthalten.
			Diese Daten stammen aus interessenbezogener Werbung
			von Google sowie aus Besucherdaten von Drittanbietern. Diese Daten können
			jedoch keiner bestimmten Person zugeordnet werden.
		</p>
		<h5>IP-Anonymisierung</h5>
		<p>
			Wir haben auf unserer Webseite die Funktion „IP-Anonymisierung“ aktiviert.
			Dadurch wird Deine IP-Adresse von Google innerhalb
			von Mitgliedstaaten der Europäischen Union oder in anderen Vertrags-staaten
			des Abkommens über den Europäischen Wirtschaftsraum
			vor der Übermittlung in die USA gekürzt. Nur in Ausnahmefällen wird die volle
			IP-Adresse an einen Server von Google in den USA
			übertragen und erst dort gekürzt.
		</p>
		<h5>Deaktivierung von Google Analytics</h5>
		<p>
			Du kannst Google Analytics deaktivieren, indem Du bei der Cookie-Auswahl für
			unsere Webseite unter Cookie-Einstellungen „Analyse
			und Werbung“ deaktivierst oder indem Du das unter dem folgenden Link
			verfügbare Browser-Plugin von Google herunterlädst und
			installierst: <a href="https://tools.google.com/dlpage/gaoptout?hl=de" role="link">https://tools.google.com/dlpage/gaoptout?hl=de</a>.
		</p>
		<h4>Google Tag Manager</h4>
		<p>Wir nutzen das Webdesign-Tool „Google Tag Manager“. Datenschutzrechtlich
			verantwortlicher Anbieter für dieses Tool ist:</p>
		<p>
			Google Ireland Limited<br />
			Gordon House, Barrow Street<br />
			Dublin 4, IRLAND.
		</p>
		<p>
			Google Tag Manager ermöglicht uns, sog. Webseiten-Tags über eine gemeinsame
			Oberfläche zu implementieren und zu verwalten. Das
			Tool verwendet eine Cookie-lose Domain und erfasst selbst keine
			personenbezogenen Daten, sondern sorgt für die Auslösung anderer
			Tags, die ihrerseits unter Umständen Daten erfassen. Google Tag Manager
			greift nicht auf diese Daten zu. Wenn Du auf Domain-
			oder Cookie-Ebene die entsprechenden Dienste deaktiviert hast, wirkt dies für
			alle Tags fort, die mit Google Tag Manager
			implementiert werden.
		</p>
		<p>Die Verarbeitung der personenbezogenen Daten erfolgt auf Grundlage Deiner
			Einwilligung (Art. 6 Abs. 1 lit. a DSGVO).</p>
		<h4>Google Firebase</h4>
		<p>Wir nutzen den Dienst „Google Firebase“ des datenschutzrechtlich
			verantwortlichen Anbieters:</p>
		<p>
			Google Ireland Limited<br />
			Gordon House, Barrow Street<br />
			Dublin 4, IRLAND.
		</p>
		<p>
			Google Firebase verwendet Tracking-Technologien. Hierdurch wird eine Analyse
			Deiner Nutzung der Webseite ermöglicht, bspw. durch
			Mitteilung von Crash- und Kommunikationsdaten. Mit Firebase werden
			Informationen über die Benutzung unserer Webseite erfasst.
			Diese werden an Google Ireland Limited (im Folgenden: Google) übertragen und
			von Google gespeichert. Dabei kann es zu
			Übertragungen in Drittländer (z.B. USA) kommen.
		</p>
		<p>Google verarbeitet folgende personenbezogene Daten:</p>
		<ul>
			<li>Meta-/Kommunikationsdaten (z.B. Geräte-Informationen, IP-Adressen)</li>
			<li>Crashdaten (z.B. fehlgeschlagener Code, Installations-ID)</li>
			<li>Remotekonfigurationsdaten (z.B. aktivieren/deaktivieren von Features)</li>
		</ul>
		<p>Die erhobenen personenbezogenen Daten werden für maximal 90 Tage
			gespeichert.</p>
		<p>
			Die Verarbeitung der personenbezogenen Daten erfolgt auf Grundlage Deiner
			Einwilligung (Art. 6 Abs. 1 lit. a DSGVO, § 25 Abs. 1
			TDDDG). Gleichwohl haben wir ein berechtigtes Interesse (Art. 6 Abs. 1 lit. f
			DSGVO) daran, Google Firebase für eine
			detaillierte Fehleranalyse in unserer Webseite einzubinden sowie technische
			Features zu de- und aktivieren.
		</p>
	</section>

	<section>
		<h3>Newsletter</h3>
		<p>
			Wir nutzen den Dienst „Braze“. Braze ist ein Dienst, mit dem u.a. der Versand
			von Newslettern organisiert und analysiert werden
			kann. Datenschutzrechtlich verantwortlicher Anbieter für diesen Dienst ist:
		</p>
		<p>
			Braze, Inc.<br />
			63 Madison Avenue, 13th Floor,<br />
			New York, NY 10016, USA.
		</p>
		<p>Braze, Inc. verarbeitet folgende personenbezogene Daten:</p>
		<ul>
			<li>E-Mail-Adresse</li>
			<li>Interaktionsdaten</li>
			<li>IP-Adresse</li>
			<li>Push-Tokens</li>
			<li>Gerätedaten</li>
			<li>User-ID-Daten</li>
		</ul>
		<p>
			Wenn Du Daten eingibst, um unseren Newsletter zu beziehen (z.B. Deine
			E-Mail-Adresse), werden diese auf den Servern von Braze,
			Inc. in den USA gespeichert. Mit Braze, Inc. haben wir einen
			Auftragsverarbeitungsvertrag gem. Art. 28 DSGVO geschlossen.
			Weitere Informationen findest Du in den Datenschutzhinweisen von Braze unter
			<a href="https://www.braze.com/company/legal/privacy" role="link">https://www.braze.com/company/legal/privacy</a>.
		</p>
		<p>
			Die Verarbeitung Deiner personenbezogenen Daten durch Braze, Inc. erfolgt auf
			Grundlage Deiner Einwilligung (Art. 6 Abs. 1 lit.
			a DSGVO) im Zuge der Anmeldung für unseren Newsletter. Wenn Du keine Analyse
			durch Braze, Inc. willst, musst Du den Newsletter
			abbestellen. Dazu kannst Du den in jedem Newsletter enthaltenen Link
			verwenden.
		</p>
	</section>

	<section>
		<h3>Zahlungsabwicklung</h3>
		<h4>Allgemeines</h4>
		<p>
			Wenn Du mit dem jeweiligen dean & david-Store über unsere Webseite einen
			kostenpflichtigen Vertrag abschließt (z.B. über den
			Erwerb einer Box), benötigen wir gewisse Daten von Dir für die
			Zahlungsabwicklung. Rechtsgrundlage der Datenverarbeitung ist
			insoweit Art. 6 Abs. 1 lit. b DSGVO (Verarbeitung zur Erfüllung eines
			Vertrags). Die Zahlungsabwicklung erfolgt mit dem
			jeweiligen Store-Betreiber. Weitere Hinweise kannst Du der
			Datenschutzerklärung des jeweiligen Store-Betreibers entnehmen.
		</p>
		<p>
			Die Zahlungsabwicklung erfolgt ausschließlich über eine verschlüsselte SSL-
			bzw. TLS-Verbindung. Eine verschlüsselte Verbindung
			erkennst Du daran, dass die Adresszeile des Browsers nicht "http://“, sondern
			"https://" anzeigt und an dem Schloss-Symbol in
			Deiner Browserzeile. Bei verschlüsselter Kommunikation können Deine
			Zahlungsdaten, die Du an uns übermittelst, nicht von Dritten
			mitgelesen werden.
		</p>
		<p>
			Die jeweiligen Store-Betreiber setzen für die Zahlungsabwicklung die
			nachfolgend genannten Dienstleister ein. Du kannst Deine
			Bestellung (soweit angegeben) auch im dean & david-Store bezahlen. Die
			Verarbeitung erfolgt zum Zwecke der Zahlungsabwicklung
			gem. Art. 6 Abs. 1 lit. b DSGVO. Soweit Du uns Deine Einwilligung erteilst,
			erfolgt die Datenverarbeitung auf Grundlage Deiner
			Einwilligung gem. Art. 6 Abs. 1 lit. a DSGVO.
		</p>
		<h4>Worldline und Pay-Jet</h4>
		<p>Die Bezahlmethode „Worldline“ wird abgewickelt von:</p>
		<p>
			Worldline S.A.<br />
			Tour Voltaire<br />
			1 place des degrés<br />
			CS 81162<br />
			92059 Paris La Défense Cedex, FRANKREICH.
		</p>
		<p>
			Worldline S.A. (im Folgenden Wordline) erhält personenbezogene und
			zahlungsrelevante Daten von Dir, die für die Abwicklung der
			Transaktion erforderlich sind. Hierfür wird ein Cookie (Ziff. IV.2). in
			Deinem Browser gespeichert. Diese Informationen werden
			auch an Dein Bankinstitut oder Deine Kreditkartengesellschaft übermittelt.
			Nähere Informationen zu Worldline erhältst Du unter
			<a
				href="https://financial-services.worldline.com/en/home/solutions/digital-services/payment-services.html" role="link">https://financial-services.worldline.com/en/home/solutions/digital-services/payment-services.html</a>.
		</p>
		<p>
			Die Datenschutzhinweise von Worldline S.A. findest Du unter
			<a href="https://worldline.com/de-de/compliancy/privacy" role="link">https://worldline.com/de-de/compliancy/privacy</a>.
			Die
			Sicherheitsanforderungen von Worldline findest Du unter
			<a
				href="https://payment.preprod.direct.worldline-solutions.com/hostedcheckout/SecurityContent/Get/b9c2968e57a848dd9e2b5defdd6636fc" role="link" aria-label="Payment link">https://payment.preprod.direct.worldline-solutions.com/hostedcheckout/SecurityContent/Get/b9c2968e57a848dd9e2b5defdd6636fc</a>.
		</p>
		<p>
			Wir übermitteln bei dem Zahlungsvorgang Deine Zahlungsdaten über eine
			gesicherte https-Verbindung an den Server von Worldline.
			Für den Zahlungsvorgang wirst Du auf eine Webseite von Worldline
			weitergeleitet. Eine Übermittlung der Daten erfolgt
			ausschließlich für die reibungslose Abwicklung Deiner Zahlung. Hierfür werden
			Cookies (Ziff. IV.2.) in Deinem Endgerät
			gespeichert.
		</p>
		<p>Worldline nutzt als Payment-Service-Provider für die Zahlungsabwicklung
			die:</p>
		<p>
			Pay-Jet GmbH<br />
			Rumfordstraße 42<br />
			80469 München, DEUTSCHLAND.
		</p>
		<p>(im Folgenden „Pay-Jet“).</p>
		<p>
			Unsere Franchisenehmer, die dean&amp;david-Stores, haben mit den Pay-Jet GmbH
			einen Auftragsverarbeitungsvertrag nach Art. 28
			DSGVO geschlossen. Die Datenschutzbestimmungen von Pay-Jet findest Du unter
			<a href="https://www.pay-jet.de/privacy-policy" role="link">https://www.pay-jet.de/privacy-policy</a>.
			Die Datenschutzinformationen für
			Karteninhaber findest Du unter <a
				href="https://www.pay-jet.de/data-processing" role="link">https://www.pay-jet.de/data-processing</a>.
		</p>
		<p>Der Payment-Service-Provider Pay-Jet ermöglicht Dir mehrere
			Bezahlmöglichkeiten. Eine Bezahlung kann über:</p>
		<ul>
			<li>American Express</li>
			<li>Diners Club</li>
			<li>MasterCard</li>
			<li>Google Pay</li>
			<li>JCB</li>
			<li>Apple Pay</li>
			<li>Maestro</li>
			<li>Visa</li>
			<li>PayPal</li>
		</ul>
		<p>
			durchgeführt werden. Hierfür leitet Pay-Jet Deine Daten an das
			Kartenzahlungssystem bzw. Deine Kreditkartenorganisation weiter.
			Dieses kann sich gegebenenfalls außerhalb der EU oder des EWR befinden. Dies
			ist zur Autorisierung und Ausführung deiner Zahlung
			erforderlich. Weder wir noch unsere dean & david-Stores sind
			datenschutzrechtlich für die Weitergabe der Daten an die jeweiligen
			Kartenzahlungsdienste verantwortlich, erläutern Dir aber nachfolgend die
			Weitergabe Deiner Daten zur besseren Verständlichkeit.
		</p>
		<h5>American Express</h5>
		<p>Bei Auswahl der Bezahlmethode „American Express“ erfolgt eine Weitergabe
			Deiner Daten an:</p>
		<p>
			American Express Payment Services Ltd.<br />
			Zweigniederlassung Frankfurt am Main,<br />
			Theodor-Heuss-Allee 112,<br />
			60486 Frankfurt am Main, DEUTSCHLAND.
		</p>
		<p>
			Die Datenschutzhinweise zu dieser Zahlungsmethode findest Du unter
			<a href="https://www.americanexpress.de/datenschutz" role="link">www.americanexpress.de/datenschutz</a>.
		</p>
		<h5>Diners Club</h5>
		<p>Bei Auswahl der Bezahlmethode „Diners Club“ erfolgt eine Weitergabe Deiner
			Daten an:</p>
		<p>
			Diners Club International Ltd.<br />
			2500 Lake Cook Road,<br />
			Riverwoods, IL 60016, USA.
		</p>
		<p>
			Die Datenschutzhinweise zu dieser Zahlungsmethode findest Du unter
			<a href="https://www.dinersclub.com/privacy-policy" role="link">https://www.dinersclub.com/privacy-policy</a>.
		</p>
		<h5>Mastercard / Maestro</h5>
		<p>Bei Auswahl der Bezahlmethode „MasterCard“ und „Maestro“ erfolgt eine
			Weitergabe Deiner Daten an:</p>
		<p>
			MasterCard Europe SPRL<br />
			Chaussée de Tervuren 198A,<br />
			1410 Waterloo, BELGIEN.
		</p>
		<p>
			Die Datenschutzhinweise zu dieser Zahlungsmethode findest Du unter
			<a href="https://www.mastercard.de/de-de/datenschutz.html" role="link">https://www.mastercard.de/de-de/datenschutz.html</a>.
		</p>
		<h5>Google Pay</h5>
		<p>Die Auswahl der Bezahlmethode „Google Pay“ erfolgt eine Weitergabe Deiner
			Daten an:</p>
		<p>
			Google Ireland Limited<br />
			Gordon House, Barrow Street<br />
			Dublin 4, IRLAND.
		</p>
		<p>
			Nach der Registrierung einer EC- oder Kreditkarte ermöglicht es Google Pay,
			Bezahlungen direkt mit einem Android-Mobiltelefon
			durchzuführen.
		</p>
		<p>
			Weitere Informationen findest Du in den Datenschutzhinweisen von Google
			unter:
			<a href="https://policies.google.com/privacy" role="link">https://policies.google.com/privacy</a>
			sowie unter
			<a
				href="https://payments.google.com/payments/apis-secure/get_legal_document?ldo=0&ldt=privacynotice&ldl=de" role="link">https://payments.google.com/payments/apis-secure/get_legal_document?ldo=0&ldt=privacynotice&ldl=de</a>.
			Die Nutzungsbedingungen von Google Pay findest Du unter
			<a
				href="https://payments.google.com/payments/apis-secure/get_legal_document?ldo=0&ldt=googlepaytos&ldl=de" role="link">https://payments.google.com/payments/apis-secure/get_legal_document?ldo=0&ldt=googlepaytos&ldl=de</a>.
		</p>
		<h5>JCB</h5>
		<p>Bei Auswahl der Bezahlmethode „JCB“ erfolgt eine Weitergabe Deiner Daten
			an:</p>
		<p>
			JCB International Co., Ltd.,<br />
			5-1-22, Minami Aoyama, Minato-Ku,<br />
			Tokio, JAPAN.
		</p>
		<p>
			Die Datenschutzhinweise zu dieser Zahlungsmethode findest Du unter
			<a href="http://www.jcbeurope.eu/privacy/" role="link">http://www.jcbeurope.eu/privacy/</a>.
		</p>
		<h5>Apple Pay</h5>
		<p>Die Bezahlmethode „Apple Pay“ wird abgewickelt von:</p>
		<p>
			Apple Distribution International Limited<br />
			Hollyhill Industrial Estate,<br />
			Hollyhill, Cork, T23 YK84, IRLAND.
		</p>
		<p>
			Nach der Registrierung einer EC- oder Kreditkarte ermöglicht es Apple Pay,
			Bezahlungen direkt mit einem iPhone iOS, watchOS oder
			macOS betriebenen Endgeräts durchzuführen. Hierfür werden durch Apple zur
			Durchführung der Transaktionen personenbezogene Daten
			(unter anderem Name, Rechnungsadresse, Geräte-ID und Telefonnummer)
			verarbeitet.
		</p>
		<p>
			Weitere Informationen findest Du in der Datenschutzerklärung von Apple unter
			<a href="https://www.apple.com/de/legal/privacy/data/de/apple-pay/">https://www.apple.com/de/legal/privacy/data/de/apple-pay/</a>.
		</p>
		<h5>Visa</h5>
		<p>Bei Auswahl der Bezahlmethode „Visa“ erfolgt eine Weitergabe Deiner Daten
			an:</p>
		<p>
			Visa Europe Services LLC,<br />
			eingetragen in Delaware USA,<br />
			London, 1 Sheldon Square,<br />
			London W2 6TT, UK.
		</p>
		<p>
			Weitere Informationen findest Du in der Datenschutzerklärung unter
			<a href="https://www.visa.co.uk/privacy/" role="link">https://www.visa.co.uk/privacy/</a>.
		</p>
		<h5>PayPal</h5>
		<p>Die Bezahlmethode „PayPal“ wird abgewickelt von:</p>
		<p>
			PayPal (Europe) S.à.r.l. et Cie, S.C.A.<br />
			22-24 Boulevard Royal<br />
			L-2449, LUXEMBURG.
		</p>
		<p>
			Nach der Eröffnung eines E-Wallets auf der Internetseite von PayPal und der
			Verknüpfung mit einem bestehenden Bankkonto
			ermöglicht es PayPal, Bezahlungen über einen Internet-Browser oder mittels
			Mobiltelefon-App durchzuführen. Hierfür werden durch
			PayPal zur Durchführung der Transaktion personenbezogene Daten, in der Regel
			Name, Anschrift, Telefonnummer, E-Mail und
			Kontonummer erhoben. Es werden auch Informationen über die Transaktion
			erhoben. Hierunter der Zahlungsbetrag, die
			Geräteinformation, die technischen Nutzungsdaten und Deine
			Geolokalisationsdaten. Hierfür werden Cookies (Ziff. IV.2.) in Deinem
			Browser gesetzt.
		</p>
		<p>
			Weitere Informationen findest Du in der PayPal-Datenschutzerklärung unter
			<a href="https://www.paypal.com/de/webapps/mpp/ua/privacy-full" role="link">https://www.paypal.com/de/webapps/mpp/ua/privacy-full</a>.
		</p>
		<h5>Google Pay</h5>
		<p>Die Bezahlmethode „Google Pay“ wird abgewickelt von:</p>
		<p>
			Google Ireland Limited<br />
			Gordon House, Barrow Street<br />
			Dublin 4, IRLAND.
		</p>
		<p>
			Nach der Registrierung einer EC- oder Kreditkarte ermöglicht es Google Pay,
			Bezahlungen direkt mit einem Android-Mobiltelefon
			durchzuführen.
		</p>
		<p>
			Weitere Informationen findest Du in den Datenschutzhinweisen von Google
			unter:
			<a href="https://policies.google.com/privacy" role="link">https://policies.google.com/privacy</a>
			sowie unter
			<a href="https://payments.google.com/payments/apis-secure/get_legal_document?ldo=0&ldt=privacynotice&ldl=de" role="link" aria-label="Google Payments Privacy Notice">https://payments.google.com/payments/apis-secure/get_legal_document?ldo=0&ldt=privacynotice&ldl=de</a>.
			Die Nutzungsbedingungen von Google Pay findest Du unter
			<a
 href="https://payments.google.com/payments/apis-secure/get_legal_document?ldo=0&ldt=googlepaytos&ldl=de" role="link">https://payments.google.com/payments/apis-secure/get_legal_document?ldo=0&ldt=googlepaytos&ldl=de</a>.
		</p>
		<h5>Sofortüberweisung</h5>
		<p>Die Bezahlmethode „Sofortüberweisung“ wird abgewickelt von:</p>
		<p>
			Sofort GmbH<br />
			Theresienhöhe 12<br />
			80339 München, DEUTSCHLAND.
		</p>
		<p>
			Mit Hilfe des Verfahrens „Sofortüberweisung“ erhalten wir in Echtzeit eine
			Zahlungsbestätigung von der Sofort GmbH und können
			unverzüglich mit der Erfüllung unserer Verbindlichkeiten beginnen. Für die
			Durchführung der Transaktion erhält die Sofort GmbH
			Zugriff auf Informationen zu Deinem Girokonto (PIN, TAN, Kontodeckung,
			Umsätze und Kreditrahmen des Dispokredits).
		</p>
		<p>
			Nach Angaben der Sofort GmbH werden die personenbezogenen Daten nicht
			gespeichert und auch nicht an Händler weitergeleitet.
			Weitere Informationen findest Du in der Datenschutzerklärung der Sofort GmbH
			unter
			<a
				href="https://cdn.klarna.com/1.0/shared/content/legal/terms/de/bt_payment_data_privacy" role="link">https://cdn.klarna.com/1.0/shared/content/legal/terms/de/bt_payment_data_privacy</a>.
		</p>
		<h5>Zahlung vor Ort</h5>
		<p>
			Sofern Du deine Bestellung im Store bezahlst, gelten die jeweiligen
			datenschutzrechtlichen Bestimmungen des Store-Betreibers vor
			Ort.
		</p>
	</section>

	<section>
		<h3>Drittanbieter</h3>
		<h4>Lieferdienste</h4>
		<p>
			Zur Lieferung Deiner Bestellung über den Auswahlpunkt „Lieferung“ arbeiten
			wir sowohl mit eigenen Kurieren als auch mit
			Lieferdiensten zusammen. Du kannst deine Bestellung auch über die Dienste des
			Anbieters, sofern angegeben, selbst tätigen.
			Rechtsgrundlage der Datenverarbeitung ist insoweit Art. 6 Abs. 1 lit. b DSGVO
			(Verarbeitung zur Erfüllung eines Vertrags).
		</p>
		<p>
			Wir und der jeweilige dean & david-Store bekommen von den unten aufgeführten
			Lieferdiensten folgende personenbezogene Daten
			übermittelt, die weiterverarbeitet werden:
		</p>
		<ul>
			<li>Vorname (nur bei Self-Delivery)</li>
			<li>Name (nur bei Self-Delivery)</li>
			<li>Adresse (nur bei Self-Delivery)</li>
			<li>Bestelldaten (Artikel + Summe)</li>
		</ul>
		<h5>UberDirect</h5>
		<p>
			Wenn du über unsere Webseite bestellst, kann Deine Bestellung (bspw. Deine
			Foodspot-Bestellung) von UberDirect ausgeliefert
			werden. Verantwortlicher Anbieter für diesen Dienst ist:
		</p>
		<p>
			Uber Technologies Inc.<br />
			1455 Market Street, Suite 400<br />
			San Francisco, CA 94103, USA.
		</p>
		<p>
			Zur Auslieferung Deiner Bestellung teilen wir Uber Technologies Inc. (im
			Folgenden: Uber) folgende personenbezogene Daten mit:
		</p>
		<ul>
			<li>Allgemeine Bestelldaten (Artikel, Bestellnummer)</li>
			<li>Zielort der Auslieferung (Firmenadresse/Foodspot-Adresse und -Name)</li>
		</ul>
		<p>
			Weitere Informationen findest Du in den Datenschutzbestimmungen von Uber
			unter
			<a
				href="https://www.uber.com/legal/de/document/?name=privacy-notice&country=germany&lang=de" role="link">https://www.uber.com/legal/de/document/?name=privacy-notice&country=germany&lang=de</a>.
		</p>
		<h5>Uber Eats</h5>
		<p>Du kannst bei einem dean & david-Store über Uber Eats bestellen.
			Verantwortlicher Anbieter für diesen Dienst ist:</p>
		<p>
			Uber Technologies Inc.<br />
			1455 Market Street, Suite 400<br />
			San Francisco, CA 94103, USA.
		</p>
		<p>
			Bestellungen über UberEats kannst Du z.B. über die Webseite
			<a href="https://www.ubereats.com" role="link">https://www.ubereats.com</a> vornehmen.
			Weitere Informationen findest Du in den
			Datenschutzbestimmungen von Uber unter
			<a
				href="https://www.uber.com/legal/de/document/?name=privacy-notice&country=germany&lang=de" role="link">https://www.uber.com/legal/de/document/?name=privacy-notice&country=germany&lang=de</a>.
		</p>
		<h5>Lieferando</h5>
		<p>Du kannst bei einem dean & david-Store über „Lieferando“ bestellen.
			Verantwortlicher Anbieter für diesen Dienst ist:</p>
		<p>
			yd. yourdelivery GmbH<br />
			Cuvrystr. 50, 52, 54 / Schlesische Str. 34,<br />
			10997 Berlin, DEUTSCHLAND.
		</p>
		<p>
			Bestellungen über Lieferando kannst Du z.B. über die Webseite
			<a href="https://www.lieferando.de/" role="link">https://www.lieferando.de/</a>
			vornehmen. Weitere Informationen findest Du in den Datenschutzbestimmungen
			von Lieferando unter
			<a href="https://www.lieferando.de/privacy-policy" role="link">https://www.lieferando.de/privacy-policy</a>.
		</p>
		<h5>Wolt</h5>
		<p>Du kannst bei einem dean & david-Store über Wolt bestellen.
			Verantwortlicher Anbieter für diesen Dienst ist:</p>
		<p>
			Wolt Enterprises Deutschland GmbH<br />
			Stralauer Allee 6,<br />
			10245 Berlin, DEUTSCHLAND.
		</p>
		<p>
			Weitere Informationen findest Du in den Datenschutzbestimmungen von Wolt
			unter
			<a href="https://explore.wolt.com/de/deu/privacy" role="link">https://explore.wolt.com/de/deu/privacy</a>.
		</p>
		<h5>MongoDB (Datenbank)</h5>
		<p>Wir nutzen den Cloud-Dienst MongoDB. Datenschutzrechtlich verantwortlicher
			Anbieter für diesen Dienst ist:</p>
		<p>
			MongoDB Inc.<br />
			3 Shelbourne Building<br />
			Crampton Avenue Ballsbridge<br />
			Dublin 4, IRLAND.
		</p>
		<p>
			Bei MongoDB Inc. (im Folgenden: MongoDB) speichern wir Daten, die im
			Zusammenhang mit von uns angebotenen Diensten stehen.
			Hierzu zählen:
		</p>
		<ul>
			<li>
				Kundeninformationen (u.a. Vorname, Name, E-Mail, Nutzer-ID, Adresse,
				Bestätigungsdatum des Kontos, Erstellungsdatum des
				Kontos, letzte Veränderung des Kontos, Geschlecht, letzter genutzter
				Foodspot, Passwort, letzter Login, Geburtstag,
				Telefonnummer, eigene PromoCodes, SocialMediaID (SociaLogin: Facebook,
				Apple, Google)
			</li>
			<li>
				Bestellinformationen (u.a. bestellte Artikel, Adresse, Bestellsumme,
				Trinkgeld, zusätzliche Notizen in der Bestellung,
				Lieferzeit, Bestellzeit, Zahlungsart, Order-Channel (Web, SOT, Wolt, Uber
				etc.), Venue, genutztes SOT (falls SOT
				Bestellung), Gerät, Bestellnummer, Kassenquittung, Abholzeit, Lieferzeit,
				PromoCode, Arbeitnehmerzuschuss (nur Foodspot),
				Store-Discount (nur Foodspot), Kundendaten (Vorname, Name, E-Mail, Telefon,
				Adresse)
			</li>
			<li>Zahlungsinformationen (Zahlungsart, Bestellsumme, Trinkgeld, IP-Adresse,
				Währung, Beleginformationen (Name + Adresse)</li>
		</ul>
		<p>
			Mit MongoDB Inc. wurde ein Auftragsverarbeitungsvertrag nach Art. 28 DSGVO
			geschlossen. Weitere Informationen findest Du in den
			Datenschutzhinweisen von MongoDB unter
			<a href="https://www.mongodb.com/legal/privacy-policy?tid=132613636" role="link">https://www.mongodb.com/legal/privacy-policy?tid=132613636</a>.
		</p>
		<h5>Google Cloud</h5>
		<p>
			Wir nutzen Google Cloud, einen Cloud-Dienst zur Online-Speicherung von Daten.
			Datenschutzrechtlich verantwortlicher Anbieter für
			diesen Dienst ist:
		</p>
		<p>
			Google Ireland Limited<br />
			Gordon House, Barrow Street<br />
			Dublin 4, IRLAND.
		</p>
		<p>Wir speichern bei Google Cloud Daten, die im Zusammenhang mit von uns
			angebotenen Diensten stehen.</p>
		<p>Hierzu zählen:</p>
		<ul>
			<li>Die bei MongoDB gespeicherten Daten (s.o.)</li>
			<li>Betriebssystem</li>
			<li>Browser</li>
			<li>Referrer-URL</li>
			<li>URL</li>
			<li>IP-Adresse</li>
			<li>Status-Code</li>
			<li>Land</li>
			<li>Protokoll</li>
		</ul>
		<p>
			Mit Google Ireland Limited (im Folgenden: Google) wurde ein
			Auftragsverarbeitungsvertrag gem. Art. 28 DSGVO geschlossen. Die
			Auftragsverarbeitungsbedingungen von Google kannst Du unter
			<a href="https://business.safety.google/intl/de/adsprocessorterms/" role="link">https://business.safety.google/intl/de/adsprocessorterms/</a>
			einsehen.
		</p>
		<p>
			Weitere Informationen findest Du in den Datenschutzbestimmungen von Google
			<a href="https://business.safety.google/privacy/?hl=en">https://business.safety.google/privacy/?hl=en</a>.
		</p>
		<h5>LinaPOS</h5>
		<p>
			Bei unseren dean & david-Stores wird das Kassensystem LinaPOS genutzt.
			Datenschutzrechtlich verantwortlicher Anbieter für diesen
			Dienst ist:
		</p>
		<p>
			Varyon Deutschland GmbH<br />
			Walter-Rathenau-Straße 13<br />
			75203 Königsbach-Stein, DEUTSCHLAND.
		</p>
		<p>Um Deine Bestellung abwickeln zu können, werden folgende personenbezogene
			Daten an das Kassensystem LinaPOS weitergeleitet:</p>
		<ul>
			<li>Artikel</li>
			<li>Summe</li>
			<li>Order-Channel (Web, Self-Order-Terminal, Wolt, Uber etc.)</li>
			<li>Bestellnotizen</li>
			<li>Bestellart</li>
		</ul>
		<p>Mit Varyon Deutschland GmbH wurde ein Auftragsverarbeitungsvertrag nach
			Art. 28 DSGVO geschlossen.</p>
	</section>

	<section>
		<h3>Datenübermittlung in Drittländer</h3>
		<p>
			Wir verarbeiten Deine personenbezogenen Daten gewöhnlich in einem
			Mitgliedsstaat der europäischen Union oder einem anderen
			Vertragsstaat des Abkommens über den europäischen Vertragsraum (Beschluss
			94/1/EG). Sofern Daten an Dienstleister mit Sitz
			außerhalb der EU bzw. des EWR übermittelt werden, liegt für die betreffenden
			Staaten (aktuell: USA), sofern nicht anders
			angegeben, ein Angemessenheitsbeschluss gem. Art. 45 DSGVO vor, der ein den
			Vorgaben der DSGVO entsprechendes Datenschutzniveau
			gewährleistet und eine Datenübermittlung ohne besondere Genehmigung erlaubt.
			Soweit nicht anders angegeben, sind Dienstleister
			mit Sitz in den USA nach dem geltenden EU-US Data Privacy Framework
			zertifiziert.
		</p>
		<p>
			Die weitere Datenverarbeitung durch externe Dienstleister liegt nicht in
			unserem Einflussbereich. Deine Daten können in
			Drittländern verarbeitet werden, die datenschutzrechtlich nicht das gleiche
			Schutzniveau garantieren wie innerhalb der EU.
			Einzelheiten kannst Du den jeweiligen Datenschutzerklärungen des
			Dienstleisters entnehmen, die wir entsprechend verlinkt haben.
		</p>
	</section>

	<section>
		<h3>Dauer der Datenspeicherung</h3>
		<p>
			Wir verarbeiten und speichern Deine personenbezogenen Daten grundsätzlich nur
			für die Dauer, für die der jeweilige Nutzungszweck
			eine entsprechende Speicherung erfordert. Das schließt ggf. auch die
			Zeiträume der Anbahnung eines Vertrages und der Abwicklung
			eines Vertrages mit ein. Hast Du uns für eine bestimmte Datenverarbeitung
			Deine Einwilligung erteilt, speichern wir die
			betreffenden Daten, solange die Einwilligung fortbesteht. Einzelheiten über
			die Dauer der Speicherung Deiner personenbezogenen
			Daten bei Drittanbietern kannst Du der Datenschutzerklärung des
			datenschutzrechtlich verantwortlichen Dienstleisters entnehmen.
			Diese haben wir an entsprechender Stelle verlinkt.
		</p>
		<p>
			Hat sich der Nutzungszweck erledigt oder hast Du deine Einwilligung
			widerrufen, löschen wir Deine personenbezogenen Daten
			unverzüglich, sofern uns nicht gesetzliche Aufbewahrungsfristen zu einer
			längeren Speicherung zwingen.
		</p>
	</section>

	<section>
		<h3>Deine Rechte als betroffene Person</h3>
		<p>
			Als betroffene Person (Art. 4 Nr. 1 DSGVO) stehen Dir hinsichtlich Deiner
			personenbezogenen Daten unter den gesetzlichen
			Voraussetzungen die nachfolgenden Rechte zu:
		</p>
		<h4>Auskunftsrecht</h4>
		<p>
			Du bist jederzeit berechtigt, im Rahmen von Art. 15 DSGVO von uns eine
			Bestätigung darüber zu verlangen, ob wir Dich betreffende
			personenbezogene Daten verarbeiten. Ist dies der Fall, bist Du im Rahmen von
			Art. 15 DSGVO ferner berechtigt, Auskunft über
			diese personenbezogenen Daten sowie bestimmte weitere Informationen (u.a.
			Verarbeitungszwecke, Kategorien personenbezogener
			Daten, Kategorien von Empfängern, geplante Speicherdauer, die Herkunft der
			Daten, den Einsatz einer automatisierten
			Entscheidungsfindung und im Fall des Drittlandtransfers die geeigneten
			Garantien) und eine Kopie Deiner Daten zu erhalten. Es
			gelten die Einschränkungen des § 34 BDSG.
		</p>
		<h4>Recht auf Berichtigung</h4>
		<p>
			Du bist berechtigt, nach Art. 16 DSGVO von uns zu verlangen, dass wir die
			über Dich gespeicherten personenbezogenen Daten
			berichtigen, wenn diese unzutreffend oder fehlerhaft sind.
		</p>
		<h4>Recht auf Löschung</h4>
		<p>
			Du bist berechtigt, unter den Voraussetzungen von Art. 17 DSGVO von uns zu
			verlangen, dass wir Dich betreffende personenbezogene
			Daten unverzüglich löschen. Das Recht auf Löschung besteht u.a. nicht, wenn
			die Verarbeitung der personenbezogenen Daten
			erforderlich ist z.B. zur Erfüllung einer rechtlichen Verpflichtung (z.B.
			gesetzliche Aufbewahrungspflichten) oder zur
			Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen. Darüber
			hinaus gelten die Einschränkungen des § 35 BDSG.
		</p>
		<h4>Recht auf Einschränkung der Verarbeitung</h4>
		<p>
			Du bist berechtigt, unter den Voraussetzungen von Art. 18 DSGVO von uns zu
			verlangen, dass wir die Verarbeitung Deiner
			personenbezogenen Daten einschränken.
		</p>
		<h4>Recht auf Datenübertragbarkeit</h4>
		<p>
			Du bist berechtigt, unter den Voraussetzungen von Art. 20 DSGVO von uns zu
			verlangen, dass wir Dir die Dich betreffenden
			personenbezogenen Daten, die Du uns bereitgestellt hast, in einem
			strukturierten, gängigen und maschinenlesbaren Format
			übergeben.
		</p>
		<h4>Widerrufsrecht für erteilte Einwilligungen</h4>
		<p>
			Eine erteilte Einwilligung in die Verarbeitung personenbezogener Daten kannst
			Du jederzeit uns gegenüber widerrufen. Bitte
			beachte, dass der Widerruf erst für die Zukunft wirkt. Verarbeitungen, die
			vor dem Widerruf erfolgt sind, sind davon nicht
			betroffen.
		</p>
		<p>
			Zur Erklärung des Widerrufs reicht eine formlose Mitteilung z.B. per E-Mail
			an
			<a href="mailto:datenschutz&#64;deananddavid.com" role="link">datenschutz&#64;deananddavid.com</a>.
		</p>
		<h4>Widerspruchsrecht gegen Datenverarbeitung aufgrund berechtigten Interesses</h4>
		<p>
			Du bist berechtigt, unter den Voraussetzungen von Art. 21 DSGVO Widerspruch
			jederzeit gegen die Verarbeitung Deiner Daten, die
			aufgrund von Art. 6 Abs. 1 S. 1 lit. f DSGVO (Datenverarbeitung auf der
			Grundlage einer Interessenabwägung) erfolgt, Widerspruch
			einzulegen, wenn dafür Gründe vorliegen, die sich aus Deiner besonderen
			Situation ergeben.
		</p>
		<p>
			Legst Du Widerspruch ein, werden wir Deine personenbezogenen Daten nicht mehr
			verarbeiten, es sei denn, wir können zwingende
			schutzwürdige Gründe für die Verarbeitung nachweisen, die Deine Interessen,
			Rechte und Freiheiten überwiegen, oder die
			Verarbeitung dient der Geltendmachung, Ausübung oder Verteidigung von
			Rechtsansprüchen.
		</p>
		<p>
			Zur Erhebung des Widerrufs reicht eine formlose Mitteilung z.B. per E-Mail an
			<a href="mailto:datenschutz&#64;deananddavid.com">datenschutz&#64;deananddavid.com</a>.
		</p>
		<h4>Beschwerderecht bei einer Aufsichtsbehörde</h4>
		<p>
			Unter den Voraussetzungen von Art. 77 DSGVO steht Dir ein Beschwerderecht bei
			einer zuständigen Aufsichtsbehörde zu.
			Insbesondere kannst Du sich mit einer Beschwerde an die für uns zuständige
			Aufsichtsbehörde wenden, das Bayerisches Landesamt
			für Datenschutzaufsicht (BayLDA), Tel. +49 (0) 981 180093-0, E-Mail:
			<a href="mailto:poststelle&#64;lda.bayern.de" role="link">poststelle&#64;lda.bayern.de</a>.
		</p>
		<h4>Sonstige Anliegen</h4>
		<p>
			Für weitergehende Datenschutzfragen und -anliegen steht Dir unser
			Datenschutzbeauftragter zur Verfügung. Entsprechende Anfragen
			sowie die Ausübung Deiner vorstehenden Rechte sollten nach Möglichkeit per
			E-Mail an
			<a href="mailto:datenschutz&#64;deananddavid.com">datenschutz&#64;deananddavid.com</a>
			geschickt werden.
		</p>
	</section> -->

	<ol type="A">
		<ol type="I">
			<li>
				<p
					align="justify"
					style="
						line-height: 120%;
						page-break-inside: auto;
						orphans: 0;
						widows: 0;
						margin-top: 0.25in;
						margin-bottom: 0.07in;
						border: none;
						padding: 0in;
						background: transparent;
						page-break-before: auto;
						page-break-after: avoid;
					"
				>
					<span style="font-variant: normal"
						><font color="#000000"
							><span style="text-decoration: none"
								><font face="Arial"
									><font size="2" style="font-size: 11pt"
										><span style="font-style: normal"
											><b><span style="background: transparent">Allgemeine Hinweise</span></b></span
										></font
									></font
								></span
							></font
						></span
					>
				</p>
			</li>
		</ol>
	</ol>
	<p>
		Wir nehmen den Schutz personenbezogener Daten sehr ernst. Wir behandeln personenbezogene Daten vertraulich und entsprechend der
		gesetzlichen Datenschutzvorschriften sowie auf Grundlage dieser Datenschutzerklärung. Die rechtlichen Grundlagen findest Du
		insbesondere in der Datenschutz-Grundverordnung (DSGVO) sowie ergänzend im Bundesdatenschutzgesetz (BDSG).
	</p>
	<p>
		Wenn Du unsere Webseite benutzt, werden je nach Art und Umfang der Nutzung verschiedene personenbezogene Daten verarbeitet.
		Personenbezogene Daten sind Informationen, die sich auf eine identifizierte oder identifizierbare natürliche Person (im Folgenden
		„betroffene Person“) beziehen; als identifizierbar wird eine natürliche Person angesehen, die direkt oder indirekt (z.B. mittels
		Zuordnung zu einer Online-Kennung) identifiziert werden kann. Darunter fallen Informationen wie der Name, die Anschrift, die
		Telefonnummer und das Geburtsdatum.
	</p>
	<p>
		Grundsätzlich bist Du nicht verpflichtet, uns Deine personenbezogenen Daten mitzuteilen. Wenn Du dies jedoch nicht tust, werden wir
		Dir unsere Webseite nicht uneingeschränkt zur Verfügung stellen können oder Deine Anfragen an uns nicht beantworten können.
		Personenbezogene Daten, die wir nicht zwingend für die oben genannten Verarbeitungszwecke benötigen, sind entsprechend als
		freiwillige Angaben gekennzeichnet.
	</p>
	<p>
		Die vorliegende Datenschutzerklärung informiert Dich gemäß Art. 12 ff. DSGVO über den Umgang mit Deinen personenbezogenen Daten bei
		der Nutzung unserer Webseite. Sie erläutert insbesondere, welche Daten wir erheben, wie wir dies tun und wofür wir die Daten
		benötigen.
	</p>
	<ol type="A">
		<ol type="I" start="2">
			<li>
				<p
					align="justify"
					style="
						line-height: 120%;
						page-break-inside: auto;
						orphans: 0;
						widows: 0;
						margin-top: 0.25in;
						margin-bottom: 0.07in;
						border: none;
						padding: 0in;
						background: transparent;
						page-break-before: auto;
						page-break-after: avoid;
					"
				>
					<span style="font-variant: normal"
						><font color="#000000"
							><span style="text-decoration: none"
								><font face="Arial"
									><font size="2" style="font-size: 11pt"
										><span style="font-style: normal"
											><b><span style="background: transparent">Verantwortlicher</span></b></span
										></font
									></font
								></span
							></font
						></span
					>
				</p>
			</li>
		</ol>
	</ol>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Verantwortlicher ist die natürliche oder juristische Person, die allein oder gemeinsam mit anderen
										über die Zwecke und Mittel der Verarbeitung von personenbezogenen Daten entscheidet (z.B. Name,
										E-Mail-Adresse etc.). Verantwortlicher im Sinne der DSGVO und der geltenden nationalen
										Datenschutzgesetze (insb. BDSG) sowie sonstiger datenschutzrechtlicher Bestimmungen ist:</span
									></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><b><span style="background: transparent">dean&amp;david Franchise GmbH</span></b></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent">Lohenstraße 8 | 82166 Gräfelfing</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent">T: +49 89 26 20 59 410</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"><span style="background: transparent">E: </span></span></span
							></font
						></font
					></span
				></font
			></span
		><a href="mailto:info&#64;deananddavid.com" role="link"
			><span style="font-variant: normal"
				><font color="#0000ff"
					><span style="text-decoration: none"
						><font face="Arial"
							><font size="2" style="font-size: 11pt"
								><span style="font-style: normal"
									><u
										><span style="font-weight: normal"
											><span style="background: transparent">info&#64;deananddavid.com</span></span
										></u
									></span
								></font
							></font
						></span
					></font
				></span
			></a
		>
	</p>
	<p>(nachfolgend „wir“)</p>
	<p>
		Diese Datenschutzerklärung gilt auch für das Angebot, das durch unsere Franchisenehmer bereitgestellt wird. Diese sind jeweils
		gemeinsam mit uns verantwortlich. Nähere Informationen kannst Du der Datenschutzerklärung des jeweiligen Stores entnehmen.
	</p>
	<ol type="A">
		<ol type="I" start="3">
			<li>
				<p
					align="justify"
					style="
						line-height: 120%;
						page-break-inside: auto;
						orphans: 0;
						widows: 0;
						margin-top: 0.25in;
						margin-bottom: 0.07in;
						border: none;
						padding: 0in;
						background: transparent;
						page-break-before: auto;
						page-break-after: avoid;
					"
				>
					<span style="font-variant: normal"
						><font color="#000000"
							><span style="text-decoration: none"
								><font face="Arial"
									><font size="2" style="font-size: 11pt"
										><span style="font-style: normal"
											><b><span style="background: transparent">Datenschutzbeauftragter</span></b></span
										></font
									></font
								></span
							></font
						></span
					>
				</p>
			</li>
		</ol>
	</ol>
	<p>Wir haben für unser Unternehmen folgenden Datenschutzbeauftragten bestellt:</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><b><span style="background: transparent">Luka Jozanovic</span></b></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent">PRIOLAN GmbH | Steinsfeldstraße 46 | 74626 Bretzfeld</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent">T: +49 0163 2867702</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent">E: datenschutz&#64;deananddavid.com</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<ol type="A">
		<ol type="I" start="4">
			<li>
				<p
					align="justify"
					style="
						line-height: 120%;
						page-break-inside: auto;
						orphans: 0;
						widows: 0;
						margin-top: 0.25in;
						margin-bottom: 0.07in;
						border: none;
						padding: 0in;
						background: transparent;
						page-break-before: auto;
						page-break-after: avoid;
					"
				>
					<span style="font-variant: normal"
						><font color="#000000"
							><span style="text-decoration: none"
								><font face="Arial"
									><font size="2" style="font-size: 11pt"
										><span style="font-style: normal"
											><b><span style="background: transparent">Datenerfassung auf unserer Webseite</span></b></span
										></font
									></font
								></span
							></font
						></span
					>
				</p>
			</li>
		</ol>
	</ol>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Für die Umsetzung unserer Bestellseite nutzen wir „Smoothr“, eine Checkout- und Bestelllö-sung der
									</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			font-variant: normal;
			font-style: normal;
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			text-decoration: none;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<br />
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><b><span style="background: transparent">Sterlix GmbH</span></b></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"><span style="background: transparent">Rankestr. 8 </span></span></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent">10789 Berlin, DEUTSCHLAND.</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			font-variant: normal;
			font-style: normal;
			font-weight: normal;
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			text-decoration: none;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<br />
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Sterlix GmbH verarbeitet folgende personenbezogene Daten:</span
									></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			font-variant: normal;
			font-style: normal;
			font-weight: normal;
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			text-decoration: none;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<br />
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><span style="background: transparent"
						>●<font face="Arial"
							><font size="2" style="font-size: 11pt"
								><span style="font-style: normal"
									><span style="font-weight: normal"> Kundendaten, z.B. Anrede/Name</span></span
								></font
							></font
						></span
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><span style="background: transparent"
						>●<font face="Arial"
							><font size="2" style="font-size: 11pt"
								><span style="font-style: normal"><span style="font-weight: normal"> Kundenadresse</span></span></font
							></font
						></span
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><span style="background: transparent"
						>●<font face="Arial"
							><font size="2" style="font-size: 11pt"
								><span style="font-style: normal"><span style="font-weight: normal"> Kunden E-Mail</span></span></font
							></font
						></span
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><span style="background: transparent"
						>●<font face="Arial"
							><font size="2" style="font-size: 11pt"
								><span style="font-style: normal"
									><span style="font-weight: normal"> Kunden Telefonnummer</span></span
								></font
							></font
						></span
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><span style="background: transparent"
						>●<font face="Arial"
							><font size="2" style="font-size: 11pt"
								><span style="font-style: normal"
									><span style="font-weight: normal"> Bestellhistorie des Kunden</span></span
								></font
							></font
						></span
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><span style="background: transparent"
						>●<font face="Arial"
							><font size="2" style="font-size: 11pt"
								><span style="font-style: normal"
									><span style="font-weight: normal"> Bestellverläufe des Kunden</span></span
								></font
							></font
						></span
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><span style="background: transparent"
						>●<font face="Arial"
							><font size="2" style="font-size: 11pt"
								><span style="font-style: normal"><span style="font-weight: normal"> bestellte Artikel</span></span></font
							></font
						></span
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			font-variant: normal;
			font-style: normal;
			font-weight: normal;
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			text-decoration: none;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<br />
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Sterlix GmbH verarbeitet für uns personenbezogene Daten für die erfolgreiche Erfüllung von
										Lieferungen und Abholungen, damit Du Deine Bestellung bei uns reibungslos tätigen kannst. Hierzu
										gehört beispielsweise die Verwaltung der Registrierung und der Versand von E-Mails. Hierfür benötigt
										Sterlix Informationen, um mit Dir in Kontakt zu treten (Benachrichtigung über Zustellung, Zahlung,
										Kontoaktivitäten, Passwortänderungen etc.). Sterlix erhält keine Kartenzahlungsdaten, wenn Du Deine
										Bestellung online bezahlt. Näheres zum Zahlungsabwicklung findest Du unter Ziff. IV.8.</span
									></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			font-variant: normal;
			font-style: normal;
			font-weight: normal;
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			text-decoration: none;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<br />
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Mit Sterlix GmbH haben wir einen Auftragsverarbeitungsvertrag nach Art. 28 Abs. 3 DSGVO
										geschlossen. Diese Vereinbarung stellt sicher, dass Deine Daten nur zu den Zwecken verarbeitet
										werden, für die wir die Daten erhoben haben. Die Datenschutzhinweise von Sterlix GmbH findest Du
										unter
									</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		><a href="https://www.smoothr.de/datenschutz" role="link"
			><span style="font-variant: normal"
				><font color="#0000ff"
					><span style="text-decoration: none"
						><font face="Arial"
							><font size="2" style="font-size: 11pt"
								><span style="font-style: normal"
									><u
										><span style="font-weight: normal"
											><span style="background: transparent">https://www.smoothr.de/datenschutz</span></span
										></u
									></span
								></font
							></font
						></span
					></font
				></span
			></a
		><span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"><span style="background: transparent">. </span></span></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<ol type="A">
		<ol type="I">
			<ol>
				<li>
					<p
						align="justify"
						style="
							line-height: 120%;
							page-break-inside: auto;
							orphans: 0;
							widows: 0;
							margin-top: 0.24in;
							margin-bottom: 0.04in;
							border: none;
							padding: 0in;
							background: transparent;
							page-break-before: auto;
							page-break-after: avoid;
						"
					>
						<span style="font-variant: normal"
							><font color="#000000"
								><span style="text-decoration: none"
									><font face="Arial"
										><font size="2" style="font-size: 11pt"
											><span style="font-style: normal"
												><b
													><span style="background: transparent"
														>Aufruf und Besuch unserer Webseite (Server-Log-Dateien)</span
													></b
												></span
											></font
										></font
									></span
								></font
							></span
						>
					</p>
				</li>
			</ol>
		</ol>
	</ol>
	<p>
		Zum Zweck der technischen Bereitstellung der Webseite ist es erforderlich, dass wir bestimmte, durch Dein Endgerät automatisch
		übermittelte Informationen verarbeiten. Diese Informationen werden bei jedem Aufruf unserer Webseite erfasst und in so genannten
		Server-Log-Dateien gespeichert. Dies sind:
	</p>
	<ul>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent">IP-Adresse des anfragenden Endgerätes</span></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent">Datum und Uhrzeit des Zugriffs</span></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent">Zugriffsstatus</span></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent">übertragene Datenmenge in Byte</span></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent"
												>Browsertyp, Betriebssystem, Oberfläche, Sprache des Browsers, Version der
												Browsersoftware</span
											></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent">Referrer URL</span></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent"
												>Zeitverschiebung zwischen anfragendem Host und Webserver,</span
											></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent"
												>Inhalt zur Anfrage bzw. Angabe der abgerufenen Datei, die an den Nutzer übermittelt
												wurde</span
											></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
	</ul>
	<p>Die erhobenen personenbezogenen Daten werden für maximal 30 Tage gespeichert.</p>
	<p>
		Soweit Du unsere Webseite nutzt, um dich über unser Produkt- und Leistungsangebot zu informieren oder dieses zu nutzen, ist
		Rechtsgrundlage für die vorübergehende Speicherung und Verarbeitung der Zugriffsdaten Art. 6 Abs. 1 S. 1 lit. b DSGVO, der die
		Verarbeitung von Daten zur Erfüllung eines Vertrags oder zur Durchführung vorvertraglicher Maßnahmen gestattet. Darüber hinaus dient
		Art. 6 Abs. 1 S. 1 lit. f DSGVO als Rechtsgrundlage. Unser berechtigtes Interesse besteht hierbei darin, Dir eine technisch
		funktionierende und benutzerfreundlich gestaltete Webseite zur Verfügung stellen zu können sowie die Sicherheit unserer Systeme zu
		gewährleisten.
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Beim Aufruf unserer Webseite fragen wir Dich über Deinen Browser temporär nach Deinem Standort.
										Diesen kannst Du uns freiwillig mitteilen. Die Datenverarbeitung erfolgt auf Grundlage Deiner
										Einwilligung (Art. 6 Abs. 1 lit. a DSGVO).
									</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Wir arbeiten hierfür mit einem externen Dienstleister zusammen. Wir speichern unsere Hosting-Daten
										in einer Datenbank beim verantwortlichen Dienstleiter</span
									></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><b><span style="background: transparent">MongoDB Inc</span></b></span
							></font
						></font
					></span
				></font
			></span
		><span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"><span style="background: transparent">.</span></span></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent">3 Shelbourne Building</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent">Crampton Avenue Ballsbridge</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent">Dublin 4, IRLAND.</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			font-variant: normal;
			font-style: normal;
			font-weight: normal;
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			text-decoration: none;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<br />
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Mit MongoDB Inc.(im Folgenden: MongoDB) wurde einen Auftragsverarbeitungsvertrag nach Art. 28 DSGVO
										geschlossen. Weitere Informationen findest Du in den Datenschutzhinweisen von MongoDB unter
									</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		><a href="https://www.mongodb.com/legal/privacy-policy?tid=132613636" role="link"
			><span style="font-variant: normal"
				><font color="#0000ff"
					><span style="text-decoration: none"
						><font face="Arial"
							><font size="2" style="font-size: 11pt"
								><span style="font-style: normal"
									><u
										><span style="font-weight: normal"
											><span style="background: transparent"
												>https://www.mongodb.com/legal/privacy-policy?tid=132613636</span
											></span
										></u
									></span
								></font
							></font
						></span
					></font
				></span
			></a
		><span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"><span style="background: transparent">.</span></span></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p>
		Die in der Datenbank von MongoDB gespeicherten Daten werden auf Servern gespeichert. Zum Hosting unserer Datenbank nutzen wir Google
		Cloud. Hierfür nutzen wir die Dienste von
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><b><span style="background: transparent">Google Ireland Limited</span></b></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent">Gordon House, Barrow Street</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent">Dublin 4, IRLAND.</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Die Auftragsverarbeitungsbedingungen von Google Ireland Limited (im Folgenden: Google) kannst Du
										unter
									</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		><a href="https://business.safety.google/intl/de/adsprocessorterms/"
			><span style="font-variant: normal"
				><font color="#0000ff"
					><span style="text-decoration: none"
						><font face="Arial"
							><font size="2" style="font-size: 11pt"
								><span style="font-style: normal"
									><u
										><span style="font-weight: normal"
											><span style="background: transparent"
												>https://business.safety.google/intl/de/adsprocessorterms/</span
											></span
										></u
									></span
								></font
							></font
						></span
					></font
				></span
			></a
		><span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent">
										einsehen. Weitere Informationen findest Du in den Datenschutzbestimmungen von Google
									</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		><a href="https://business.safety.google/privacy/?hl=en" role="link"
			><span style="font-variant: normal"
				><font color="#0000ff"
					><span style="text-decoration: none"
						><font face="Arial"
							><font size="2" style="font-size: 11pt"
								><span style="font-style: normal"
									><u
										><span style="font-weight: normal"
											><span style="background: transparent"
												>https://business.safety.google/privacy/?hl=en</span
											></span
										></u
									></span
								></font
							></font
						></span
					></font
				></span
			></a
		><span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"><span style="background: transparent">.</span></span></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<ol type="A">
		<ol type="I">
			<ol start="2">
				<li>
					<p
						align="justify"
						style="
							line-height: 120%;
							page-break-inside: auto;
							orphans: 0;
							widows: 0;
							margin-top: 0.24in;
							margin-bottom: 0.04in;
							border: none;
							padding: 0in;
							background: transparent;
							page-break-before: auto;
							page-break-after: avoid;
						"
					>
						<span style="font-variant: normal"
							><font color="#000000"
								><span style="text-decoration: none"
									><font face="Arial"
										><font size="2" style="font-size: 11pt"
											><span style="font-style: normal"
												><b><span style="background: transparent">Cookies</span></b></span
											></font
										></font
									></span
								></font
							></span
						>
					</p>
					<ol type="a">
						<li>
							<p
								align="justify"
								style="
									line-height: 120%;
									page-break-inside: auto;
									orphans: 0;
									widows: 0;
									margin-top: 0.24in;
									margin-bottom: 0.04in;
									border: none;
									padding: 0in;
									background: transparent;
									page-break-before: auto;
									page-break-after: avoid;
								"
							>
								<span style="font-variant: normal"
									><font color="#000000"
										><span style="text-decoration: none"
											><font face="Arial"
												><font size="2" style="font-size: 11pt"
													><span style="font-style: normal"
														><b><span style="background: transparent">Allgemeines</span></b></span
													></font
												></font
											></span
										></font
									></span
								>
							</p>
						</li>
					</ol>
				</li>
			</ol>
		</ol>
	</ol>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Wir setzen auf unserer Webseite so genannte „Cookies“ ein. Cookies richten auf Deinem Rechner
										keinen Schaden an und enthalten keine Viren. Cookies dienen dazu, unser Angebot
										benutzerfreundlicher, effektiver und sicherer zu machen sowie die Bereitstellung bestimmter
										Funktionen zu ermöglichen. Cookies sind kleine Textdateien, die auf Deinem Rechner oder mobilen
										Gerät abgelegt werden und die Dein Browser speichert. Ein Cookie enthält eine charakteristische
										Zeichenfolge, die eine eindeutige Identifizierung Deines Browsers beim erneuten Aufrufen der
										Webseite ermöglicht.</span
									></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p>Wir setzen folgende Cookies ein:</p>
	<ul>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent">Session Cookies</span></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent"
												>Temporäre Cookies (z.B. Cookies zu Analysezwecken, Plugins, etc.)</span
											></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
	</ul>
	<p>
		Cookies werden durch die meisten Browser automatisch akzeptiert. Cookies können einzeln oder vollständig im jeweiligen Browser
		gelöscht werden. Soweit Du Cookies in Deinen Browsereinstellungen vollständig deaktivierst, kann dies dazu führen, dass Dir nicht
		alle Funktionen unserer Webseite zur Nutzung zur Verfügung stehen.
	</p>
	<ol type="A">
		<ol type="I">
			<ol>
				<ol type="a" start="2">
					<li>
						<p
							align="justify"
							style="
								line-height: 120%;
								page-break-inside: auto;
								orphans: 0;
								widows: 0;
								margin-top: 0.24in;
								margin-bottom: 0.04in;
								border: none;
								padding: 0in;
								background: transparent;
								page-break-before: auto;
								page-break-after: avoid;
							"
						>
							<span style="font-variant: normal"
								><font color="#000000"
									><span style="text-decoration: none"
										><font face="Arial"
											><font size="2" style="font-size: 11pt"
												><span style="font-style: normal"
													><b><span style="background: transparent">Session Cookies</span></b></span
												></font
											></font
										></span
									></font
								></span
							>
						</p>
					</li>
				</ol>
			</ol>
		</ol>
	</ol>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Wir nutzen Session Cookies, um festzustellen, dass Du unsere Webseite sowie einzelne Seiten besucht
										hast. Session-Cookies speichern eine Session-ID und liefern keinen Hinweis zu Deiner Identifikation.
										Die Informationen werden gelöscht, sobald Du deinen Browser schließt.</span
									></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<ol type="A">
		<ol type="I">
			<ol>
				<ol type="a" start="3">
					<li>
						<p
							align="justify"
							style="
								line-height: 120%;
								page-break-inside: auto;
								orphans: 0;
								widows: 0;
								margin-top: 0.24in;
								margin-bottom: 0.04in;
								border: none;
								padding: 0in;
								background: transparent;
								page-break-before: auto;
								page-break-after: avoid;
							"
						>
							<span style="font-variant: normal"
								><font color="#000000"
									><span style="text-decoration: none"
										><font face="Arial"
											><font size="2" style="font-size: 11pt"
												><span style="font-style: normal"
													><b><span style="background: transparent">Temporäre Cookies</span></b></span
												></font
											></font
										></span
									></font
								></span
							>
						</p>
					</li>
				</ol>
			</ol>
		</ol>
	</ol>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Einige der Cookies, die wir auf unserer Webseite verwenden, stammen von Dritten, die uns helfen,
										die Wirkung unserer Webseiteninhalte und Interessen unserer Besucher zu analysieren, die Leistung
										und Performance unserer Webseite zu messen oder bedarfsgerechte Werbung und anderen Content auf
										unsere oder andere Webseiten zu setzen.
									</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Die Cookie-basierte Datenverarbeitung erfolgt vorrangig auf Basis Deiner erteilten Einwilligung
										gemäß § 25 Abs. 1 TDDDG, Art. 6 Abs. 1 S. 1 lit. a DSGVO. Darüber hinaus dienen Art. 6 Abs.&nbsp;1
										S. 1 lit. c DSGVO und Art. 6 Abs. 1 S. 1 lit. f DSGVO als Rechtsgrundlage. Unser berechtigtes
										Interesse besteht hierbei darin, Dir eine technisch funktionierende und benutzerfreundlich
										gestaltete Webseite zur Verfügung stellen zu können sowie die Sicherheit unserer Systeme zu
										gewährleisten.</span
									></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p>
		Du kannst die Cookies unter folgendem Link die Cookies einsehen und die Cookie-Einstellungen jederzeit ändern über
		<a href="https://order.deananddavid.com/cookie" target="_blank" role="link">https://order.deananddavid.com/cookie</a>
	</p>
	<ol type="A">
		<ol type="I">
			<ol start="3">
				<li>
					<p
						align="justify"
						style="
							line-height: 120%;
							page-break-inside: auto;
							orphans: 0;
							widows: 0;
							margin-top: 0.24in;
							margin-bottom: 0.04in;
							border: none;
							padding: 0in;
							background: transparent;
							page-break-before: auto;
							page-break-after: avoid;
						"
					>
						<span style="font-variant: normal"
							><font color="#000000"
								><span style="text-decoration: none"
									><font face="Arial"
										><font size="2" style="font-size: 11pt"
											><span style="font-style: normal"
												><b><span style="background: transparent">Kontaktaufnahme und Bestellungen</span></b></span
											></font
										></font
									></span
								></font
							></span
						>
					</p>
				</li>
			</ol>
		</ol>
	</ol>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Soweit Du mit uns im Rahmen einer bestehenden Vertragsbeziehung Kontakt aufnimmst oder uns im
										Vorfeld zur Information über unser Leistungsangebot oder unsere sonstigen Services kontaktierst,
										werden die von Dir mitgeteilten Daten und Informationen zum Zwecke der Bearbeitung und Beantwortung
										Deiner Kontaktanfrage gemäß Art. 6 Abs. 1 S. 1 lit. b DSGVO (Vertragserfüllung) verarbeitet. Wenn Du
										dich bei uns registrierst, um bei uns zu bestellen oder als Gast bestellst, erfolgt die
										Datenverarbeitung zur Vorbereitung/Bereitstellung/Lieferung deiner Bestellung und auf Grundlage von
										Art. 6 Abs. 1 S. 1 lit. b DSGVO (Vertragserfüllung). Ansonsten erfolgt die Datenverarbeitung zur
										Wahrung unserer berechtigten Interessen gemäß Art. 6 Abs. 1 S. 1 lit. f DSGVO zur sachgerechten
										Beantwortung von Kunden- und Kontaktanfragen. Soweit Du uns Deine Einwilligung (Art. 6 Abs. 1 lit. a
										DSGVO) erteilt hast, erfolgt die Datenverarbeitung auf dieser Rechtsgrundlage.</span
									></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<ol type="A">
		<ol type="I">
			<ol>
				<ol type="a">
					<li>
						<p
							align="justify"
							style="
								line-height: 120%;
								page-break-inside: auto;
								orphans: 0;
								widows: 0;
								margin-top: 0.24in;
								margin-bottom: 0.04in;
								border: none;
								padding: 0in;
								background: transparent;
								page-break-before: auto;
								page-break-after: avoid;
							"
						>
							<span style="font-variant: normal"
								><font color="#000000"
									><span style="text-decoration: none"
										><font face="Arial"
											><font size="2" style="font-size: 11pt"
												><span style="font-style: normal"
													><b
														><span style="background: transparent"
															>Anfragen per E-Mail, Telefon und Fax</span
														></b
													></span
												></font
											></font
										></span
									></font
								></span
							>
						</p>
					</li>
				</ol>
			</ol>
		</ol>
	</ol>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Wenn Du mit uns per E-Mail, Telefon oder Fax Anfragen zukommen lässt, wird Deine Nachricht
										inklusive der von Dir mitgeteilten personenbezogenen Daten (Name, E-Mail-Adresse, Telefonnummer,
										Faxnummer u. ä.) zwecks Bearbeitung und Beantwortung der Anfrage sowie für den Fall von
										Anschlussfragen bei uns gespeichert und entsprechend weiterverarbeitet. Diese Daten geben wir nicht
										an Dritte weiter, es sei denn, dies ist im Rahmen der Bearbeitung und Beantwortung Deiner
										Kontaktanfrage erforderlich (z.B. an einen dean&amp;david-Store) oder Du hast uns Deine Einwilligung
										erteilt.</span
									></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<ol type="A">
		<ol type="I">
			<ol>
				<ol type="a" start="2">
					<li>
						<p
							align="justify"
							style="
								line-height: 120%;
								page-break-inside: auto;
								orphans: 0;
								widows: 0;
								margin-top: 0.24in;
								margin-bottom: 0.04in;
								border: none;
								padding: 0in;
								background: transparent;
								page-break-before: auto;
								page-break-after: avoid;
							"
						>
							<span style="font-variant: normal"
								><font color="#000000"
									><span style="text-decoration: none"
										><font face="Arial"
											><font size="2" style="font-size: 11pt"
												><span style="font-style: normal"
													><b><span style="background: transparent">Registrierung</span></b></span
												></font
											></font
										></span
									></font
								></span
							>
						</p>
					</li>
				</ol>
			</ol>
		</ol>
	</ol>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Du kannst auf unserer Webseite als Gast bestellen. Du kannst dich auch für eine Registrierung bei
										uns entscheiden. Du kannst dann beim Bestellvorgang Gutschein-/Promocodes und Coupons nutzen und
										deinen Bestellverlauf einsehen. Zudem können Deine Daten automatisch beim Bestellvorgang ausgefüllt
										werden.</span
									></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<ol type="A">
		<ol type="I">
			<ol>
				<ol type="a">
					<ol type="a" start="27">
						<li>
							<p
								align="justify"
								style="
									line-height: 120%;
									page-break-inside: auto;
									orphans: 0;
									widows: 0;
									margin-top: 0.24in;
									margin-bottom: 0.04in;
									border: none;
									padding: 0in;
									background: transparent;
									page-break-before: auto;
									page-break-after: auto;
								"
							>
								<span style="font-variant: normal"
									><font color="#000000"
										><span style="text-decoration: none"
											><font face="Arial"
												><font size="2" style="font-size: 11pt"
													><span style="font-style: normal"
														><b><span style="background: transparent">Registrierung bei uns</span></b></span
													></font
												></font
											></span
										></font
									></span
								>
							</p>
						</li>
					</ol>
				</ol>
			</ol>
		</ol>
	</ol>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Eine Registrierung ist direkt bei uns möglich. Hierfür benötigen wir folgende personenbezogene
										Daten von Dir:</span
									></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<ul>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent">Vor- und Nachname</span></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"><span style="background: transparent">E-Mail</span></span></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent">Telefonnummer </span></span
										></span
									></font
								></font
							></span
						></font
					></span
				><span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent"
												>(optional)<!-- Für Bestellung ist diese verpflichtend; Bitte einhaltlich machen; Zwecks Geburtsdatum bitte Minderjährigenrecht beachten. --></span
											></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent">Geburtsdatum (optional)</span></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
	</ul>
	<p style="line-height: 100%; margin-top: 0.19in; margin-bottom: 0.19in">
		Die Verarbeitung der personenbezogenen Daten erfolgt auf Grundlage Deiner Einwilligung (Art. 6 Abs. 1 lit. a DSGVO).
	</p>
	<p style="line-height: 100%; margin-top: 0.19in; margin-bottom: 0.19in">
		Um Deine Registrierung bei uns richtig zu verarbeiten, arbeiten wir mit Sterlix GmbH zusammen (s.o.).
	</p>
	<ol type="A">
		<ol type="I">
			<ol>
				<ol type="a">
					<ol type="a" start="27">
						<li>
							<p
								align="justify"
								style="
									line-height: 120%;
									page-break-inside: auto;
									orphans: 0;
									widows: 0;
									margin-top: 0.24in;
									margin-bottom: 0.04in;
									border: none;
									padding: 0in;
									background: transparent;
									page-break-before: auto;
									page-break-after: auto;
								"
							>
								<span style="font-variant: normal"
									><font color="#000000"
										><span style="text-decoration: none"
											><span style="background: transparent"
												>„<font face="Arial"
													><font size="2" style="font-size: 11pt"
														><span style="font-style: normal"><b>Mit Apple anmelden“</b></span></font
													></font
												></span
											></span
										></font
									></span
								>
							</p>
						</li>
					</ol>
				</ol>
			</ol>
		</ol>
	</ol>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Statt dich bei uns zu registrieren, kannst Du dich mit Deinem Apple-Account auf unserer Webseite
										anmelden („mit Apple anmelden“). Hierfür werden Cookies (Ziff. IV.2.) in Deinem Endgerät
										gespeichert. Datenschutzrechtlich verantwortlicher Anbieter für diesen Dienst ist</span
									></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p style="line-height: 100%; margin-bottom: 0in"><b>Apple Distribution International Limited </b></p>
	<p style="line-height: 100%; margin-bottom: 0in">Hollyhill Industrial Estate,</p>
	<p style="line-height: 100%; margin-bottom: 0in">Hollyhill, Cork, T23 YK84, IRLAND.</p>
	<p
		align="justify"
		style="
			font-variant: normal;
			font-style: normal;
			font-weight: normal;
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			text-decoration: none;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<br />
	</p>
	<p>
		Wenn Du dich für eine Anmeldung mit Apple entscheidest und auf den Button „mit Apple anmelden“ klickst, wirst Du auf das Anmeldefeld
		von Apple weitergeleitet. Du kannst dich dann mit Deinem Apple-Account bei dean &amp; david anmelden, statt eine eigene
		Registrierung vorzunehmen. Hierfür werden Cookies in Deinem Browser gespeichert. Nähere Informationen zur Anmeldung mit Apple
		findest Du unter
		<a href="https://support.apple.com/de-de/102609" role="link"
			><font color="#0000ff"><u>https://support.apple.com/de-de/102609</u></font></a
		>.
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Wir erhalten Zugriff auf folgende personenbezogene Daten von Dir:</span
									></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<ul>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"><span style="background: transparent">Name</span></span></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent">E-Mail-Adresse</span></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
	</ul>
	<p style="line-height: 100%; margin-top: 0.19in; margin-bottom: 0.19in">
		Diese Daten werden zur Einrichtung, Bereitstellung und Personalisierung Deines Accounts genutzt. Weitere Informationen findest Du in
		der Datenschutzerklärung von Apple unter
		<a href="https://www.apple.com/de/legal/privacy/data/de/apple-pay/" role="link"
			><font color="#0000ff"><u>https://www.apple.com/de/legal/privacy/data/de/apple-pay/</u></font></a
		>.
	</p>
	<p style="line-height: 100%; margin-top: 0.19in; margin-bottom: 0.19in">
		Die Verarbeitung der personenbezogenen Daten erfolgt auf Grundlage Deiner Einwilligung (Art. 6 Abs. 1 lit. a DSGVO).
	</p>
	<ol type="A">
		<ol type="I">
			<ol>
				<ol type="a">
					<ol type="a" start="27">
						<li>
							<p
								align="justify"
								style="
									line-height: 120%;
									page-break-inside: auto;
									orphans: 0;
									widows: 0;
									margin-top: 0.24in;
									margin-bottom: 0.04in;
									border: none;
									padding: 0in;
									background: transparent;
									page-break-before: auto;
									page-break-after: auto;
								"
							>
								<span style="font-variant: normal"
									><font color="#000000"
										><span style="text-decoration: none"
											><font face="Arial"
												><font size="2" style="font-size: 11pt"
													><span style="font-style: normal"
														><b
															><span style="background: transparent">Registrierung mit Facebook </span></b
														></span
													></font
												></font
											></span
										></font
									></span
								>
							</p>
						</li>
					</ol>
				</ol>
			</ol>
		</ol>
	</ol>
	<p style="line-height: 100%; margin-top: 0.19in; margin-bottom: 0.19in">
		Statt einer direkten Registrierung auf unserer Bestellseite kannst Du dich mit „Facebook“ registrieren. Hierfür werden Cookies
		(Ziff. IV.2.) in Deinem Endgerät gespeichert. Datenschutzrechtlich verantwortlich für diesen Dienst ist
	</p>
	<p style="line-height: 100%; margin-bottom: 0in"><b>Meta Platforms Ireland Limited</b></p>
	<p style="line-height: 100%; margin-bottom: 0in">4 Grand Canal Square</p>
	<p style="line-height: 100%; margin-bottom: 0in">Dublin 2, IRLAND.</p>
	<p style="line-height: 100%; margin-top: 0.19in; margin-bottom: 0.19in">
		Wenn Du Dich für die Registrierung mit Facebook Connect entscheidest und auf den „Login with Facebook“- / „Connect with
		Facebook“-Button klickst, wirst Du automatisch auf die Plattform von Facebook weitergeleitet. Dort kannst Du Dich mit Deinen
		Nutzungsdaten anmelden. Dadurch wird Dein Facebook-Profil mit unserer Webseite bzw. unseren Diensten verknüpft. Durch diese
		Verknüpfung erhalten wir Zugriff auf Deine bei Facebook hinterlegten Daten. Dies sind vor allem:
	</p>
	<ul>
		<li><p style="line-height: 100%; orphans: 2; widows: 2; margin-top: 0.19in; margin-bottom: 0in">Facebook-Name</p></li>
		<li><p style="line-height: 100%; orphans: 2; widows: 2; margin-bottom: 0in">Facebook-Profil- und Titelbild</p></li>
		<li><p style="line-height: 100%; orphans: 2; widows: 2; margin-bottom: 0in">Facebook-Titelbild</p></li>
		<li><p style="line-height: 100%; orphans: 2; widows: 2; margin-bottom: 0in">bei Facebook hinterlegte E-Mail-Adresse</p></li>
		<li><p style="line-height: 100%; orphans: 2; widows: 2; margin-bottom: 0in">Facebook-ID</p></li>
		<li><p style="line-height: 100%; orphans: 2; widows: 2; margin-bottom: 0in">Facebook-Freundeslisten</p></li>
		<li><p style="line-height: 100%; orphans: 2; widows: 2; margin-bottom: 0in">Facebook Likes („Gefällt-mir“-Angaben)</p></li>
		<li><p style="line-height: 100%; orphans: 2; widows: 2; margin-bottom: 0in">Geburtstag</p></li>
		<li><p style="line-height: 100%; orphans: 2; widows: 2; margin-bottom: 0in">Geschlecht</p></li>
		<li><p style="line-height: 100%; orphans: 2; widows: 2; margin-bottom: 0in">Land</p></li>
		<li><p style="line-height: 100%; orphans: 2; widows: 2; margin-bottom: 0.19in">Sprache</p></li>
	</ul>
	<p style="line-height: 100%; margin-top: 0.19in; margin-bottom: 0.19in">
		Diese Daten werden zur Einrichtung, Bereitstellung und Personalisierung Deines Accounts genutzt. Weitere Informationen findest Du in
		der Meta-Datenschutzrichtlinie unter
		<a href="https://www.facebook.com/privacy/policy/" role="link"
			><font color="#0000ff"><u>https://www.facebook.com/privacy/policy/</u></font></a
		>.
	</p>
	<p style="line-height: 100%; margin-top: 0.19in; margin-bottom: 0.19in">
		Die Verarbeitung der personenbezogenen Daten erfolgt auf Grundlage Deiner Einwilligung (Art. 6 Abs. 1 lit. a DSGVO).
	</p>
	<ol type="A">
		<ol type="I">
			<ol>
				<ol type="a">
					<ol type="a" start="27">
						<li>
							<p
								align="justify"
								style="
									line-height: 120%;
									page-break-inside: auto;
									orphans: 0;
									widows: 0;
									margin-top: 0.24in;
									margin-bottom: 0.04in;
									border: none;
									padding: 0in;
									background: transparent;
									page-break-before: auto;
									page-break-after: auto;
								"
							>
								<span style="font-variant: normal"
									><font color="#000000"
										><span style="text-decoration: none"
											><font face="Arial"
												><font size="2" style="font-size: 11pt"
													><span style="font-style: normal"
														><b><span style="background: transparent">Anmeldung über Google</span></b></span
													></font
												></font
											></span
										></font
									></span
								>
							</p>
						</li>
					</ol>
				</ol>
			</ol>
		</ol>
	</ol>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Statt einer direkten Registrierung auf unserer Bestellseite kannst Du dich mit Deinem Google
										Account registrieren. Hierfür werden Cookies (Ziff. IV.2.) in Deinem Endgerät gespeichert.
										Datenschutzrechtlich verantwortlich für diesen Dienst ist</span
									></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p style="line-height: 100%; margin-bottom: 0in"><b>Google Ireland Limited</b></p>
	<p style="line-height: 100%; margin-bottom: 0in">Gordon House, Barrow Street</p>
	<p style="line-height: 100%; margin-bottom: 0in">Dublin 4, IRLAND.</p>
	<p style="line-height: 100%; margin-bottom: 0in"><br /></p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Wenn Du Dich für eine Anmeldung mit Google entscheidest und auf den „Weiter mit Google“-Button
										klickst, wirst Du auf das Anmeldefeld von Google weitergeleitet. Du kannst dann Deinen
										Google-Account verwenden, um Dich bei dean &amp; david anzumelden. Nähere Informationen zur
										Anmeldung mit Google findest du unter
									</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		><a href="https://support.google.com/accounts/answer/12921417?hl=de" role="link"
			><span style="font-variant: normal"
				><font color="#0000ff"
					><span style="text-decoration: none"
						><font face="Arial"
							><font size="2" style="font-size: 11pt"
								><span style="font-style: normal"
									><u
										><span style="font-weight: normal"
											><span style="background: transparent"
												>https://support.google.com/accounts/answer/12921417?hl=de</span
											></span
										></u
									></span
								></font
							></font
						></span
					></font
				></span
			></a
		><span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"><span style="background: transparent">.</span></span></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Wenn Du die die Funktion „Weiter mit Google“ verwendest, dich auf unserer Webseite anzumelden,
										erhalten wir Zugriff auf Daten, die mit Deinem Google-Konto verknüpft sind. Dies sind vor
										allem:</span
									></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<ul>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent">Profilbild</span></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent">E-Mail-Adresse</span></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"><span style="background: transparent">Name</span></span></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
	</ul>
	<p style="line-height: 100%; margin-top: 0.19in; margin-bottom: 0.19in">
		Diese Daten werden zur Einrichtung, Bereitstellung und Personalisierung Deines Accounts genutzt. Weitere Informationen findest Du in
		den Datenschutzinformationen von Google unter
		<a href="https://business.safety.google/privacy/?hl=en" role="link"
			><font color="#0000ff"><u>https://business.safety.google/privacy/?hl=en</u></font></a
		>.
	</p>
	<p style="line-height: 100%; margin-top: 0.19in; margin-bottom: 0.19in">
		Die Verarbeitung der personenbezogenen Daten erfolgt auf Grundlage Deiner Einwilligung (Art. 6 Abs. 1 lit. a DSGVO).
	</p>
	<ol type="A">
		<ol type="I">
			<ol>
				<ol type="a" start="3">
					<li>
						<p
							align="justify"
							style="
								line-height: 120%;
								page-break-inside: auto;
								orphans: 0;
								widows: 0;
								margin-top: 0.24in;
								margin-bottom: 0.04in;
								border: none;
								padding: 0in;
								background: transparent;
								page-break-before: auto;
								page-break-after: avoid;
							"
						>
							<span style="font-variant: normal"
								><font color="#000000"
									><span style="text-decoration: none"
										><font face="Arial"
											><font size="2" style="font-size: 11pt"
												><span style="font-style: normal"
													><b><span style="background: transparent">Bestellung</span></b></span
												></font
											></font
										></span
									></font
								></span
							>
						</p>
					</li>
				</ol>
			</ol>
		</ol>
	</ol>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Wenn Du bei uns bestellst, benötigen wir, um Deine Bestellung auszuführen, einige personenbezogene
										Daten:</span
									></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<ul>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent">Vor- und Nachname</span></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent">Telefonnummer</span></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent">E-Mail-Adresse</span></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent">ggf. Lieferadresse</span></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent"
												>ggf. sonstige Informationen, die Du uns über das Feld „Anmerkung hinzufügen“
												mitteilst</span
											></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
	</ul>
	<p
		align="justify"
		style="
			font-variant: normal;
			font-style: normal;
			font-weight: normal;
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-left: 0.5in;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			text-decoration: none;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<br />
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Diese Daten geben wir an den von Dir ausgewählten dean-and-david Store weiter, damit sie Deine
										Bestellung ausführen und bereitstellen / ausliefern können. Die Verarbeitung erfolgt auf Grundlage
										von Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung). Sofern Du uns Gesundheitsdaten mitteilst (bspw.
										Allergien), erfolgt die Datenverarbeitung auf Grundlage von Art. 9 Abs.&nbsp;2 lit. e DSGVO, wenn Du
										diese Daten uns öffentlich gemacht hast. Ansonsten erfolgt die Verarbeitung auf Grundlage deiner
										Einwilligung Art. 9 Abs. 2 lit. a DSGVO.</span
									></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<ol type="A">
		<ol type="I">
			<ol start="4">
				<li>
					<p
						align="justify"
						style="
							line-height: 120%;
							page-break-inside: auto;
							orphans: 0;
							widows: 0;
							margin-top: 0.24in;
							margin-bottom: 0.04in;
							border: none;
							padding: 0in;
							background: transparent;
							page-break-before: auto;
							page-break-after: avoid;
						"
					>
						<span style="font-variant: normal"
							><font color="#000000"
								><span style="text-decoration: none"
									><font face="Arial"
										><font size="2" style="font-size: 11pt"
											><span style="font-style: normal"
												><b><span style="background: transparent">Kommunikation mit uns</span></b></span
											></font
										></font
									></span
								></font
							></span
						>
					</p>
				</li>
			</ol>
		</ol>
	</ol>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Wir versenden über Smoothr (s.o.) E-Mails, um Dich beispielsweise über Bestellverläufe und
										Kontoaktivitäten zu informieren. Zum Versand von E-Mails nutzen wir SendGrid, einen
										E-Mail-Delivery-Dienst. Datenschutzrechtlich verantwortlicher Anbieter für diesen Dienst ist</span
									></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p style="line-height: 100%; margin-bottom: 0in"><b>Twilio Ireland Limited</b></p>
	<p style="line-height: 100%; margin-bottom: 0in">3 Dublin Landings, North Wall Quay</p>
	<p style="line-height: 100%; margin-bottom: 0in">Dublin 1, IRLAND.</p>
	<p style="line-height: 100%; margin-bottom: 0in"><br /></p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Mit SendGrid können wir E-Mails effektiver versenden und verarbeiten. Wir können Dich so schneller
										über Deine Bestellung informieren oder Dir Informationen über Deinen Account zukommen lassen.
									</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Für den Versand der E-Mails verarbeitet Twilio Ireland Limited (im Folgenden: Twilio) folgende
										personenbezogene Daten:</span
									></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<ul>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"><span style="background: transparent">Vorname</span></span></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"><span style="background: transparent">Name</span></span></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent">Lieferadresse (falls Lieferung)</span></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent"
												>Bestelldaten (Artikel, Summe und Coupon-Nummer)</span
											></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent">Zahlungsart</span></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent">Öffnungsraten</span></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"><span style="background: transparent">Klicks</span></span></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent">Datum und Zeit</span></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent">Sendestatus</span></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent">Anhänge (Bestellbestätigung)</span></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
	</ul>
	<p
		align="justify"
		style="
			font-variant: normal;
			font-style: normal;
			font-weight: normal;
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-left: 0.5in;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			text-decoration: none;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<br />
	</p>
	<p>
		Die erhobenen personenbezogenen Daten werden für maximal 37 Tage gespeichert. Weitere Informationen findest Du in den
		Datenschutzhinweisen von Twilio unter
		<a href="https://www.twilio.com/en-us/legal/privacy?tid=331732615152" role="link"
			><font color="#0000ff"><u>https://www.twilio.com/en-us/legal/privacy?tid=331732615152</u></font></a
		>.
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Die Datenverarbeitung zum Zwecke der Bearbeitung Deiner Bestellung erfolgt auf Grundlage von Art. 6
										Abs. 1 S. 1 lit. b DSGVO (Vertragserfüllung). Ansonsten erfolgt die Datenverarbeitung zur Wahrung
										unserer berechtigten Interessen gemäß Art. 6 Abs.&nbsp;1 S. 1 lit. f DSGVO, da wir ein berechtigtes
										Interesse haben, Dich über Kontoaktivitäten zu informieren.</span
									></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<ol type="A">
		<ol type="I">
			<ol start="5">
				<li>
					<p
						align="justify"
						style="
							line-height: 120%;
							page-break-inside: auto;
							orphans: 0;
							widows: 0;
							margin-top: 0.24in;
							margin-bottom: 0.04in;
							border: none;
							padding: 0in;
							background: transparent;
							page-break-before: auto;
							page-break-after: avoid;
						"
					>
						<span style="font-variant: normal"
							><font color="#000000"
								><span style="text-decoration: none"
									><font face="Arial"
										><font size="2" style="font-size: 11pt"
											><span style="font-style: normal"
												><b><span style="background: transparent">Plugins/Cookies</span></b></span
											></font
										></font
									></span
								></font
							></span
						>
					</p>
					<ol type="a">
						<li>
							<p
								align="justify"
								style="
									line-height: 120%;
									page-break-inside: auto;
									orphans: 0;
									widows: 0;
									margin-top: 0.24in;
									margin-bottom: 0.04in;
									border: none;
									padding: 0in;
									background: transparent;
									page-break-before: auto;
									page-break-after: avoid;
								"
							>
								<span style="font-variant: normal"
									><font color="#000000"
										><span style="text-decoration: none"
											><font face="Arial"
												><font size="2" style="font-size: 11pt"
													><span style="font-style: normal"
														><b><span style="background: transparent">Cookiebot</span></b></span
													></font
												></font
											></span
										></font
									></span
								>
							</p>
						</li>
					</ol>
				</li>
			</ol>
		</ol>
	</ol>
	<p>
		Wir nutzen den Zustimmungsverwaltungsdienst Cookiebot. Durch diesen Dienst können wir Deine Einwilligung zur Speicherung bestimmter
		Cookies einholen und diese datenschutzkonform dokumentieren und verwalten. Um die erteilten Einwilligungen oder einen etwaigen
		Widerruf zuzuordnen, speichert Cookiebot einen Cookie in Deinem Browser.
	</p>
	<p style="line-height: 100%; margin-top: 0.19in; margin-bottom: 0.19in">Datenschutzrechtlich verantwortlicher Anbieter ist</p>
	<p align="left" style="line-height: 108%; orphans: 2; widows: 2; margin-bottom: 0.11in">
		<font color="#000000"><b>Usercentrics A/S</b></font
		><font color="#000000"
			><br />
			Havnegade 39<br />
			1058 Kopenhagen, DÄNEMARK.</font
		>
	</p>
	<p align="left" style="line-height: 108%; orphans: 2; widows: 2; margin-bottom: 0.11in">
		<font color="#000000">Usercentrics A/S verarbeitet folgende Daten</font>
	</p>
	<ul>
		<li>
			<p align="left" style="line-height: 108%; orphans: 2; widows: 2; margin-bottom: 0in">
				<a name="_heading=h.gjdgxs"></a> <font color="#000000">Datum und Uhrzeit des Zugriffs</font>
			</p>
		</li>
		<li>
			<p align="left" style="line-height: 108%; orphans: 2; widows: 2; margin-bottom: 0in">
				<font color="#000000">Browser-Informationen</font>
			</p>
		</li>
		<li>
			<p align="left" style="line-height: 108%; orphans: 2; widows: 2; margin-bottom: 0in">
				<font color="#000000">Geräteinformationen </font>
			</p>
		</li>
		<li>
			<p align="left" style="line-height: 108%; orphans: 2; widows: 2; margin-bottom: 0in">
				<font color="#000000">Geografischer Standort </font>
			</p>
		</li>
		<li>
			<p align="left" style="line-height: 108%; orphans: 2; widows: 2; margin-bottom: 0in">
				<font color="#000000">Cookie-Präferenzen </font>
			</p>
		</li>
		<li>
			<p align="left" style="line-height: 108%; orphans: 2; widows: 2; margin-bottom: 0in">
				<font color="#000000">URL der besuchten Seite</font>
			</p>
		</li>
	</ul>
	<p align="left" style="line-height: 108%; orphans: 2; widows: 2; margin-left: 0.5in; margin-bottom: 0in">
		<br />
	</p>
	<p align="left" style="line-height: 108%; orphans: 2; widows: 2; margin-bottom: 0.11in">
		<font color="#000000"
			>Usercentrics A/S speichert Deine Einwilligungsdaten (erteilte Einwilligung und Widerruf der Einwilligung) für ein Jahr. Die
			Daten werden dann unverzüglich gelöscht.</font
		>
	</p>
	<p align="left" style="line-height: 108%; orphans: 2; widows: 2; margin-bottom: 0.11in">
		<font color="#000000">Weitere Informationen findest Du in der Datenschutzrichtlinie des Anbieters unter </font
		><a href="https://www.cookiebot.com/de/privacy-policy/" role="link"
			><font color="#0000ff"><u>https://www.cookiebot.com/de/privacy-policy/</u></font></a
		><font color="#000000">.</font>
	</p>
	<p style="line-height: 100%; margin-bottom: 0in">
		Rechtsgrundlage für die Nutzung von Cookiebot ist Art. 6 Abs. 1 S. 1 lit. c DSGVO, um die gesetzlich vorgeschriebene Einwilligung
		für den Einsatz bestimmter Technologien einzuholen.
	</p>
	<ol type="A">
		<ol type="I">
			<ol>
				<ol type="a" start="2">
					<li>
						<p
							align="justify"
							style="
								line-height: 120%;
								page-break-inside: auto;
								orphans: 0;
								widows: 0;
								margin-top: 0.24in;
								margin-bottom: 0.04in;
								border: none;
								padding: 0in;
								background: transparent;
								page-break-before: auto;
								page-break-after: avoid;
							"
						>
							<span style="font-variant: normal"
								><font color="#000000"
									><span style="text-decoration: none"
										><font face="Arial"
											><font size="2" style="font-size: 11pt"
												><span style="font-style: normal"
													><b><span style="background: transparent">Google Maps</span></b></span
												></font
											></font
										></span
									></font
								></span
							>
						</p>
					</li>
				</ol>
			</ol>
		</ol>
	</ol>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Wir nutzen den Online-Kartendienst Google Maps. Datenschutzrechtlich verantwortlicher Anbieter für
										diesen Dienst ist</span
									></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><b><span style="background: transparent">Google Ireland Limited</span></b></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"><span style="background: transparent">Gordon House</span></span></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"><span style="background: transparent">4 Barrow St,</span></span></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><span style="background: transparent">
						<font face="Arial"
							><font size="2" style="font-size: 11pt"
								><span style="font-style: normal"
									><span style="font-weight: normal">Dublin, D04 E5W5, IRLAND.</span></span
								></font
							></font
						></span
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			font-variant: normal;
			font-style: normal;
			font-weight: normal;
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			text-decoration: none;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<br />
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Google Maps ist ein Dienst zur visuellen Darstellung von Karten und geographischen Informationen.
										Wir können Dir über diesen Dienst von Google Ireland Limited (im Folgenden: Google) unsere dean
										&amp; david–Standorte und den nächsten Store anzeigen lassen. Durch die Freigabe oder Angabe Deines
										Standorts können wir Dir die Suche des nächsten Stores erleichtern.</span
									></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent">Google verarbeitet folgende personenbezogene Daten</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<ul>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent">Datum und Uhrzeit des Besuchs</span></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent">Standort</span></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent">IP-Adresse</span></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"><span style="background: transparent">URL</span></span></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent">Nutzungsdaten</span></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent">Suchbegriffe</span></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent">geografischer Standort</span></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
	</ul>
	<p
		align="justify"
		style="
			font-variant: normal;
			font-style: normal;
			font-weight: normal;
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-left: 0.25in;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			text-decoration: none;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<br />
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Die von Google verarbeiteten Daten werden bis zu zwei Jahre gespeichert. Weitere Informationen
										findest Du in den Datenschutzbestimmungen von Google
									</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		><a href="https://business.safety.google/privacy/?hl=en" role="link"
			><span style="font-variant: normal"
				><font color="#0000ff"
					><span style="text-decoration: none"
						><font face="Arial"
							><font size="2" style="font-size: 11pt"
								><span style="font-style: normal"
									><u
										><span style="font-weight: normal"
											><span style="background: transparent"
												>https://business.safety.google/privacy/?hl=en</span
											></span
										></u
									></span
								></font
							></font
						></span
					></font
				></span
			></a
		><span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>. Die Cookie-Richtlinien von Google findest Du unter
									</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		><a href="https://policies.google.com/technologies/cookies?hl=en.%20" role="link"
			><span style="font-variant: normal"
				><font color="#0000ff"
					><span style="text-decoration: none"
						><font face="Arial"
							><font size="2" style="font-size: 11pt"
								><span style="font-style: normal"
									><u
										><span style="font-weight: normal"
											><span style="background: transparent"
												>https://policies.google.com/technologies/cookies?hl=en.
											</span></span
										></u
									></span
								></font
							></font
						></span
					></font
				></span
			></a
		>
	</p>
	<p>
		Wir haben ein berechtigtes Interesse (Art. 6 Abs. 1 lit. f DSGVO) daran, Google Maps für eine ansprechende Darstellung unserer dean
		&amp; david-Store-Standorte einzubinden.<!-- Nur auf Einwilligungsbasis, hier agieren! -->
	</p>
	<ol type="A">
		<ol type="I">
			<ol>
				<ol type="a" start="3">
					<li>
						<p
							align="justify"
							style="
								line-height: 120%;
								page-break-inside: auto;
								orphans: 0;
								widows: 0;
								margin-top: 0.24in;
								margin-bottom: 0.04in;
								border: none;
								padding: 0in;
								background: transparent;
								page-break-before: auto;
								page-break-after: avoid;
							"
						>
							<span style="font-variant: normal"
								><font color="#000000"
									><span style="text-decoration: none"
										><font face="Arial"
											><font size="2" style="font-size: 11pt"
												><span style="font-style: normal"
													><b><span style="background: transparent">Braze</span></b></span
												></font
											></font
										></span
									></font
								></span
							>
						</p>
					</li>
				</ol>
			</ol>
		</ol>
	</ol>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Wir nutzen „Braze“, um Dich über Push-Nachrichten, In-App-Messages zu informieren. Zudem nutzen wir
										Braze zum Zwecke des E-Mail-Marketings.</span
									></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Datenschutzrechtlich verantwortlicher Anbieter für diesen Dienst ist</span
									></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><b><span style="background: transparent">Braze, Inc.</span></b></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent">63 Madison Avenue, 13th Floor, </span></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent">New York, NY 10016, USA</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			font-variant: normal;
			font-style: normal;
			font-weight: normal;
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			text-decoration: none;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<br />
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Braze, Inc. (im Folgenden: Braze) verarbeitet folgende personenbezogene Daten:</span
									></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<ul>
		<ul>
			<li>
				<p
					align="justify"
					style="
						line-height: 120%;
						page-break-inside: auto;
						orphans: 0;
						widows: 0;
						margin-bottom: 0in;
						border: none;
						padding: 0in;
						background: transparent;
						page-break-before: auto;
						page-break-after: auto;
					"
				>
					<span style="font-variant: normal"
						><font color="#000000"
							><span style="text-decoration: none"
								><font face="Arial"
									><font size="2" style="font-size: 11pt"
										><span style="font-style: normal"
											><span style="font-weight: normal"
												><span style="background: transparent">Nutzerdaten (z.B. Demografische Details)</span></span
											></span
										></font
									></font
								></span
							></font
						></span
					>
				</p>
			</li>
			<li>
				<p
					align="justify"
					style="
						line-height: 120%;
						page-break-inside: auto;
						orphans: 0;
						widows: 0;
						margin-bottom: 0in;
						border: none;
						padding: 0in;
						background: transparent;
						page-break-before: auto;
						page-break-after: auto;
					"
				>
					<span style="font-variant: normal"
						><font color="#000000"
							><span style="text-decoration: none"
								><font face="Arial"
									><font size="2" style="font-size: 11pt"
										><span style="font-style: normal"
											><span style="font-weight: normal"
												><span style="background: transparent"
													>Meta-/Kommunikationsdaten (z.B. Geräte-Informationen, IP-Adresse)</span
												></span
											></span
										></font
									></font
								></span
							></font
						></span
					>
				</p>
			</li>
			<li>
				<p
					align="justify"
					style="
						line-height: 120%;
						page-break-inside: auto;
						orphans: 0;
						widows: 0;
						margin-bottom: 0in;
						border: none;
						padding: 0in;
						background: transparent;
						page-break-before: auto;
						page-break-after: auto;
					"
				>
					<span style="font-variant: normal"
						><font color="#000000"
							><span style="text-decoration: none"
								><font face="Arial"
									><font size="2" style="font-size: 11pt"
										><span style="font-style: normal"
											><span style="font-weight: normal"
												><span style="background: transparent">Interaktionsdaten (z.B. Clicks, Opens)</span></span
											></span
										></font
									></font
								></span
							></font
						></span
					>
				</p>
			</li>
		</ul>
	</ul>
	<p
		align="justify"
		style="
			font-variant: normal;
			font-style: normal;
			font-weight: normal;
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-left: 0.5in;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			text-decoration: none;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<br />
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Die erhobenen personenbezogenen Daten werden für maximal 90 Tage gespeichert. Weitere Informationen
										findest Du in den Datenschutzbestimmungen von Braze https://www.braze.com/company/legal/privacy. Die
										Cookie-Richtlinien von Braze findest Du unter
										<a href="https://policies.google.com/technologies/cookies?hl=en.%20" role="link">
										</a></span></span></span></font></font></span></font></span
		><a href="https://policies.google.com/technologies/cookies?hl=en.%20" role="link"
			><span style="font-variant: normal"
				><font color="#0000ff"
					><span style="text-decoration: none"
						><font face="Arial"
							><font size="2" style="font-size: 11pt"
								><span style="font-style: normal"
									><u
										><span style="font-weight: normal"
											><span style="background: transparent"
												>https://www.braze.com/company/legal/cookies.
											</span></span
										></u
									></span
								></font
							></font
						></span
					></font
				></span
			></a
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Die Verarbeitung der personenbezogenen Daten erfolgt auf Grundlage Deiner Einwilligung (Art. 6 Abs.
										1 lit. a DSGVO, § 25 Abs. 1 TDDDG).</span
									></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<ol type="A">
		<ol type="I">
			<ol>
				<ol type="a" start="4">
					<li>
						<p
							align="justify"
							style="
								line-height: 120%;
								page-break-inside: auto;
								orphans: 0;
								widows: 0;
								margin-top: 0.24in;
								margin-bottom: 0.04in;
								border: none;
								padding: 0in;
								background: transparent;
								page-break-before: auto;
								page-break-after: avoid;
							"
						>
							<span style="font-variant: normal"
								><font color="#000000"
									><span style="text-decoration: none"
										><font face="Arial"
											><font size="2" style="font-size: 11pt"
												><span style="font-style: normal"
													><b><span style="background: transparent">Google Cloud CDN</span></b></span
												></font
											></font
										></span
									></font
								></span
							>
						</p>
					</li>
				</ol>
			</ol>
		</ol>
	</ol>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Wir nutzen das Content Delivery Network (CDN) von Google Cloud. Über ein CDN können wir Dir eine
										schnellere Ladezeit der Webseite zu ermöglichen. Durch diesen Dienst können wir Dir als Nutzer
										unsere Webseite schneller zum Abruf bereitstellen.</span
									></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Datenschutzrechtlich verantwortlicher Anbieter für diesen Dienst ist</span
									></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><b><span style="background: transparent">Google Ireland Limited</span></b></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent">Gordon House, Barrow Street</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent">Dublin 4, IRLAND.</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			font-variant: normal;
			font-style: normal;
			font-weight: normal;
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			text-decoration: none;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<br />
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Google Ireland Limited (im Folgenden: Google) verarbeitet folgende personenbezogene Daten:</span
									></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<ul>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent">Betriebssystem</span></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"><span style="background: transparent">Browser</span></span></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent">Referrer-URL</span></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent">aufgerufene Webseite</span></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent">IP-Adresse</span></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
	</ul>
	<p
		align="justify"
		style="
			font-variant: normal;
			font-style: normal;
			font-weight: normal;
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-left: 0.5in;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			text-decoration: none;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<br />
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Zur Erhebung der Daten wird ein Cookie in Deinem Browser platziert. Die erhobenen personenbezogenen
										Daten werden für maximal 30 Tage gespeichert. Weitere Informationen findest Du in den
										Datenschutzbestimmungen von Google
									</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		><a href="https://business.safety.google/privacy/?hl=en" role="link"
			><span style="font-variant: normal"
				><font color="#0000ff"
					><span style="text-decoration: none"
						><font face="Arial"
							><font size="2" style="font-size: 11pt"
								><span style="font-style: normal"
									><u
										><span style="font-weight: normal"
											><span style="background: transparent"
												>https://business.safety.google/privacy/?hl=en</span
											></span
										></u
									></span
								></font
							></font
						></span
					></font
				></span
			></a
		><span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>. Die Cookie-Richtlinien von Google findest Du unter
									</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		><a href="https://policies.google.com/technologies/cookies?hl=en.%20" role="link" aria-label="Google Cookies Policy"
			><span style="font-variant: normal"
				><font color="#0000ff"
					><span style="text-decoration: none"
						><font face="Arial"
							><font size="2" style="font-size: 11pt"
								><span style="font-style: normal"
									><u
										><span style="font-weight: normal"
											><span style="background: transparent"
												>https://policies.google.com/technologies/cookies?hl=en.
											</span></span
										></u
									></span
								></font
							></font
						></span
					></font
				></span
			></a
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Die Verarbeitung der personenbezogenen Daten erfolgt auf Grundlage unseres berechtigten Interesses
										(Art. 6 Abs. 1 lit. f DSGVO) an einer möglichst fehlerfreien und schnellen Bereitstellung unseres
										Angebots.</span
									></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<ol type="A">
		<ol type="I">
			<ol start="6">
				<li>
					<p
						align="justify"
						style="
							line-height: 120%;
							page-break-inside: auto;
							orphans: 0;
							widows: 0;
							margin-top: 0.24in;
							margin-bottom: 0.04in;
							border: none;
							padding: 0in;
							background: transparent;
							page-break-before: auto;
							page-break-after: avoid;
						"
					>
						<span style="font-variant: normal"
							><font color="#000000"
								><span style="text-decoration: none"
									><font face="Arial"
										><font size="2" style="font-size: 11pt"
											><span style="font-style: normal"
												><b><span style="background: transparent">Analyse-Tools und Werbung</span></b></span
											></font
										></font
									></span
								></font
							></span
						>
					</p>
				</li>
			</ol>
		</ol>
	</ol>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Wir nutzen verschiedene Tools zur technischen Analyse der Webseite, zur Nutzeranalyse des
										Webseitenverhaltens und zum Zwecke der Werbung.</span
									></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<ol type="A">
		<ol type="I">
			<ol>
				<ol type="a">
					<li>
						<p
							align="justify"
							style="
								line-height: 120%;
								page-break-inside: auto;
								orphans: 0;
								widows: 0;
								margin-top: 0.24in;
								margin-bottom: 0.04in;
								border: none;
								padding: 0in;
								background: transparent;
								page-break-before: auto;
								page-break-after: avoid;
							"
						>
							<span style="font-variant: normal"
								><font color="#000000"
									><span style="text-decoration: none"
										><font face="Arial"
											><font size="2" style="font-size: 11pt"
												><span style="font-style: normal"
													><b><span style="background: transparent">Google Analytics</span></b></span
												></font
											></font
										></span
									></font
								></span
							>
						</p>
						<ol type="a" start="27">
							<li>
								<p
									align="justify"
									style="
										line-height: 120%;
										page-break-inside: auto;
										orphans: 0;
										widows: 0;
										margin-top: 0.24in;
										margin-bottom: 0.04in;
										border: none;
										padding: 0in;
										background: transparent;
										page-break-before: auto;
										page-break-after: auto;
									"
								>
									<span style="font-variant: normal"
										><font color="#000000"
											><span style="text-decoration: none"
												><font face="Arial"
													><font size="2" style="font-size: 11pt"
														><span style="font-style: normal"
															><b><span style="background: transparent">Allgemeines</span></b></span
														></font
													></font
												></span
											></font
										></span
									>
								</p>
							</li>
						</ol>
					</li>
				</ol>
			</ol>
		</ol>
	</ol>
	<p>Wir nutzen den Webtrackingdienst Google Analytics. Datenschutzrechtlich verantwortlicher Anbieter für diesen Dienst ist</p>
	<p style="line-height: 100%; margin-bottom: 0in"><b>Google Ireland Limited</b></p>
	<p style="line-height: 100%; margin-bottom: 0in">Gordon House, Barrow Street</p>
	<p style="line-height: 100%; margin-bottom: 0in">Dublin 4, IRLAND.</p>
	<p style="line-height: 100%; margin-bottom: 0in"><br /></p>
	<p>
		Durch Google Analytics können wir Dein Nutzerverhalten auf unserer Webseite analysieren. In unserem Auftrag wird Google Ireland
		Limited (im Folgenden: Google) diese Informationen benutzen, um Deine Nutzung der Webseite auszuwerten, um Reports über die
		Webseitenaktivitäten zusammenzustellen und um weitere mit der Webseitennutzung und der Internetnutzung verbundene Dienstleistungen
		gegenüber uns zu erbringen. Die im Rahmen von Google Analytics von Deinem Browser übermittelte IP-Adresse wird nicht mit anderen
		Daten von Google zusammengeführt.
	</p>
	<p>Folgende personenbezogene Daten werden durch Google verarbeitet:</p>
	<ul>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent">Klickpfad</span></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent">Datum und Uhrzeit des Besuchs</span></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent">Geräteinformationen</span></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent">Standort-Informationen</span></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent">IP-Adresse</span></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent">Besuchte Seiten</span></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent">Referrer-URL</span></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent">Browser-Informationen</span></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent">Hostname</span></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent">Browser-Sprache</span></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent">Browser-Typ</span></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent">Bildschirmauflösung</span></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent">Gerätebetriebssystem</span></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent">Interaktionsdaten</span></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent">Nutzerverhalten</span></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent">Besuchte URL</span></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent">Cookie ID</span></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
	</ul>
	<p
		align="justify"
		style="
			font-variant: normal;
			font-style: normal;
			font-weight: normal;
			line-height: 100%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-left: 0.5in;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			text-decoration: none;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<br />
	</p>
	<p>
		Google Analytics verwendet „Cookies“ (s.o. Ziffer IV.2), die eine Analyse der Benutzung unserer Webseite durch Dich ermöglichen. Die
		gesammelten Informationen werden an einen Server von Google innerhalb der EU, aber ggf. auch in den USA übertragen und dort
		gespeichert.
	</p>
	<p>
		Die Höchstgrenze für die Speicherung von Cookies von Google Analytics beträgt zwei Jahre. Weitere Informationen erhältst Du in den
		Datenschutzinformationen von Google unter
		<a href="https://business.safety.google/privacy/?hl=en" role="link"
			><font color="#0000ff"><u>https://business.safety.google/privacy/?hl=en</u></font></a
		>. Die Cookie-Richtlinie von Google kannst Du unter
		<a href="https://policies.google.com/technologies/cookies?hl=en" role="link"
			><font color="#0000ff"><u>https://policies.google.com/technologies/cookies?hl=en</u></font></a
		>
		abrufen. Unter
		<a href="http://tools.google.com/dlpage/gaoptout?hl=de" role="link"
			><font color="#0000ff"><u>http://tools.google.com/dlpage/gaoptout?hl=de</u></font></a
		>
		kannst Du das Browser-Add-On zur Deaktivierung von Google Analytics herunterladen und installieren, um die Datenerfassung durch
		Google einzuschränken.
	</p>
	<p>
		Die Verarbeitung der personenbezogenen Daten erfolgt auf Grundlage Deiner Einwilligung (Art.&nbsp;6 Abs. 1 lit. a DSGVO, § 25 Abs. 1
		TDDDG).
	</p>
	<ol type="A">
		<ol type="I">
			<ol>
				<ol type="a">
					<ol type="a" start="27">
						<li>
							<p
								align="justify"
								style="
									line-height: 120%;
									page-break-inside: auto;
									orphans: 0;
									widows: 0;
									margin-top: 0.24in;
									margin-bottom: 0.04in;
									border: none;
									padding: 0in;
									background: transparent;
									page-break-before: auto;
									page-break-after: auto;
								"
							>
								<span style="font-variant: normal"
									><font color="#000000"
										><span style="text-decoration: none"
											><font face="Arial"
												><font size="2" style="font-size: 11pt"
													><span style="font-style: normal"
														><b><span style="background: transparent">Demografische Merkmale</span></b></span
													></font
												></font
											></span
										></font
									></span
								>
							</p>
						</li>
					</ol>
				</ol>
			</ol>
		</ol>
	</ol>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Unsere Webseite nutzt die Funktion „demografische Merkmale” von Google Analytics. Dadurch können
										Berichte erstellt werden, die Aussagen zu Alter, Geschlecht und Interessen der Seitenbesucher
										enthalten. Diese Daten stammen aus interessenbezogener Werbung von Google sowie aus Besucherdaten
										von Drittanbietern. Diese Daten können jedoch keiner bestimmten Person zugeordnet werden.</span
									></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<ol type="A">
		<ol type="I">
			<ol>
				<ol type="a">
					<ol type="a" start="27">
						<li>
							<p
								align="justify"
								style="
									line-height: 120%;
									page-break-inside: auto;
									orphans: 0;
									widows: 0;
									margin-top: 0.24in;
									margin-bottom: 0.04in;
									border: none;
									padding: 0in;
									background: transparent;
									page-break-before: auto;
									page-break-after: auto;
								"
							>
								<span style="font-variant: normal"
									><font color="#000000"
										><span style="text-decoration: none"
											><font face="Arial"
												><font size="2" style="font-size: 11pt"
													><span style="font-style: normal"
														><b
															><span style="background: transparent"
																>Detaillierte Standort- und Geräteerfassung</span
															></b
														></span
													></font
												></font
											></span
										></font
									></span
								>
							</p>
						</li>
					</ol>
				</ol>
			</ol>
		</ol>
	</ol>
	<p>
		Unsere Webseite nutzt die Funktion „Detaillierte Standort- und Gerätedatenerfassung”. Dadurch können Berichte erstellt werden, die
		Aussagen zu Alter, Geschlecht und Interessen der Appbesucher enthalten. Diese Daten stammen aus interessenbezogener Werbung von
		Google sowie aus Besucherdaten von Drittanbietern.
	</p>
	<ol type="A">
		<ol type="I">
			<ol>
				<ol type="a">
					<ol type="a" start="27">
						<li>
							<p
								align="justify"
								style="
									line-height: 120%;
									page-break-inside: auto;
									orphans: 0;
									widows: 0;
									margin-top: 0.24in;
									margin-bottom: 0.04in;
									border: none;
									padding: 0in;
									background: transparent;
									page-break-before: auto;
									page-break-after: auto;
								"
							>
								<span style="font-variant: normal"
									><font color="#000000"
										><span style="text-decoration: none"
											><font face="Arial"
												><font size="2" style="font-size: 11pt"
													><span style="font-style: normal"
														><b><span style="background: transparent">Google Signale</span></b></span
													></font
												></font
											></span
										></font
									></span
								>
							</p>
						</li>
					</ol>
				</ol>
			</ol>
		</ol>
	</ol>
	<p>
		Unsere Webseite nutzt die Funktion „Google Signale“. Durch Google Signale können wir zusammengefasste und anonymisierte Daten von
		Dir erhalten, wenn Du in Deinem Google-Konto personalisierte Anzeigen erlaubt haben. Die von Google bereitgestellten Berichte helfen
		uns, Dein Nutzerverhalten besser einschätzen zu können und unser Angebot zu optimieren. Im Rahmen von Google Signale werden
		demografische Merkmale (z.B. Alter, Sprache, Wohnort, Geschlecht) erhoben. Es handelt sich um zusammengefasste und anonymisierte
		Daten. Ein Rückschluss auf Dich als Nutzer ist nicht möglich.
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Bei Google Signale handelt es sich um eine „Cross-Device-Tracking-Funktion“. Dies bedeu-tet, dass
										Deine Daten geräteübergreifend analysiert werden können. Die von Google erhobenen Daten werden mit
										Deinem Google Konto verknüpft. Durch die erfassten Daten können wir in Form des Remarketings
										Kampagnen starten und auch geräteübergreifend auf anderen Webseiten unser Angebot
										präsentieren.</span
									></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<ol type="A">
		<ol type="I">
			<ol>
				<ol type="a">
					<ol type="a" start="27">
						<li>
							<p
								align="justify"
								style="
									line-height: 120%;
									page-break-inside: auto;
									orphans: 0;
									widows: 0;
									margin-top: 0.24in;
									margin-bottom: 0.04in;
									border: none;
									padding: 0in;
									background: transparent;
									page-break-before: auto;
									page-break-after: auto;
								"
							>
								<span style="font-variant: normal"
									><font color="#000000"
										><span style="text-decoration: none"
											><font face="Arial"
												><font size="2" style="font-size: 11pt"
													><span style="font-style: normal"
														><b><span style="background: transparent">IP-Anonymisierung</span></b></span
													></font
												></font
											></span
										></font
									></span
								>
							</p>
						</li>
					</ol>
				</ol>
			</ol>
		</ol>
	</ol>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>In Google Analytics ist die Funktion „IP-Anonymisierung“ integriert. Dadurch wird Deine IP-Adresse
										von Google innerhalb von Mitgliedstaaten der Europäischen Union oder in anderen Vertragsstaaten des
										Abkommens über den Europäischen Wirtschaftsraum vor der Übermitt-lung in die USA gekürzt. Nur in
										Ausnahmefällen wird die volle IP-Adresse an einen Server von Google in den USA übertragen und erst
										dort gekürzt.</span
									></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<ol type="A">
		<ol type="I">
			<ol>
				<ol type="a">
					<ol type="a" start="27">
						<li>
							<p
								align="justify"
								style="
									line-height: 120%;
									page-break-inside: auto;
									orphans: 0;
									widows: 0;
									margin-top: 0.24in;
									margin-bottom: 0.04in;
									border: none;
									padding: 0in;
									background: transparent;
									page-break-before: auto;
									page-break-after: auto;
								"
							>
								<span style="font-variant: normal"
									><font color="#000000"
										><span style="text-decoration: none"
											><font face="Arial"
												><font size="2" style="font-size: 11pt"
													><span style="font-style: normal"
														><b
															><span style="background: transparent"
																>Deaktivierung von Google Analytics</span
															></b
														></span
													></font
												></font
											></span
										></font
									></span
								>
							</p>
						</li>
					</ol>
				</ol>
			</ol>
		</ol>
	</ol>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Du kannst Google Analytics deaktivieren, indem Du bei der Cookie-Auswahl für unsere Webseite unter
										Cookie-Einstellungen „Analyse und Werbung“ deaktivierst oder indem Du das unter dem folgenden Link
										verfügbare Browser-Plugin von Google herunterlädst und installierst:
									</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		><a href="https://tools.google.com/dlpage/gaoptout?hl=de" role="link"
			><span style="font-variant: normal"
				><font color="#0000ff"
					><span style="text-decoration: none"
						><font face="Arial"
							><font size="2" style="font-size: 11pt"
								><span style="font-style: normal"
									><u
										><span style="font-weight: normal"
											><span style="background: transparent"
												>https://tools.google.com/dlpage/gaoptout?hl=de</span
											></span
										></u
									></span
								></font
							></font
						></span
					></font
				></span
			></a
		><span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"><span style="background: transparent">.</span></span></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<ol type="A">
		<ol type="I">
			<ol>
				<ol type="a" start="2">
					<li>
						<p
							align="justify"
							style="
								line-height: 120%;
								page-break-inside: auto;
								orphans: 0;
								widows: 0;
								margin-top: 0.24in;
								margin-bottom: 0.04in;
								border: none;
								padding: 0in;
								background: transparent;
								page-break-before: auto;
								page-break-after: avoid;
							"
						>
							<span style="font-variant: normal"
								><font color="#000000"
									><span style="text-decoration: none"
										><font face="Arial"
											><font size="2" style="font-size: 11pt"
												><span style="font-style: normal"
													><b><span style="background: transparent">Google Tag Manager</span></b></span
												></font
											></font
										></span
									></font
								></span
							>
						</p>
					</li>
				</ol>
			</ol>
		</ol>
	</ol>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Wir nutzen das Webdesign-Tool „Google Tag Manager“. Datenschutzrechtlich verantwortlicher Anbieter
										für dieses Tool ist
									</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><b><span style="background: transparent">Google Ireland Limited</span></b></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent">Gordon House, Barrow Street</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent">Dublin 4, IRLAND.</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			font-variant: normal;
			font-style: normal;
			font-weight: normal;
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			text-decoration: none;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<br />
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Google Tag Manager ermöglicht uns, sog. Webseiten-Tags über eine gemeinsame Oberfläche zu
										implementieren und zu verwalten. Das Tool verwendet eine Cookie-lose Domain und erfasst selbst keine
										personenbezogenen Daten, sondern sorgt für die Auslösung anderer Tags, die ihrerseits unter
										Umständen Daten erfassen. Google Tag Manager greift nicht auf diese Daten zu. Wenn Du auf Domain-
										oder Cookie-Ebene die entsprechenden Dienste deaktiviert hast, wirkt dies für alle Tags fort, die
										mit Google Tag Manager implementiert werden.</span
									></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p>Die Verarbeitung der personenbezogenen Daten erfolgt auf Grundlage Deiner Einwilligung (Art. 6 Abs. 1 lit. a DSGVO).</p>
	<ol type="A">
		<ol type="I">
			<ol>
				<ol type="a" start="3">
					<li>
						<p
							align="justify"
							style="
								line-height: 120%;
								page-break-inside: auto;
								orphans: 0;
								widows: 0;
								margin-top: 0.24in;
								margin-bottom: 0.04in;
								border: none;
								padding: 0in;
								background: transparent;
								page-break-before: auto;
								page-break-after: avoid;
							"
						>
							<span style="font-variant: normal"
								><font color="#000000"
									><span style="text-decoration: none"
										><font face="Arial"
											><font size="2" style="font-size: 11pt"
												><span style="font-style: normal"
													><b><span style="background: transparent">Google Firebase</span></b></span
												></font
											></font
										></span
									></font
								></span
							>
						</p>
					</li>
				</ol>
			</ol>
		</ol>
	</ol>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Wir nutzen den Dienst „Google Firebase“ des datenschutzrechtlich verantwortlichen Anbieters</span
									></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><b><span style="background: transparent">Google Ireland Limited</span></b></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent">Gordon House, Barrow Street</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent">Dublin 4, IRLAND.</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			font-variant: normal;
			font-style: normal;
			font-weight: normal;
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			text-decoration: none;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<br />
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Google Firebase verwendet Tracking-Technologien. Hierdurch wird eine Analyse Deiner Nutzung der
										Webseite ermöglicht, bspw. durch Mitteilung von Crash- und Kommunikationsdaten. Mit Firebase werden
										Informationen über die Benutzung unserer Webseite erfasst. Diese werden an Google Ireland Limited
										(im Folgenden: Google) übertragen und von Google gespeichert. Dabei kann es zu Übertragungen in
										Drittländer (z.B. USA) kommen.</span
									></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p>Google verarbeitet folgende personenbezogene Daten:</p>
	<ul>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent"
												>Meta-/Kommunikationsdaten (z.B. Geräte-Informationen, IP-Adressen)</span
											></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent"
												>Crashdaten (z.B. fehlgeschlagener Code, Installations-ID)</span
											></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent"
												>Remotekonfigurationsdaten (z.B. aktivieren/deaktiveren von Features)</span
											></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
	</ul>
	<p>Die erhobenen personenbezogenen Daten werden für maximal 90 Tage gespeichert.</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Wir haben ein berechtigtes Interesse (Art. 6 Abs. 1 lit. f DSGVO) daran, Google Firebase für eine
										detaillierte Fehleranalyse in unserer Webseite einzubinden sowie technische Features zu de- und
										aktivieren.<!-- Nur auf Einwilligungsbasis, hier agieren! --></span
									></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<ol type="A">
		<ol type="I">
			<ol start="2">
				<li>
					<p
						align="justify"
						style="
							line-height: 120%;
							page-break-inside: auto;
							orphans: 0;
							widows: 0;
							margin-top: 0.24in;
							margin-bottom: 0.04in;
							border: none;
							padding: 0in;
							background: transparent;
							page-break-before: auto;
							page-break-after: avoid;
						"
					>
						<span style="font-variant: normal"
							><font color="#000000"
								><span style="text-decoration: none"
									><font face="Arial"
										><font size="2" style="font-size: 11pt"
											><span style="font-style: normal"
												><b><span style="background: transparent">Newsletter und CRM-System</span></b></span
											></font
										></font
									></span
								></font
							></span
						>
					</p>
				</li>
			</ol>
		</ol>
	</ol>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Wir nutzen den Dienst „Braze“. Braze ist ein Dienst, mit dem u.a. der Versand von Newslettern
										organisiert und analysiert werden kann. Zudem nutzen wir Braze für unser Customer Relationship
										Management (CRM).</span
									></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Datenschutzrechtlich verantwortlicher Anbieter für diesen Dienst ist</span
									></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><b><span style="background: transparent">Braze, Inc.</span></b></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent">63 Madison Avenue, 13th Floor, </span></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent">New York, NY 10016, USA</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			font-variant: normal;
			font-style: normal;
			font-weight: normal;
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			text-decoration: none;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<br />
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Braze, Inc. verarbeitet folgende personenbezogene Daten:</span
									></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<ul>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent">E-Mail-Adresse</span></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent">Interaktionsdaten</span></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent">IP-Adresse</span></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent">Push-Tokens</span></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent">Gerätedaten</span></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent">User-ID-Daten</span></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
	</ul>
	<p
		align="justify"
		style="
			font-variant: normal;
			font-style: normal;
			font-weight: normal;
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-left: 0.25in;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			text-decoration: none;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<br />
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Wenn Du Daten eingibst, um unseren Newsletter zu beziehen (z.B. Deine E-Mail-Adresse), werden diese
										auf den Servern von Braze, Inc. in den USA gespeichert. Mit Braze, Inc. haben wir einen
										Auftragsverarbeitungsvertrag gem. Art. 28 DSGVO geschlossen. Weitere Informationen findest Du in den
										Datenschutzhinweisen von Braze unter
									</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		><a href="https://www.braze.com/company/legal/privacy/" role="link"
			><span style="font-variant: normal"
				><font color="#0000ff"
					><span style="text-decoration: none"
						><font face="Arial"
							><font size="2" style="font-size: 11pt"
								><span style="font-style: normal"
									><u
										><span style="font-weight: normal"
											><span style="background: transparent">https://www.braze.com/company/legal/privacy/</span></span
										></u
									></span
								></font
							></font
						></span
					></font
				></span
			></a
		><span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"><span style="background: transparent">.</span></span></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Die Verarbeitung Deiner personenbezogenen Daten durch Braze, Inc. erfolgt auf Grundlage Deiner
										Einwilligung (Art. 6 Abs. 1 lit. a DSGVO) im Zuge der Anmeldung für unseren Newsletter. Wenn Du
										keine Analyse durch Braze, Inc. willst, musst Du den Newsletter abbestellen. Dazu kannst Du den in
										jedem Newsletter enthaltenen Link verwenden.</span
									></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Die Datenerhebung und Erfassung in unserem CRM findet grundsätzlich auf Basis unseres berechtigten
										Interesses (Art. 6 Abs. 1 lit. f DSGVO) statt. Unser berechtigtes Interesse besteht daran, dass wir
										mit Dir in Kontakt bleiben und kommunizieren können. Hierdurch können wir unsere Dienstleistungen
										erbringen und Dich als Kunden betreuen. Sofern dies im Rahmen von Vertragsanbahnungen und
										Vertragsdurchführungen erfolgt, basiert die Datenverarbeitung auf Art. 6 Abs. 1 lit. b DSGVO
										(Vertragserfüllung).</span
									></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<ol type="A">
		<ol type="I">
			<ol start="3">
				<li>
					<p
						align="justify"
						style="
							line-height: 120%;
							page-break-inside: auto;
							orphans: 0;
							widows: 0;
							margin-top: 0.24in;
							margin-bottom: 0.04in;
							border: none;
							padding: 0in;
							background: transparent;
							page-break-before: auto;
							page-break-after: avoid;
						"
					>
						<a name="_heading=h.30j0zll" role="link"></a>
						<span style="font-variant: normal"
							><font color="#000000"
								><span style="text-decoration: none"
									><font face="Arial"
										><font size="2" style="font-size: 11pt"
											><span style="font-style: normal"
												><b><span style="background: transparent">Zahlungsabwicklung</span></b></span
											></font
										></font
									></span
								></font
							></span
						>
					</p>
					<ol type="a">
						<li>
							<p
								align="justify"
								style="
									line-height: 120%;
									page-break-inside: auto;
									orphans: 0;
									widows: 0;
									margin-top: 0.24in;
									margin-bottom: 0.04in;
									border: none;
									padding: 0in;
									background: transparent;
									page-break-before: auto;
									page-break-after: avoid;
								"
							>
								<span style="font-variant: normal"
									><font color="#000000"
										><span style="text-decoration: none"
											><font face="Arial"
												><font size="2" style="font-size: 11pt"
													><span style="font-style: normal"
														><b><span style="background: transparent">Allgemeines</span></b></span
													></font
												></font
											></span
										></font
									></span
								>
							</p>
						</li>
					</ol>
				</li>
			</ol>
		</ol>
	</ol>
	<p>
		Wenn Du mit dem jeweiligen dean &amp; david-Store über unsere Webseite einen kostenpflichtigen Vertrag abschließt (z.B. über den
		Erwerb einer Box), benötigen wir gewisse Daten von Dir für die Zahlungsabwicklung:
	</p>
	<ul>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent">Vor- und Nachname</span></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"><span style="background: transparent">E-Mail</span></span></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent">Telefonnummer</span></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent">Liefer-/Rechnungsadresse</span></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
	</ul>
	<p>
		Rechtsgrundlage der Datenverarbeitung ist insoweit Art. 6 Abs. 1 lit. b DSGVO (Verarbeitung zur Erfüllung eines Vertrags). Die
		Zahlungsabwicklung erfolgt mit dem jeweiligen Store-Betreiber. Weitere Hinweise kannst Du der Datenschutzerklärung des jeweiligen
		Store-Betreibers entnehmen.
	</p>
	<p>
		Die Zahlungsabwicklung erfolgt ausschließlich über eine verschlüsselte SSL- bzw. TLS-Verbindung. Eine verschlüsselte Verbindung
		erkennst Du daran, dass die Adresszeile des Browsers nicht &quot;http://“, sondern &quot;https://&quot; anzeigt und an dem
		Schloss-Symbol in Deiner Browserzeile. Bei verschlüsselter Kommunikation können Deine Zahlungsdaten, die Du an uns übermittelst,
		nicht von Dritten mitgelesen werden.
	</p>
	<p>
		Die jeweiligen Store-Betreiber setzen für die Zahlungsabwicklung die nachfolgend genannten Dienstleister ein. Du kannst Deine
		Bestellung (soweit angegeben) auch im dean &amp; david-Store bezahlen. Die Verarbeitung erfolgt zum Zwecke der Zahlungsabwicklung
		gem. Art. 6 Abs. 1 lit. b DSGVO. Soweit Du uns Deine Einwilligung erteilst, erfolgt die Datenverarbeitung auf Grundlage Deiner
		Einwilligung gem. Art. 6 Abs. 1 lit.&nbsp;a DSGVO.
	</p>
	<ol type="A">
		<ol type="I">
			<ol>
				<ol type="a" start="2">
					<li>
						<p
							align="justify"
							style="
								line-height: 120%;
								page-break-inside: auto;
								orphans: 0;
								widows: 0;
								margin-top: 0.24in;
								margin-bottom: 0.04in;
								border: none;
								padding: 0in;
								background: transparent;
								page-break-before: auto;
								page-break-after: avoid;
							"
						>
							<a name="_heading=h.1fob9te"></a>
							<span style="font-variant: normal"
								><font color="#000000"
									><span style="text-decoration: none"
										><font face="Arial"
											><font size="2" style="font-size: 11pt"
												><span style="font-style: normal"
													><b><span style="background: transparent">Worldline und Pay-Jet</span></b></span
												></font
											></font
										></span
									></font
								></span
							>
						</p>
					</li>
				</ol>
			</ol>
		</ol>
	</ol>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent">Die Bezahlmethode „Worldline“ wird abgewickelt von </span></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="left"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><b><span style="background: transparent">Worldline S.A.</span></b></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"><span style="background: transparent">Tour Voltaire</span></span></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent">1 place des degrés</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"><span style="background: transparent">CS 81162</span></span></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent">92059 Paris La Défense Cedex, FRANKREICH.</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			font-variant: normal;
			font-style: normal;
			font-weight: normal;
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			text-decoration: none;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<br />
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Worldline S.A. (im Folgenden Wordline) erhält personenbezogene und zahlungsrelevante Daten von Dir,
										die für die Abwicklung der Transaktion erforderlich sind. Hierfür wird ein Cookie (Ziff. IV.2). in
										Deinem Browser gespeichert Diese Informationen werden auch an Dein Bankinstitut oder Deine
										Kreditkartengesellschaft übermittelt. Nähere Informationen zu Worldline erhältst Du unter
									</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		><a href="https://financial-services.worldline.com/en/home/solutions/digital-services/payment-services.html" role="link"
			><span style="font-variant: normal"
				><font color="#0000ff"
					><span style="text-decoration: none"
						><font face="Arial"
							><font size="2" style="font-size: 11pt"
								><span style="font-style: normal"
									><u
										><span style="font-weight: normal"
											><span style="background: transparent"
												>https://financial-services.worldline.com/en/home/solutions/digital-services/payment-services.html</span
											></span
										></u
									></span
								></font
							></font
						></span
					></font
				></span
			></a
		><span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"><span style="background: transparent">.</span></span></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			font-variant: normal;
			font-style: normal;
			font-weight: normal;
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			text-decoration: none;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<br />
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Die Datenschutzhinweise von Worldline S.A. findest Du unter
									</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		><a href="https://worldline.com/de-de/compliancy/privacy" role="link"
			><span style="font-variant: normal"
				><font color="#0000ff"
					><span style="text-decoration: none"
						><font face="Arial"
							><font size="2" style="font-size: 11pt"
								><span style="font-style: normal"
									><u
										><span style="font-weight: normal"
											><span style="background: transparent"
												>https://worldline.com/de-de/compliancy/privacy</span
											></span
										></u
									></span
								></font
							></font
						></span
					></font
				></span
			></a
		><span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>. Die Sicherheitsanforderungen von Worldline findest Du unter
									</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		><a
			href="https://payment.preprod.direct.worldline-solutions.com/hostedcheckout/SecurityContent/Get/b9c2968e57a848dd9e2b5defdd6636fc"
			role="link"
			aria-label="Worldline Solutions Payment"
			><span style="font-variant: normal"
				><font color="#0000ff"
					><span style="text-decoration: none"
						><font face="Arial"
							><font size="2" style="font-size: 11pt"
								><span style="font-style: normal"
									><u
										><span style="font-weight: normal"
											><span style="background: transparent"
												>https://payment.preprod.direct.worldline-solutions.com/hostedcheckout/SecurityContent/Get/b9c2968e57a848dd9e2b5defdd6636fc</span
											></span
										></u
									></span
								></font
							></font
						></span
					></font
				></span
			></a
		><span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"><span style="background: transparent">.</span></span></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p style="line-height: 100%; margin-bottom: 0in"><br /></p>
	<p>
		Wir übermitteln bei dem Zahlungsvorgang Deine Zahlungsdaten über eine gesicherte https-Verbindung an den Server von Worldline. Für
		den Zahlungsvorgang wirst Du auf eine Webseite von Worldline weitergeleitet. Eine Übermittlung der Daten erfolgt ausschließlich für
		die reibungslose Abwicklung Deiner Zahlung. Hierfür werden Cookies (Ziff. IV.2.) in Deinem Endgerät gespeichert.
	</p>
	<p>Worldline nutzt als Payment-Service-Provider für die Zahlungsabwicklung die</p>
	<p style="line-height: 100%; margin-bottom: 0in"><b>Pay-Jet GmbH</b></p>
	<p style="line-height: 100%; margin-bottom: 0in">Rumfordstraße 42</p>
	<p style="line-height: 100%; margin-bottom: 0in">80469 München, DEUTSCHLAND</p>
	<p style="line-height: 100%; margin-bottom: 0in">(im Folgenden „Pay-Jet“).</p>
	<p style="line-height: 100%; margin-bottom: 0in"><br /></p>
	<p>
		Unsere Franchisenehmer, die dean&amp;david-Stores, haben mit den Pay-Jet GmbH einen Auftragsverarbeitungsvertrag nach Art. 28 DSGVO
		geschlossen. Die Datenschutzbestimmungen von Pay-Jet findest Du unter
		<a href="https://www.pay-jet.de/privacy-policy" role="link"
			><font color="#0000ff"><u>https://www.pay-jet.de/privacy-policy</u></font></a
		>. Die Datenschutzinformationen für Karteninhaber findest Du unter
		<a href="https://www.pay-jet.de/data-processing" role="link"
			><font color="#0000ff"><u>https://www.pay-jet.de/data-processing</u></font></a
		>.
	</p>
	<p>Der Payment-Service-Provider Pay-Jet ermöglicht Dir mehrere Bezahlmöglichkeiten. Eine Bezahlung kann über</p>
	<ul>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent">American Express</span></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent">Diners Club</span></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent">MasterCard</span></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent">Google Pay</span></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"><span style="background: transparent">JCB</span></span></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent">Apple Pay</span></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent">Maestro </span></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent">Visa und </span></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent"
												>PayPal
												<!-- Ist das Store abhängig? Die Auflistung habe ich von der Testwebseite, ist so aber nicht vorhanden; Sicherheitshalber lasse ich es in der vorläufigen Version drin. --></span
											></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
	</ul>
	<p>
		durchgeführt werden. Hierfür leitet Pay-Jet Deine Daten an das Kartenzahlungssystem bzw. Deine Kreditkartenorganisation weiter.
		Dieses kann sich gegebenenfalls außerhalb der EU oder des EWR befinden. Dies ist zur Autorisierung und Ausführung deiner Zahlung
		erforderlich. Weder wir noch unsere dean &amp; david-Stores sind datenschutzrechtlich für die Weitergabe der Daten an die jeweiligen
		Kartenzahlungsdienste verantwortlich, erläutern Dir aber nachfolgend die Weitergabe Deiner Daten zur besseren Verständlichkeit.
	</p>
	<ol type="A">
		<ol type="I">
			<ol>
				<ol type="a">
					<ol type="a" start="27">
						<li>
							<p
								align="justify"
								style="
									line-height: 120%;
									page-break-inside: auto;
									orphans: 0;
									widows: 0;
									margin-top: 0.24in;
									margin-bottom: 0.04in;
									border: none;
									padding: 0in;
									background: transparent;
									page-break-before: auto;
									page-break-after: auto;
								"
							>
								<span style="font-variant: normal"
									><font color="#000000"
										><span style="text-decoration: none"
											><font face="Arial"
												><font size="2" style="font-size: 11pt"
													><span style="font-style: normal"
														><b><span style="background: transparent">American Express</span></b></span
													></font
												></font
											></span
										></font
									></span
								>
							</p>
						</li>
					</ol>
				</ol>
			</ol>
		</ol>
	</ol>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Bei Auswahl der Bezahlmethode „American Express“ erfolgt eine Weitergabe Deiner Daten an</span
									></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><b><span style="background: transparent">American Express Payment Services Ltd.</span></b></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent">Zweigniederlassung Frankfurt am Main,</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent">Theodor-Heuss-Allee 112, </span></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent">60486 Frankfurt am Main, DEUTSCHLAND.</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			font-variant: normal;
			font-style: normal;
			font-weight: normal;
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			text-decoration: none;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<br />
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Die Datenschutzhinweise zu dieser Zahlungsmethode findest Du unter
									</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		><a href="http://www.americanexpress.de/datenschutz" role="link"
			><span style="font-variant: normal"
				><font color="#0000ff"
					><span style="text-decoration: none"
						><font face="Arial"
							><font size="2" style="font-size: 11pt"
								><span style="font-style: normal"
									><u
										><span style="font-weight: normal"
											><span style="background: transparent">www.americanexpress.de/datenschutz</span></span
										></u
									></span
								></font
							></font
						></span
					></font
				></span
			></a
		><span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"><span style="background: transparent">.</span></span></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<ol type="A">
		<ol type="I">
			<ol>
				<ol type="a">
					<ol type="a" start="27">
						<li>
							<p
								align="justify"
								style="
									line-height: 120%;
									page-break-inside: auto;
									orphans: 0;
									widows: 0;
									margin-top: 0.24in;
									margin-bottom: 0.04in;
									border: none;
									padding: 0in;
									background: transparent;
									page-break-before: auto;
									page-break-after: auto;
								"
							>
								<span style="font-variant: normal"
									><font color="#000000"
										><span style="text-decoration: none"
											><font face="Arial"
												><font size="2" style="font-size: 11pt"
													><span style="font-style: normal"
														><b><span style="background: transparent">Diners Club</span></b></span
													></font
												></font
											></span
										></font
									></span
								>
							</p>
						</li>
					</ol>
				</ol>
			</ol>
		</ol>
	</ol>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Bei Auswahl der Bezahlmethode „Diners Club“ erfolgt eine Weitergabe Deiner Daten an</span
									></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><b><span style="background: transparent">Diners Club International Ltd.</span></b></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><span style="background: transparent">
						<font face="Arial"
							><font size="2" style="font-size: 11pt"
								><span style="font-style: normal"
									><span style="font-weight: normal">2500 Lake Cook Road, </span></span
								></font
							></font
						></span
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent">Riverwoods,IL 60016, USA.</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			font-variant: normal;
			font-style: normal;
			font-weight: normal;
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			text-decoration: none;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<br />
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Die Datenschutzhinweise zu dieser Zahlungsmethode findest Du unter
										https://www.dinersclub.com/privacy-policy.</span
									></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<ol type="A">
		<ol type="I">
			<ol>
				<ol type="a">
					<ol type="a" start="27">
						<li>
							<p
								align="justify"
								style="
									line-height: 120%;
									page-break-inside: auto;
									orphans: 0;
									widows: 0;
									margin-top: 0.24in;
									margin-bottom: 0.04in;
									border: none;
									padding: 0in;
									background: transparent;
									page-break-before: auto;
									page-break-after: auto;
								"
							>
								<span style="font-variant: normal"
									><font color="#000000"
										><span style="text-decoration: none"
											><font face="Arial"
												><font size="2" style="font-size: 11pt"
													><span style="font-style: normal"
														><b><span style="background: transparent">Mastercard / Maestro</span></b></span
													></font
												></font
											></span
										></font
									></span
								>
							</p>
						</li>
					</ol>
				</ol>
			</ol>
		</ol>
	</ol>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Bei Auswahl der Bezahlmethode „MasterCard“ und „Maestro“ erfolgt eine Weitergabe Deiner Daten
										an</span
									></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><b><span style="background: transparent">MasterCard Europe SPRL</span></b></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent">Chaussée de Tervuren 198A,</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent">1410 Waterloo, BELGIEN.</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			font-variant: normal;
			font-style: normal;
			font-weight: normal;
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			text-decoration: none;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<br />
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Die Datenschutzhinweise zu dieser Zahlungsmethode findest Du unter
										https://www.mastercard.de/de-de/datenschutz.html.</span
									></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<ol type="A">
		<ol type="I">
			<ol>
				<ol type="a">
					<ol type="a" start="27">
						<li>
							<p
								align="justify"
								style="
									line-height: 120%;
									page-break-inside: auto;
									orphans: 0;
									widows: 0;
									margin-top: 0.24in;
									margin-bottom: 0.04in;
									border: none;
									padding: 0in;
									background: transparent;
									page-break-before: auto;
									page-break-after: auto;
								"
							>
								<span style="font-variant: normal"
									><font color="#000000"
										><span style="text-decoration: none"
											><font face="Arial"
												><font size="2" style="font-size: 11pt"
													><span style="font-style: normal"
														><b><span style="background: transparent">Google Pay</span></b></span
													></font
												></font
											></span
										></font
									></span
								>
							</p>
						</li>
					</ol>
				</ol>
			</ol>
		</ol>
	</ol>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Die Auswahl der Bezahlmethode „Google Pay“ erfolgt eine Weitergabe Deiner Daten an</span
									></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><b><span style="background: transparent">Google Ireland Limited</span></b></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent">Gordon House, Barrow Street</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent">Dublin 4, IRLAND.</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			font-variant: normal;
			font-style: normal;
			font-weight: normal;
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			text-decoration: none;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<br />
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Nach der Registrierung einer EC- oder Kreditkarte ermöglicht es Google Pay, Bezahlungen direkt mit
										einem Android-Mobiltelefon durchzuführen.</span
									></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Weitere Informationen findest Du in den Datenschutzhinweisen von Google unter:
										https://policies.google.com/privacy sowie unter
									</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		><a href="https://payments.google.com/payments/apis-secure/get_legal_document?ldo=0&amp;ldt=privacynotice&amp;ldl=de" role="link"
			><span style="font-variant: normal"
				><font color="#0000ff"
					><span style="text-decoration: none"
						><font face="Arial"
							><font size="2" style="font-size: 11pt"
								><span style="font-style: normal"
									><u
										><span style="font-weight: normal"
											><span style="background: transparent"
												>https://payments.google.com/payments/apis-secure/get_legal_document?ldo=0&amp;ldt=privacynotice&amp;ldl=de</span
											></span
										></u
									></span
								></font
							></font
						></span
					></font
				></span
			></a
		><span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>. Die Nutzungsbedingungen von Google Pay findest Du unter
									</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		><a href="https://payments.google.com/payments/apis-secure/get_legal_document?ldo=0&amp;ldt=googlepaytos&amp;ldl=de" role="link"
			><span style="font-variant: normal"
				><font color="#0000ff"
					><span style="text-decoration: none"
						><font face="Arial"
							><font size="2" style="font-size: 11pt"
								><span style="font-style: normal"
									><u
										><span style="font-weight: normal"
											><span style="background: transparent"
												>https://payments.google.com/payments/apis-secure/get_legal_document?ldo=0&amp;ldt=googlepaytos&amp;ldl=de</span
											></span
										></u
									></span
								></font
							></font
						></span
					></font
				></span
			></a
		><span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"><span style="background: transparent">.</span></span></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<ol type="A">
		<ol type="I">
			<ol>
				<ol type="a">
					<ol type="a" start="27">
						<li>
							<p
								align="justify"
								style="
									line-height: 120%;
									page-break-inside: auto;
									orphans: 0;
									widows: 0;
									margin-top: 0.24in;
									margin-bottom: 0.04in;
									border: none;
									padding: 0in;
									background: transparent;
									page-break-before: auto;
									page-break-after: auto;
								"
							>
								<span style="font-variant: normal"
									><font color="#000000"
										><span style="text-decoration: none"
											><font face="Arial"
												><font size="2" style="font-size: 11pt"
													><span style="font-style: normal"
														><b><span style="background: transparent">JCB</span></b></span
													></font
												></font
											></span
										></font
									></span
								>
							</p>
						</li>
					</ol>
				</ol>
			</ol>
		</ol>
	</ol>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Bei Auswahl der Bezahlmethode „JCB“ erfolgt eine Weitergabe Deiner Daten an
									</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><b><span style="background: transparent">JCB International Co., Ltd.,</span></b></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent">5-1-22, Minami Aoyama, Minato-Ku, </span></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"><span style="background: transparent">Tokio, JAPAN.</span></span></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			font-variant: normal;
			font-style: normal;
			font-weight: normal;
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			text-decoration: none;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<br />
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Die Datenschutzhinweise zu dieser Zahlungsmethode findest Du unter
										http://www.jcbeurope.eu/privacy/</span
									></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<ol type="A">
		<ol type="I">
			<ol>
				<ol type="a">
					<ol type="a" start="27">
						<li>
							<p
								align="justify"
								style="
									line-height: 120%;
									page-break-inside: auto;
									orphans: 0;
									widows: 0;
									margin-top: 0.24in;
									margin-bottom: 0.04in;
									border: none;
									padding: 0in;
									background: transparent;
									page-break-before: auto;
									page-break-after: auto;
								"
							>
								<span style="font-variant: normal"
									><font color="#000000"
										><span style="text-decoration: none"
											><font face="Arial"
												><font size="2" style="font-size: 11pt"
													><span style="font-style: normal"
														><b><span style="background: transparent">Apple Pay</span></b></span
													></font
												></font
											></span
										></font
									></span
								>
							</p>
						</li>
					</ol>
				</ol>
			</ol>
		</ol>
	</ol>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent">Die Bezahlmethode „Apple Pay“ wird abgewickelt von</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><b><span style="background: transparent">Apple Distribution International Limited </span></b></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent">Hollyhill Industrial Estate, </span></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent">Hollyhill, Cork, T23 YK84, IRLAND </span></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			font-variant: normal;
			font-style: normal;
			font-weight: normal;
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			text-decoration: none;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<br />
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Nach der Registrierung einer EC- oder Kreditkarte ermöglicht es Apple Pay, Bezahlungen direkt mit
										einem iPhone iOS, watchOS oder macOS betriebenen Endgeräts durchzuführen. Hierfür werden durch Apple
										zur Durchführung der Transaktionen personenbezogene Daten (unter anderem Name, Rechnungsadresse,
										Geräte-ID und Telefonnummer) verarbeitet.</span
									></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Weitere Informationen findest Du in der Datenschutzerklärung von Apple unter
									</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		><a href="https://www.apple.com/de/legal/privacy/data/de/apple-pay/" role="link"
			><span style="font-variant: normal"
				><font color="#0000ff"
					><span style="text-decoration: none"
						><font face="Arial"
							><font size="2" style="font-size: 11pt"
								><span style="font-style: normal"
									><u
										><span style="font-weight: normal"
											><span style="background: transparent"
												>https://www.apple.com/de/legal/privacy/data/de/apple-pay/</span
											></span
										></u
									></span
								></font
							></font
						></span
					></font
				></span
			></a
		><span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"><span style="background: transparent">.</span></span></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<ol type="A">
		<ol type="I">
			<ol>
				<ol type="a">
					<ol type="a" start="27">
						<li>
							<p
								align="justify"
								style="
									line-height: 120%;
									page-break-inside: auto;
									orphans: 0;
									widows: 0;
									margin-top: 0.24in;
									margin-bottom: 0.04in;
									border: none;
									padding: 0in;
									background: transparent;
									page-break-before: auto;
									page-break-after: auto;
								"
							>
								<span style="font-variant: normal"
									><font color="#000000"
										><span style="text-decoration: none"
											><font face="Arial"
												><font size="2" style="font-size: 11pt"
													><span style="font-style: normal"
														><b><span style="background: transparent">Visa</span></b></span
													></font
												></font
											></span
										></font
									></span
								>
							</p>
						</li>
					</ol>
				</ol>
			</ol>
		</ol>
	</ol>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Bei Auswahl der Bezahlmethode „Visa“ erfolgt eine Weitergabe Deiner Daten an</span
									></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent">Visa Europe Services LLC, </span></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent">eingetragen in Delaware USA, </span></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent">London, 1 Sheldon Square, </span></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent">London W2 6TT, UK.</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			font-variant: normal;
			font-style: normal;
			font-weight: normal;
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			text-decoration: none;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<br />
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Weitere Informationen findest Du in der Datenschutzerklärung unter
										https://www.visa.co.uk/privacy/.</span
									></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<ol type="A">
		<ol type="I">
			<ol>
				<ol type="a" start="3">
					<li>
						<p
							align="justify"
							style="
								line-height: 120%;
								page-break-inside: auto;
								orphans: 0;
								widows: 0;
								margin-top: 0.24in;
								margin-bottom: 0.04in;
								border: none;
								padding: 0in;
								background: transparent;
								page-break-before: auto;
								page-break-after: avoid;
							"
						>
							<span style="font-variant: normal"
								><font color="#000000"
									><span style="text-decoration: none"
										><font face="Arial"
											><font size="2" style="font-size: 11pt"
												><span style="font-style: normal"
													><b><span style="background: transparent">PayPal</span></b></span
												></font
											></font
										></span
									></font
								></span
							>
						</p>
					</li>
				</ol>
			</ol>
		</ol>
	</ol>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent">Die Bezahlmethode „PayPal“ wird abgewickelt von</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><b><span style="background: transparent">PayPal (Europe) S.à.r.l. et Cie, S.C.A.</span></b></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent">22-24 Boulevard Royal</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent">L-2449, LUXEMBURG</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			font-variant: normal;
			font-style: normal;
			font-weight: normal;
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-left: 0.79in;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			text-decoration: none;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<br />
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Nach der Eröffnung eines E-Wallets auf der Internetseite von PayPal und der Verknüpfung mit einem
										bestehenden Bankkonto ermöglicht es PayPal, Bezahlungen über einen Internet-Browser oder mittels
										Mobiltelefon-App durchzuführen. Hierfür werden durch PayPal zur Durchführung der Transaktion
										personenbezogene Daten, in der Regel Name, Anschrift, Telefonnummer, E-Mail und Kontonummer erhoben.
										Es werden auch Informationen über die Transaktion erhoben. Hierunter der Zahlungsbetrag, die
										Geräteinformation, die technischen Nutzungsdaten und Deine Geolokalisationsdaten. Hierfür werden
										Cookies (Ziff. IV.2.) in Deinem Browser gesetzt.
									</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Weitere Informationen findest Du in der PayPal-Datenschutzerklärung unter
									</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		><a href="https://www.paypal.com/de/webapps/mpp/ua/privacy-full"
			><span style="font-variant: normal"
				><font color="#0000ff"
					><span style="text-decoration: none"
						><font face="Arial"
							><font size="2" style="font-size: 11pt"
								><span style="font-style: normal"
									><u
										><span style="font-weight: normal"
											><span style="background: transparent"
												>https://www.paypal.com/de/webapps/mpp/ua/privacy-full</span
											></span
										></u
									></span
								></font
							></font
						></span
					></font
				></span
			></a
		><span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"><span style="background: transparent">.</span></span></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<ol type="A">
		<ol type="I">
			<ol>
				<ol type="a" start="4">
					<li>
						<p
							align="justify"
							style="
								line-height: 120%;
								page-break-inside: auto;
								orphans: 0;
								widows: 0;
								margin-top: 0.24in;
								margin-bottom: 0.04in;
								border: none;
								padding: 0in;
								background: transparent;
								page-break-before: auto;
								page-break-after: avoid;
							"
						>
							<span style="font-variant: normal"
								><font color="#000000"
									><span style="text-decoration: none"
										><font face="Arial"
											><font size="2" style="font-size: 11pt"
												><span style="font-style: normal"
													><b><span style="background: transparent">Google Pay</span></b></span
												></font
											></font
										></span
									></font
								></span
							>
						</p>
					</li>
				</ol>
			</ol>
		</ol>
	</ol>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent">Die Bezahlmethode „Google Pay“ wird abgewickelt von</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><b><span style="background: transparent">Google Ireland Limited</span></b></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent">Gordon House, Barrow Street</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent">Dublin 4, IRLAND.</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			font-variant: normal;
			font-style: normal;
			font-weight: normal;
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			text-decoration: none;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<br />
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Nach der Registrierung einer EC- oder Kreditkarte ermöglicht es Google Pay, Bezahlungen direkt mit
										einem Android-Mobiltelefon durchzuführen.</span
									></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Weitere Informationen findest Du in den Datenschutzhinweisen von Google unter:
										https://policies.google.com/privacy sowie unter
									</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		><a href="https://payments.google.com/payments/apis-secure/get_legal_document?ldo=0&amp;ldt=privacynotice&amp;ldl=de" role="link"
			><span style="font-variant: normal"
				><font color="#0000ff"
					><span style="text-decoration: none"
						><font face="Arial"
							><font size="2" style="font-size: 11pt"
								><span style="font-style: normal"
									><u
										><span style="font-weight: normal"
											><span style="background: transparent"
												>https://payments.google.com/payments/apis-secure/get_legal_document?ldo=0&amp;ldt=privacynotice&amp;ldl=de</span
											></span
										></u
									></span
								></font
							></font
						></span
					></font
				></span
			></a
		><span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>. Die Nutzungsbedingungen von Google Pay findest Du unter
									</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		><a href="https://payments.google.com/payments/apis-secure/get_legal_document?ldo=0&amp;ldt=googlepaytos&amp;ldl=de" role="link"
			><span style="font-variant: normal"
				><font color="#0000ff"
					><span style="text-decoration: none"
						><font face="Arial"
							><font size="2" style="font-size: 11pt"
								><span style="font-style: normal"
									><u
										><span style="font-weight: normal"
											><span style="background: transparent"
												>https://payments.google.com/payments/apis-secure/get_legal_document?ldo=0&amp;ldt=googlepaytos&amp;ldl=de</span
											></span
										></u
									></span
								></font
							></font
						></span
					></font
				></span
			></a
		><span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"><span style="background: transparent">.</span></span></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<ol type="A">
		<ol type="I">
			<ol>
				<ol type="a" start="5">
					<li>
						<p
							align="justify"
							style="
								line-height: 120%;
								page-break-inside: auto;
								orphans: 0;
								widows: 0;
								margin-top: 0.24in;
								margin-bottom: 0.04in;
								border: none;
								padding: 0in;
								background: transparent;
								page-break-before: auto;
								page-break-after: avoid;
							"
						>
							<span style="font-variant: normal"
								><font color="#000000"
									><span style="text-decoration: none"
										><font face="Arial"
											><font size="2" style="font-size: 11pt"
												><span style="font-style: normal"
													><b><span style="background: transparent">Sofortüberweisung</span></b></span
												></font
											></font
										></span
									></font
								></span
							>
						</p>
					</li>
				</ol>
			</ol>
		</ol>
	</ol>
	<p style="line-height: 100%; margin-top: 0.19in; margin-bottom: 0.19in">
		<a name="_heading=h.3znysh7"></a>
		Die Bezahlmethode „Sofortüberweisung“ wird abgewickelt von
	</p>
	<p style="line-height: 100%; margin-bottom: 0in"><b>Sofort GmbH</b></p>
	<p style="line-height: 100%; margin-bottom: 0in">Theresienhöhe 12</p>
	<p style="line-height: 100%; margin-bottom: 0in">80339 München, DEUTSCHLAND.</p>
	<p style="line-height: 100%; margin-top: 0.19in; margin-bottom: 0.19in">
		Mit Hilfe des Verfahrens „Sofortüberweisung“ erhalten wir in Echtzeit eine Zahlungsbestätigung von der Sofort GmbH und können
		unverzüglich mit der Erfüllung unserer Verbindlichkeiten beginnen. Für die Durchführung der Transaktion erhält die Sofort GmbH
		Zugriff auf Informationen zu Deinem Girokonto (PIN, TAN, Kontodeckung, Umsätze und Kreditrahmen des Dispokredits).
	</p>
	<p style="line-height: 100%; margin-top: 0.19in; margin-bottom: 0.19in">
		Nach Angaben der Sofort GmbH werden die personenbezogenen Daten nicht gespeichert und auch nicht an Händler weitergeleitet. Weitere
		Informationen findest Du in der Datenschutzerklärung der Sofort GmbH unter
		<a href="https://cdn.klarna.com/1.0/shared/content/legal/terms/de/bt_payment_data_privacy" role="link"
			><font color="#0000ff"><u>https://cdn.klarna.com/1.0/shared/content/legal/terms/de/bt_payment_data_privacy</u></font></a
		>.
	</p>
	<ol type="A">
		<ol type="I">
			<ol>
				<ol type="a" start="6">
					<li>
						<p
							align="justify"
							style="
								line-height: 120%;
								page-break-inside: auto;
								orphans: 0;
								widows: 0;
								margin-top: 0.24in;
								margin-bottom: 0.04in;
								border: none;
								padding: 0in;
								background: transparent;
								page-break-before: auto;
								page-break-after: avoid;
							"
						>
							<span style="font-variant: normal"
								><font color="#000000"
									><span style="text-decoration: none"
										><font face="Arial"
											><font size="2" style="font-size: 11pt"
												><span style="font-style: normal"
													><b><span style="background: transparent">Zahlung vor Ort</span></b></span
												></font
											></font
										></span
									></font
								></span
							>
						</p>
					</li>
				</ol>
			</ol>
		</ol>
	</ol>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Sofern Du deine Bestellung im Store bezahlst, gelten die jeweiligen datenschutzrechtlichen
										Bestimmungen des Store-Betreibers vor Ort.</span
									></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<ol type="A">
		<ol type="I">
			<ol start="4">
				<li>
					<p
						align="justify"
						style="
							line-height: 120%;
							page-break-inside: auto;
							orphans: 0;
							widows: 0;
							margin-top: 0.24in;
							margin-bottom: 0.04in;
							border: none;
							padding: 0in;
							background: transparent;
							page-break-before: auto;
							page-break-after: avoid;
						"
					>
						<span style="font-variant: normal"
							><font color="#000000"
								><span style="text-decoration: none"
									><font face="Arial"
										><font size="2" style="font-size: 11pt"
											><span style="font-style: normal"
												><b><span style="background: transparent">Drittanbieter</span></b></span
											></font
										></font
									></span
								></font
							></span
						>
					</p>
					<ol type="a">
						<li>
							<p
								align="justify"
								style="
									line-height: 120%;
									page-break-inside: auto;
									orphans: 0;
									widows: 0;
									margin-top: 0.24in;
									margin-bottom: 0.04in;
									border: none;
									padding: 0in;
									background: transparent;
									page-break-before: auto;
									page-break-after: avoid;
								"
							>
								<span style="font-variant: normal"
									><font color="#000000"
										><span style="text-decoration: none"
											><font face="Arial"
												><font size="2" style="font-size: 11pt"
													><span style="font-style: normal"
														><b><span style="background: transparent">Lieferdienste </span></b></span
													></font
												></font
											></span
										></font
									></span
								>
							</p>
						</li>
					</ol>
				</li>
			</ol>
		</ol>
	</ol>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Zur Lieferung Deiner Bestellung über den Auswahlpunkt „Lieferung“ arbeiten wir sowohl mit eigenen
										Kurieren als auch mit Lieferdiensten zusammen. Du kannst deine Bestellung auch über die Dienste des
										Anbieters, sofern angegeben, selbst tätigen. Rechtsgrundlage der Datenverarbeitung ist insoweit Art.
										6 Abs. 1 lit. b DSGVO (Verarbeitung zur Erfüllung eines Vertrags).</span
									></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Wir und der jeweilige dean &amp; david-Store bekommen von den unten aufgeführten Lieferdiensten
										folgende personenbezogene Daten übermittelt, die weiterverarbeitet werden:</span
									></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<ul>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent">Vorname (nur bei Self-Delivery)</span></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent">Name (nur bei Self-Delivery)</span></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent">Adresse (nur bei Self-Delivery)</span></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent">Bestelldaten (Artikel + Summe)</span></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
	</ul>
	<ol type="A">
		<ol type="I">
			<ol>
				<ol type="a">
					<ol type="a" start="27">
						<li>
							<p
								align="justify"
								style="
									line-height: 120%;
									page-break-inside: auto;
									orphans: 0;
									widows: 0;
									margin-top: 0.24in;
									margin-bottom: 0.04in;
									border: none;
									padding: 0in;
									background: transparent;
									page-break-before: auto;
									page-break-after: auto;
								"
							>
								<span style="font-variant: normal"
									><font color="#000000"
										><span style="text-decoration: none"
											><font face="Arial"
												><font size="2" style="font-size: 11pt"
													><span style="font-style: normal"
														><b><span style="background: transparent">UberDirect</span></b></span
													></font
												></font
											></span
										></font
									></span
								>
							</p>
						</li>
					</ol>
				</ol>
			</ol>
		</ol>
	</ol>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Wenn du über unsere Webseite bestellst, kann Deine Bestellung (bspw. Deine Foodspot-Bestellung) von
										UberDirect ausgeliefert werden. Verantwortlicher Anbieter für diesen Dienst ist</span
									></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><b><span style="background: transparent">Uber Technologies Inc.</span></b></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent">1455 Market Street, Suite 400</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent">San Francisco, CA 94103, USA.</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			font-variant: normal;
			font-style: normal;
			font-weight: normal;
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			text-decoration: none;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<br />
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Zur Auslieferung Deiner Bestellung teilen wir Uber Technologies Inc. (im Folgenden: Uber) folgende
										personenbezogene Daten mit:</span
									></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<ul>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent"
												>Allgemeine Bestelldaten (Artikel, Bestellnummer)</span
											></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent"
												>Zielort der Auslieferung (Firmenadresse/Foodspot-Adresse und -Name)</span
											></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
	</ul>
	<p
		align="justify"
		style="
			font-variant: normal;
			font-style: normal;
			font-weight: normal;
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-left: 0.5in;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			text-decoration: none;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<br />
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Weitere Informationen findest Du in den Datenschutzbestimmungen von Uber unter
										https://www.uber.com/legal/de/document/?name=privacy-notice&amp;country=germany&amp;lang=de.</span
									></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<ol type="A">
		<ol type="I">
			<ol>
				<ol type="a">
					<ol type="a" start="27">
						<li>
							<p
								align="justify"
								style="
									line-height: 120%;
									page-break-inside: auto;
									orphans: 0;
									widows: 0;
									margin-top: 0.24in;
									margin-bottom: 0.04in;
									border: none;
									padding: 0in;
									background: transparent;
									page-break-before: auto;
									page-break-after: auto;
								"
							>
								<span style="font-variant: normal"
									><font color="#000000"
										><span style="text-decoration: none"
											><font face="Arial"
												><font size="2" style="font-size: 11pt"
													><span style="font-style: normal"
														><b><span style="background: transparent">Uber Eats</span></b></span
													></font
												></font
											></span
										></font
									></span
								>
							</p>
						</li>
					</ol>
				</ol>
			</ol>
		</ol>
	</ol>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Du kannst bei einem dean &amp; david-Store über Uber Eats bestellen. Verantwortlicher Anbieter für
										diesen Dienst ist
									</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><b><span style="background: transparent">Uber Technologies Inc.</span></b></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent">1455 Market Street, Suite 400</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent">San Francisco, CA 94103, USA.</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			font-variant: normal;
			font-style: normal;
			font-weight: normal;
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			text-decoration: none;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<br />
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Bestellungen über UberEats kannst Du z.B. über die Webseite
									</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		><a href="https://www.ubereats.com/" role="link"
			><span style="font-variant: normal"
				><font color="#0000ff"
					><span style="text-decoration: none"
						><font face="Arial"
							><font size="2" style="font-size: 11pt"
								><span style="font-style: normal"
									><u
										><span style="font-weight: normal"
											><span style="background: transparent">https://www.ubereats.com</span></span
										></u
									></span
								></font
							></font
						></span
					></font
				></span
			></a
		><span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent">
										vornehmen. Weitere Informationen findest Du in den Datenschutzbestimmungen von Uber unter
										https://www.uber.com/legal/de/document/?name=privacy-notice&amp;country=germany&amp;lang=de.</span
									></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<ol type="A">
		<ol type="I">
			<ol>
				<ol type="a">
					<ol type="a" start="27">
						<li>
							<p
								align="justify"
								style="
									line-height: 120%;
									page-break-inside: auto;
									orphans: 0;
									widows: 0;
									margin-top: 0.24in;
									margin-bottom: 0.04in;
									border: none;
									padding: 0in;
									background: transparent;
									page-break-before: auto;
									page-break-after: auto;
								"
							>
								<span style="font-variant: normal"
									><font color="#000000"
										><span style="text-decoration: none"
											><font face="Arial"
												><font size="2" style="font-size: 11pt"
													><span style="font-style: normal"
														><b><span style="background: transparent">Lieferando</span></b></span
													></font
												></font
											></span
										></font
									></span
								>
							</p>
						</li>
					</ol>
				</ol>
			</ol>
		</ol>
	</ol>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Du kannst bei einem dean &amp; david-Store über „Lieferando“ bestellen. Verantwortlicher Anbieter
										für diesen Dienst ist</span
									></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent">yd. yourdelivery GmbH</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent">Cuvrystr. 50, 52, 54 / Schlesische Str. 34,</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent">10997 Berlin, DEUTSCHLAND.</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			font-variant: normal;
			font-style: normal;
			font-weight: normal;
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			text-decoration: none;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<br />
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Bestellungen über Lieferando kannst Du z.B. über die Webseite
									</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		><a href="https://www.lieferando.de/" role="link"
			><span style="font-variant: normal"
				><font color="#0000ff"
					><span style="text-decoration: none"
						><font face="Arial"
							><font size="2" style="font-size: 11pt"
								><span style="font-style: normal"
									><u
										><span style="font-weight: normal"
											><span style="background: transparent">https://www.lieferando.de/</span></span
										></u
									></span
								></font
							></font
						></span
					></font
				></span
			></a
		><span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent">
										vornehmen. Weitere Informationen findest Du in den Datenschutzbestimmungen von Lieferando unter
										https://www.lieferando.de/privacy-policy.</span
									></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<ol type="A">
		<ol type="I">
			<ol>
				<ol type="a">
					<ol type="a" start="27">
						<li>
							<p
								align="justify"
								style="
									line-height: 120%;
									page-break-inside: auto;
									orphans: 0;
									widows: 0;
									margin-top: 0.24in;
									margin-bottom: 0.04in;
									border: none;
									padding: 0in;
									background: transparent;
									page-break-before: auto;
									page-break-after: auto;
								"
							>
								<span style="font-variant: normal"
									><font color="#000000"
										><span style="text-decoration: none"
											><font face="Arial"
												><font size="2" style="font-size: 11pt"
													><span style="font-style: normal"
														><b><span style="background: transparent">Wolt</span></b></span
													></font
												></font
											></span
										></font
									></span
								>
							</p>
						</li>
					</ol>
				</ol>
			</ol>
		</ol>
	</ol>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Du kannst bei einem dean &amp; david-Store über Wolt bestellen. Verantwortlicher Anbieter für
										diesen Dienst ist
									</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			font-variant: normal;
			font-style: normal;
			font-weight: normal;
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			text-decoration: none;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<br />
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><b><span style="background: transparent">Wolt Enterprises Deutschland GmbH</span></b></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent">Stralauer Allee 6,</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent">10245 Berlin, DEUTSCHLAND.</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			font-variant: normal;
			font-style: normal;
			font-weight: normal;
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			text-decoration: none;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<br />
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Weitere Informationen findest Du in den Datenschutzbestimmungen von Wolt unter
									</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		><a href="https://explore.wolt.com/de/deu/privacy" role="link"
			><span style="font-variant: normal"
				><font color="#0000ff"
					><span style="text-decoration: none"
						><font face="Arial"
							><font size="2" style="font-size: 11pt"
								><span style="font-style: normal"
									><u
										><span style="font-weight: normal"
											><span style="background: transparent">https://explore.wolt.com/de/deu/privacy</span></span
										></u
									></span
								></font
							></font
						></span
					></font
				></span
			></a
		><span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"><span style="background: transparent">.</span></span></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<ol type="A">
		<ol type="I">
			<ol>
				<ol type="a" start="2">
					<li>
						<p
							align="justify"
							style="
								line-height: 120%;
								page-break-inside: auto;
								orphans: 0;
								widows: 0;
								margin-top: 0.24in;
								margin-bottom: 0.04in;
								border: none;
								padding: 0in;
								background: transparent;
								page-break-before: auto;
								page-break-after: avoid;
							"
						>
							<span style="font-variant: normal"
								><font color="#000000"
									><span style="text-decoration: none"
										><font face="Arial"
											><font size="2" style="font-size: 11pt"
												><span style="font-style: normal"
													><b><span style="background: transparent">MongoDB (Datenbank)</span></b></span
												></font
											></font
										></span
									></font
								></span
							>
						</p>
					</li>
				</ol>
			</ol>
		</ol>
	</ol>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Wir nutzen den Cloud-Dienst MongoDB. Datenschutzrechtlich verantwortlicher Anbieter für diesen
										Dienst ist</span
									></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><b><span style="background: transparent">MongoDB Inc</span></b></span
							></font
						></font
					></span
				></font
			></span
		><span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"><span style="background: transparent">.</span></span></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent">3 Shelbourne Building</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent">Crampton Avenue Ballsbridge</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent">Dublin 4, IRLAND.</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			font-variant: normal;
			font-style: normal;
			font-weight: normal;
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			text-decoration: none;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<br />
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Bei MongoDB Inc. (im Folgenden: MongoDB) speichern wir Daten, die im Zusammenhang mit von uns
										angebotenen Diensten stehen. Hierzu zählen:
									</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<ul>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent"
												>Kundeninformationen (u.a. Vorname, Name, E-Mail, Nutzer-ID, Adresse, Bestätigungsdatum des
												Kontos, Erstellungsdatum des Kontos, letzte Veränderung des Kontos, Geschlecht, letzter
												genutzter Foodspot, Passwort, letzter Login, Geburtstag, Telefonnummer, eigene PromoCodes,
												SocialMediaID (SociaLogin: Facebook, Apple, Google)</span
											></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent"
												>Bestellinformationen (u.a. bestellte Artikel, Adresse, Bestellsumme, Trinkgeld, zusätzliche
												Notizen in der Bestellung, Lieferzeit, Bestellzeit, Zahlungsart, Order-Channel (Web, SOT,
												Wolt, Uber etc.), Venue, genutztes SOT (falls SOT Bestellung), Gerät, Bestellnummer,
												Kassenquittung, Abholzeit, Lieferzeit, PromoCode, Arbeitnehmerzuschuss (nur Foodspot),
												Store-Discount (nur Foodspot), Kundendaten (Vorname, Name, E-Mail, Telefon, Adresse),
											</span></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent"
												>Zahlungsinformationen (Zahlungsart, Bestellsumme, Trinkgeld, IP-Adresse, Währung,
												Beleginformationen (Name + Adresse)</span
											></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
	</ul>
	<p
		align="justify"
		style="
			font-variant: normal;
			font-style: normal;
			font-weight: normal;
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-left: 0.64in;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			text-decoration: none;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<br />
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Mit MongoDB Inc. wurde ein Auftragsverarbeitungsvertrag nach Art. 28 DSGVO geschlossen. Weitere
										Informationen findest Du in den Datenschutzhinweisen von MongoDB unter
									</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		><a href="https://www.mongodb.com/legal/privacy-policy?tid=132613636" role="link"
			><span style="font-variant: normal"
				><font color="#0000ff"
					><span style="text-decoration: none"
						><font face="Arial"
							><font size="2" style="font-size: 11pt"
								><span style="font-style: normal"
									><u
										><span style="font-weight: normal"
											><span style="background: transparent"
												>https://www.mongodb.com/legal/privacy-policy?tid=132613636</span
											></span
										></u
									></span
								></font
							></font
						></span
					></font
				></span
			></a
		><span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"><span style="background: transparent">.</span></span></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<ol type="A">
		<ol type="I">
			<ol>
				<ol type="a" start="3">
					<li>
						<p
							align="justify"
							style="
								line-height: 120%;
								page-break-inside: auto;
								orphans: 0;
								widows: 0;
								margin-top: 0.24in;
								margin-bottom: 0.04in;
								border: none;
								padding: 0in;
								background: transparent;
								page-break-before: auto;
								page-break-after: avoid;
							"
						>
							<span style="font-variant: normal"
								><font color="#000000"
									><span style="text-decoration: none"
										><font face="Arial"
											><font size="2" style="font-size: 11pt"
												><span style="font-style: normal"
													><b><span style="background: transparent">Google Cloud </span></b></span
												></font
											></font
										></span
									></font
								></span
							>
						</p>
					</li>
				</ol>
			</ol>
		</ol>
	</ol>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Wir nutzen Google Cloud, einen Cloud-Dienst zur Online-Speicherung von Daten. Datenschutzrechtlich
										verantwortlicher Anbieter für diesen Dienst ist</span
									></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><b><span style="background: transparent">Google Ireland Limited</span></b></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent">Gordon House, Barrow Street</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent">Dublin 4, IRLAND.</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Wir speichern bei Google Cloud Daten, die im Zusammenhang mit von uns angebotenen Diensten stehen.
									</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"><span style="background: transparent">Hierzu zählen:</span></span></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<ul>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent">Die bei MongoDB gespeicherten Daten (s.o.).</span></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent">Betriebssystem</span></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"><span style="background: transparent">Browser</span></span></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent">Referrer-URL</span></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"><span style="background: transparent">URL</span></span></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent">IP-Adresse</span></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent">Status-Code</span></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"><span style="background: transparent">Land</span></span></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent">Protokoll</span></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
	</ul>
	<p
		align="justify"
		style="
			font-variant: normal;
			font-style: normal;
			font-weight: normal;
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-left: 0.5in;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			text-decoration: none;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<br />
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Mit Google Ireland Limited (im Folgenden: Google) wurde ein Auftragsverarbeitungsvertrag gem. Art.
										28 DSGVO geschlossen. Die Auftragsverarbeitungsbedingungen von Google kannst Du unter
									</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		><a href="https://business.safety.google/intl/de/adsprocessorterms/" role="link"
			><span style="font-variant: normal"
				><font color="#0000ff"
					><span style="text-decoration: none"
						><font face="Arial"
							><font size="2" style="font-size: 11pt"
								><span style="font-style: normal"
									><u
										><span style="font-weight: normal"
											><span style="background: transparent"
												>https://business.safety.google/intl/de/adsprocessorterms/</span
											></span
										></u
									></span
								></font
							></font
						></span
					></font
				></span
			></a
		><span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"><span style="background: transparent"> einsehen.</span></span></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Weitere Informationen findest Du in den Datenschutzbestimmungen von Google
									</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		><a href="https://business.safety.google/privacy/?hl=en" role="link"
			><span style="font-variant: normal"
				><font color="#0000ff"
					><span style="text-decoration: none"
						><font face="Arial"
							><font size="2" style="font-size: 11pt"
								><span style="font-style: normal"
									><u
										><span style="font-weight: normal"
											><span style="background: transparent"
												>https://business.safety.google/privacy/?hl=en</span
											></span
										></u
									></span
								></font
							></font
						></span
					></font
				></span
			></a
		><span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"><span style="background: transparent">.</span></span></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<ol type="A">
		<ol type="I">
			<ol>
				<ol type="a" start="4">
					<li>
						<p
							align="justify"
							style="
								line-height: 120%;
								page-break-inside: auto;
								orphans: 0;
								widows: 0;
								margin-top: 0.24in;
								margin-bottom: 0.04in;
								border: none;
								padding: 0in;
								background: transparent;
								page-break-before: auto;
								page-break-after: avoid;
							"
						>
							<span style="font-variant: normal"
								><font color="#000000"
									><span style="text-decoration: none"
										><font face="Arial"
											><font size="2" style="font-size: 11pt"
												><span style="font-style: normal"
													><b><span style="background: transparent">LinaPOS</span></b></span
												></font
											></font
										></span
									></font
								></span
							>
						</p>
					</li>
				</ol>
			</ol>
		</ol>
	</ol>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Bei unseren dean &amp; david-Stores wird das Kassensystem LinaPOS genutzt. Datenschutzrechtlich
										verantwortlicher Anbieter für diesen Dienst ist</span
									></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent">Varyon Deutschland GmbH</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent">Walter-Rathenau-Straße 13</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent">75203 Königsbach-Stein, DEUTSCHLAND.</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			font-variant: normal;
			font-style: normal;
			font-weight: normal;
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			text-decoration: none;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<br />
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Um Deine Bestellung abwickeln zu können, werden folgende personenbezogene Daten an das Kassensystem
										LinaPOS weitergeleitet:</span
									></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<ul>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"><span style="background: transparent">Artikel</span></span></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"><span style="background: transparent">Summe</span></span></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent"
												>Order-Channel (Web, Self-Order-Terminal, Wolt, Uber etc.)</span
											></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent">Bestellnotizen</span></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
		<li>
			<p
				align="justify"
				style="
					line-height: 120%;
					page-break-inside: auto;
					orphans: 0;
					widows: 0;
					margin-bottom: 0in;
					border: none;
					padding: 0in;
					background: transparent;
					page-break-before: auto;
					page-break-after: auto;
				"
			>
				<span style="font-variant: normal"
					><font color="#000000"
						><span style="text-decoration: none"
							><font face="Arial"
								><font size="2" style="font-size: 11pt"
									><span style="font-style: normal"
										><span style="font-weight: normal"
											><span style="background: transparent">Bestellart</span></span
										></span
									></font
								></font
							></span
						></font
					></span
				>
			</p>
		</li>
	</ul>
	<p
		align="justify"
		style="
			font-variant: normal;
			font-style: normal;
			font-weight: normal;
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			text-decoration: none;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<br />
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			margin-bottom: 0in;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Mit Varyon Deutschland GmbH wurde ein Auftragsverarbeitungsvertrag nach Art. 28 DSGVO geschlossen.<!-- Vermutung (zwischen FN und Varyon) --></span
									></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<ol type="A">
		<ol type="I" start="2">
			<li>
				<p
					align="justify"
					style="
						line-height: 120%;
						page-break-inside: auto;
						orphans: 0;
						widows: 0;
						margin-top: 0.25in;
						margin-bottom: 0.07in;
						border: none;
						padding: 0in;
						background: transparent;
						page-break-before: auto;
						page-break-after: avoid;
					"
				>
					<span style="font-variant: normal"
						><font color="#000000"
							><span style="text-decoration: none"
								><font face="Arial"
									><font size="2" style="font-size: 11pt"
										><span style="font-style: normal"
											><b><span style="background: transparent">Datenübermittlung in Drittländer</span></b></span
										></font
									></font
								></span
							></font
						></span
					>
				</p>
			</li>
		</ol>
	</ol>
	<p>
		Wir verarbeiten Deine personenbezogenen Daten gewöhnlich in einem Mitgliedsstaat der europäischen Union oder einem anderen
		Vertragsstaat des Abkommens über den europäischen Vertragsraum (Beschluss 94/1/EG). Sofern Daten an Dienstleister mit Sitz außerhalb
		der EU bzw. des EWR übermittelt werden, liegt für die betreffenden Staaten (aktuell: USA), sofern nicht anders angegeben, ein
		Angemessenheitsbeschluss gem. Art. 45 DSGVO vor, der ein den Vorgaben der DSGVO entsprechendes Datenschutzniveau gewährleistet und
		eine Datenübermittlung ohne besondere Genehmigung erlaubt.<font size="2" style="font-size: 10pt"> </font>Soweit nicht anders
		angegeben, sind Dienstleister mit Sitz in den USA nach dem geltenden EU-US Data Privacy Framework zertifiziert.
	</p>
	<p>
		Die weitere Datenverarbeitung durch externe Dienstleister liegt nicht in unserem Einflussbereich.<b> </b>Deine Daten können in
		Drittländern verarbeitet werden, die datenschutzrechtlich nicht das gleiche Schutzniveau garantieren wie innerhalb der EU.
		Einzelheiten kannst Du den jeweiligen Datenschutzerklärungen des Dienstleisters entnehmen, die wir entsprechend verlinkt haben.
	</p>
	<ol type="A">
		<ol type="I" start="3">
			<li>
				<p
					align="justify"
					style="
						line-height: 120%;
						page-break-inside: auto;
						orphans: 0;
						widows: 0;
						margin-top: 0.25in;
						margin-bottom: 0.07in;
						border: none;
						padding: 0in;
						background: transparent;
						page-break-before: auto;
						page-break-after: avoid;
					"
				>
					<span style="font-variant: normal"
						><font color="#000000"
							><span style="text-decoration: none"
								><font face="Arial"
									><font size="2" style="font-size: 11pt"
										><span style="font-style: normal"
											><b><span style="background: transparent">Dauer der Datenspeicherung</span></b></span
										></font
									></font
								></span
							></font
						></span
					>
				</p>
			</li>
		</ol>
	</ol>
	<p>
		Wir verarbeiten und speichern Deine personenbezogenen Daten grundsätzlich nur für die Dauer, für die der jeweilige Nutzungszweck
		eine entsprechende Speicherung erfordert. Das schließt ggf. auch die Zeiträume der Anbahnung eines Vertrages und der Abwicklung
		eines Vertrages mit ein. Hast Du uns für eine bestimmte Datenverarbeitung Deine Einwilligung erteilt, speichern wir die betreffenden
		Daten, solange die Einwilligung fortbesteht. Einzelheiten über die Dauer der Speicherung Deiner personenbezogenen Daten bei
		Drittanbietern kannst Du der Datenschutzerklärung des datenschutzrechtlich verantwortlichen Dienstleisters entnehmen. Diese haben
		wir an entsprechender Stelle verlinkt.
	</p>
	<p>
		Hat sich der Nutzungszweck erledigt oder hast Du deine Einwilligung widerrufen, löschen wir Deine personenbezogenen Daten
		unverzüglich, sofern uns nicht gesetzliche Aufbewahrungsfristen zu einer längeren Speicherung zwingen.
	</p>
	<ol type="A">
		<ol type="I" start="4">
			<li>
				<p
					align="justify"
					style="
						line-height: 120%;
						page-break-inside: auto;
						orphans: 0;
						widows: 0;
						margin-top: 0.25in;
						margin-bottom: 0.07in;
						border: none;
						padding: 0in;
						background: transparent;
						page-break-before: auto;
						page-break-after: avoid;
					"
				>
					<span style="font-variant: normal"
						><font color="#000000"
							><span style="text-decoration: none"
								><font face="Arial"
									><font size="2" style="font-size: 11pt"
										><span style="font-style: normal"
											><b
												><span style="background: transparent"
													>Deine Rechte als betroffene Person<!-- (P) Gemeinsame Verantwortlichkeit? --></span
												></b
											></span
										></font
									></font
								></span
							></font
						></span
					>
				</p>
			</li>
		</ol>
	</ol>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Als betroffene Person (Art. 4 Nr. 1 DSGVO) stehen Dir hinsichtlich Deiner personenbezogenen Daten
										unter den gesetzlichen Voraussetzungen die nachfolgenden Rechte zu:</span
									></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<ol type="A">
		<ol type="I">
			<ol>
				<li>
					<p
						align="justify"
						style="
							line-height: 120%;
							page-break-inside: auto;
							orphans: 0;
							widows: 0;
							margin-top: 0.24in;
							margin-bottom: 0.04in;
							border: none;
							padding: 0in;
							background: transparent;
							page-break-before: auto;
							page-break-after: avoid;
						"
					>
						<span style="font-variant: normal"
							><font color="#000000"
								><span style="text-decoration: none"
									><font face="Arial"
										><font size="2" style="font-size: 11pt"
											><span style="font-style: normal"
												><b><span style="background: transparent">Auskunftsrecht </span></b></span
											></font
										></font
									></span
								></font
							></span
						>
					</p>
				</li>
			</ol>
		</ol>
	</ol>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Du bist jederzeit berechtigt, im Rahmen von Art. 15 DSGVO von uns eine Bestätigung darüber zu
										verlangen, ob wir Dich betreffende personenbezogene Daten verarbeiten. Ist dies der Fall, bist Du im
										Rahmen von Art. 15 DSGVO ferner berechtigt, Auskunft über diese personenbezogenen Daten sowie
										bestimmte weitere Informationen (u.a. Verarbeitungszwecke, Kategorien personenbezogener Daten,
										Kategorien von Empfängern, geplante Speicherdauer, die Herkunft der Daten, den Einsatz einer
										automatisierten Entscheidungsfindung und im Fall des Drittlandtransfers die geeigneten Garantien)
										und eine Kopie Deiner Daten zu erhalten. Es gelten die Einschränkungen des § 34 BDSG.</span
									></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<ol type="A">
		<ol type="I">
			<ol start="2">
				<li>
					<p
						align="justify"
						style="
							line-height: 120%;
							page-break-inside: auto;
							orphans: 0;
							widows: 0;
							margin-top: 0.24in;
							margin-bottom: 0.04in;
							border: none;
							padding: 0in;
							background: transparent;
							page-break-before: auto;
							page-break-after: avoid;
						"
					>
						<span style="font-variant: normal"
							><font color="#000000"
								><span style="text-decoration: none"
									><font face="Arial"
										><font size="2" style="font-size: 11pt"
											><span style="font-style: normal"
												><b><span style="background: transparent">Recht auf Berichtigung</span></b></span
											></font
										></font
									></span
								></font
							></span
						>
					</p>
				</li>
			</ol>
		</ol>
	</ol>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Du bist berechtigt, nach Art. 16 DSGVO von uns zu verlangen, dass wir die über Dich gespeicherten
										personenbezogenen Daten berichtigen, wenn diese unzutreffend oder fehlerhaft sind.</span
									></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<ol type="A">
		<ol type="I">
			<ol start="3">
				<li>
					<p
						align="justify"
						style="
							line-height: 120%;
							page-break-inside: auto;
							orphans: 0;
							widows: 0;
							margin-top: 0.24in;
							margin-bottom: 0.04in;
							border: none;
							padding: 0in;
							background: transparent;
							page-break-before: auto;
							page-break-after: avoid;
						"
					>
						<span style="font-variant: normal"
							><font color="#000000"
								><span style="text-decoration: none"
									><font face="Arial"
										><font size="2" style="font-size: 11pt"
											><span style="font-style: normal"
												><b><span style="background: transparent">Recht auf Löschung</span></b></span
											></font
										></font
									></span
								></font
							></span
						>
					</p>
				</li>
			</ol>
		</ol>
	</ol>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Du bist berechtigt, unter den Voraussetzungen von Art. 17 DSGVO von uns zu verlangen, dass wir Dich
										betreffende personenbezogene Daten unverzüglich löschen. Das Recht auf Löschung besteht u.a. nicht,
										wenn die Verarbeitung der personenbezogenen Daten erforderlich ist z.B. zur Erfüllung einer
										rechtlichen Verpflichtung (z.B. gesetzliche Aufbewahrungspflichten) oder zur Geltendmachung,
										Ausübung oder Verteidigung von Rechtsansprüchen. Darüber hinaus gelten die Einschränkungen des § 35
										BDSG.</span
									></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<ol type="A">
		<ol type="I">
			<ol start="4">
				<li>
					<p
						align="justify"
						style="
							line-height: 120%;
							page-break-inside: auto;
							orphans: 0;
							widows: 0;
							margin-top: 0.24in;
							margin-bottom: 0.04in;
							border: none;
							padding: 0in;
							background: transparent;
							page-break-before: auto;
							page-break-after: avoid;
						"
					>
						<span style="font-variant: normal"
							><font color="#000000"
								><span style="text-decoration: none"
									><font face="Arial"
										><font size="2" style="font-size: 11pt"
											><span style="font-style: normal"
												><b
													><span style="background: transparent"
														>Recht auf Einschränkung der Verarbeitung</span
													></b
												></span
											></font
										></font
									></span
								></font
							></span
						>
					</p>
				</li>
			</ol>
		</ol>
	</ol>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Du bist berechtigt, unter den Voraussetzungen von Art. 18 DSGVO von uns zu verlangen, dass wir die
										Verarbeitung Deiner personenbezogenen Daten einschränken.</span
									></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<ol type="A">
		<ol type="I">
			<ol start="5">
				<li>
					<p
						align="justify"
						style="
							line-height: 120%;
							page-break-inside: auto;
							orphans: 0;
							widows: 0;
							margin-top: 0.24in;
							margin-bottom: 0.04in;
							border: none;
							padding: 0in;
							background: transparent;
							page-break-before: auto;
							page-break-after: avoid;
						"
					>
						<span style="font-variant: normal"
							><font color="#000000"
								><span style="text-decoration: none"
									><font face="Arial"
										><font size="2" style="font-size: 11pt"
											><span style="font-style: normal"
												><b><span style="background: transparent">Recht auf Datenübertragbarkeit</span></b></span
											></font
										></font
									></span
								></font
							></span
						>
					</p>
				</li>
			</ol>
		</ol>
	</ol>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Du bist berechtigt, unter den Voraussetzungen von Art. 20 DSGVO von uns zu verlangen, dass wir Dir
										die Dich betreffenden personenbezogenen Daten, die Du uns bereitgestellt hast, in einem
										strukturierten, gängigen und maschinenlesbaren Format übergeben.</span
									></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<ol type="A">
		<ol type="I">
			<ol start="6">
				<li>
					<p
						align="justify"
						style="
							line-height: 120%;
							page-break-inside: auto;
							orphans: 0;
							widows: 0;
							margin-top: 0.24in;
							margin-bottom: 0.04in;
							border: none;
							padding: 0in;
							background: transparent;
							page-break-before: auto;
							page-break-after: avoid;
						"
					>
						<span style="font-variant: normal"
							><font color="#000000"
								><span style="text-decoration: none"
									><font face="Arial"
										><font size="2" style="font-size: 11pt"
											><span style="font-style: normal"
												><b
													><span style="background: transparent"
														>Widerrufsrecht für erteilte Einwilligungen</span
													></b
												></span
											></font
										></font
									></span
								></font
							></span
						>
					</p>
				</li>
			</ol>
		</ol>
	</ol>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Eine erteilte Einwilligung in die Verarbeitung personenbezogener Daten kannst Du jederzeit uns
										gegenüber widerrufen. Bitte beachte, dass der Widerruf erst für die Zukunft wirkt. Verarbeitungen,
										die vor dem Widerruf erfolgt sind, sind davon nicht betroffen.
									</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Zur Erklärung des Widerrufs reicht eine formlose Mitteilung z.B. per E-Mail an
										datenschutz&#64;deananddavid.com.</span
									></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<ol type="A">
		<ol type="I">
			<ol start="7">
				<li>
					<p
						align="justify"
						style="
							line-height: 120%;
							page-break-inside: auto;
							orphans: 0;
							widows: 0;
							margin-top: 0.24in;
							margin-bottom: 0.04in;
							border: none;
							padding: 0in;
							background: transparent;
							page-break-before: auto;
							page-break-after: avoid;
						"
					>
						<span style="font-variant: normal"
							><font color="#000000"
								><span style="text-decoration: none"
									><font face="Arial"
										><font size="2" style="font-size: 11pt"
											><span style="font-style: normal"
												><b
													><span style="background: transparent"
														>Widerspruchsrecht gegen Datenverarbeitung aufgrund berechtigten Interesses</span
													></b
												></span
											></font
										></font
									></span
								></font
							></span
						>
					</p>
				</li>
			</ol>
		</ol>
	</ol>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Du bist berechtigt, unter den Voraussetzungen von Art. 21 DSGVO Widerspruch jederzeit gegen die
										Verarbeitung Deiner Daten, die aufgrund von Art. 6 Abs. 1 S. 1 lit. f DSGVO (Datenverarbeitung auf
										der Grundlage einer Interessenabwägung) erfolgt, Widerspruch einzulegen, wenn dafür Gründe
										vorliegen, die sich aus Deiner besonderen Situation ergeben.</span
									></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Legst Du Widerspruch ein, werden wir Deine personenbezogenen Daten nicht mehr verarbeiten, es sei
										denn, wir können zwingende schutzwürdige Gründe für die Verarbeitung nachweisen, die Deine
										Interessen, Rechte und Freiheiten überwiegen, oder die Verarbeitung dient der Geltendmachung,
										Ausübung oder Verteidigung von Rechtsansprüchen.</span
									></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Zur Erhebung des Widerrufs reicht eine formlose Mitteilung z.B. per E-Mail an
									</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		><a href="mailto:datenschutz&#64;deananddavid.com" role="link"
			><span style="font-variant: normal"
				><font color="#0000ff"
					><span style="text-decoration: none"
						><font face="Arial"
							><font size="2" style="font-size: 11pt"
								><span style="font-style: normal"
									><u
										><span style="font-weight: normal"
											><span style="background: transparent">datenschutz&#64;deananddavid.com</span></span
										></u
									></span
								></font
							></font
						></span
					></font
				></span
			></a
		><span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"><span style="background: transparent">.</span></span></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<ol type="A">
		<ol type="I">
			<ol start="8">
				<li>
					<p
						align="justify"
						style="
							line-height: 120%;
							page-break-inside: auto;
							orphans: 0;
							widows: 0;
							margin-top: 0.24in;
							margin-bottom: 0.04in;
							border: none;
							padding: 0in;
							background: transparent;
							page-break-before: auto;
							page-break-after: avoid;
						"
					>
						<span style="font-variant: normal"
							><font color="#000000"
								><span style="text-decoration: none"
									><font face="Arial"
										><font size="2" style="font-size: 11pt"
											><span style="font-style: normal"
												><b
													><span style="background: transparent"
														>Beschwerderecht bei einer Aufsichtsbehörde</span
													></b
												></span
											></font
										></font
									></span
								></font
							></span
						>
					</p>
				</li>
			</ol>
		</ol>
	</ol>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Unter den Voraussetzungen von Art. 77 DSGVO steht Dir ein Beschwerderecht bei einer zuständigen
										Aufsichtsbehörde zu. Insbesondere kannst Du sich mit einer Beschwerde an die für uns zuständige
										Aufsichtsbehörde wenden, das Bayerisches Landesamt für Datenschutzaufsicht (BayLDA), Tel. +49 (0)
										981 180093-0, E-Mail: poststelle&#64;lda.bayern.de.
									</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<ol type="A">
		<ol type="I">
			<ol start="9">
				<li>
					<p
						align="justify"
						style="
							line-height: 120%;
							page-break-inside: auto;
							orphans: 0;
							widows: 0;
							margin-top: 0.24in;
							margin-bottom: 0.04in;
							border: none;
							padding: 0in;
							background: transparent;
							page-break-before: auto;
							page-break-after: avoid;
						"
					>
						<span style="font-variant: normal"
							><font color="#000000"
								><span style="text-decoration: none"
									><font face="Arial"
										><font size="2" style="font-size: 11pt"
											><span style="font-style: normal"
												><b><span style="background: transparent">Sonstige Anliegen</span></b></span
											></font
										></font
									></span
								></font
							></span
						>
					</p>
				</li>
			</ol>
		</ol>
	</ol>
	<p
		align="justify"
		style="
			line-height: 120%;
			page-break-inside: auto;
			orphans: 0;
			widows: 0;
			border: none;
			padding: 0in;
			background: transparent;
			page-break-before: auto;
			page-break-after: auto;
		"
	>
		<span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"
										>Für weitergehende Datenschutzfragen und -anliegen steht Dir unser Datenschutzbeauftragter zur
										Verfügung. Entsprechende Anfragen sowie die Ausübung Deiner vorstehenden Rechte sollten nach
										Möglichkeit per E-Mail an
									</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		><a href="mailto:datenschutz&#64;deananddavid.com"
			><span style="font-variant: normal"
				><font color="#0000ff"
					><span style="text-decoration: none"
						><font face="Arial"
							><font size="2" style="font-size: 11pt"
								><span style="font-style: normal"
									><u
										><span style="font-weight: normal"
											><span style="background: transparent">datenschutz&#64;deananddavid.com</span></span
										></u
									></span
								></font
							></font
						></span
					></font
				></span
			></a
		><span style="font-variant: normal"
			><font color="#000000"
				><span style="text-decoration: none"
					><font face="Arial"
						><font size="2" style="font-size: 11pt"
							><span style="font-style: normal"
								><span style="font-weight: normal"
									><span style="background: transparent"> geschickt werden.</span></span
								></span
							></font
						></font
					></span
				></font
			></span
		>
	</p>
	<div title="footer" role="region" aria-label="Footer section">
		<p
			align="right"
			style="
				line-height: 100%;
				page-break-inside: auto;
				orphans: 0;
				widows: 0;
				margin-top: 0.26in;
				border: none;
				padding: 0in;
				background: transparent;
				page-break-before: auto;
				page-break-after: auto;
			"
		>
			<span style="background: #c0c0c0"><span type="PAGE" subtype="RANDOM" format="PAGE">27</span></span>
		</p>
		<p
			align="justify"
			style="
				font-variant: normal;
				font-style: normal;
				font-weight: normal;
				line-height: 100%;
				page-break-inside: auto;
				orphans: 0;
				widows: 0;
				border: none;
				padding: 0in;
				background: transparent;
				text-decoration: none;
				page-break-before: auto;
				page-break-after: auto;
			"
		>
			<br />
			<br />
		</p>
	</div>
</ion-content>
